export default {
  "common": {
    "language": "言語",
    "file_size_limit_named": "ファイル「{name}」は{size}を超えることはできません",
    "file_size_limit": "ファイルは{size}を超えることはできません",
    "language_switch_success": "言語の切り替えに成功しました",
    "language_switch_failed": "言語の切り替えに失敗しました。再度お試しください",
    "back_top": "トップに戻る",
    "contact_now": "お問い合わせ",
    "submit": "送信",
    "reset": "リセット",
    "cancel": "キャンセル",
    "confirm": "確認",
    "yes": "はい",
    "em_dash": "—",
    "delete": "削除",
    "download": "ダウンロード",
    "click_download": "ダウンロード",
    "click_upload": "アップロード",
    "design": "設計",
    "status": "ステータス",
    "designed": "設計済み",
    "not_designed": "未設計",
    "to_be_designed": "設計予定",
    "prompt": "ヒント",
    "confirm_permanently_delete_project_continue": "このプロジェクトを完全に削除します。続行しますか？",
    "delete_success": "削除に成功しました！",
    "delete_failed": "削除に失敗しました！",
    "delete_canceled": "削除をキャンセルしました",
    "add_success": "追加成功！",
    "serial_number": "番号",
    "name": "名前",
    "operations": "操作",
    "required": "必須",
    "optional": "任意",
    "back_to_list": "戻る",
    "close": "閉じる",
    "create": "作成",
    "click_to_upload": "クリックしてアップロード",
    "no_selection": "選択なし",
    "confirm_close": "閉じますか？",
    "please_select_file": "ファイルを選択してください",
    "no_data": "表示するデータがありません",
    "please_select": "選択してください",
    "please_select_image": "画像を選択してください",
    "please_select_gdt_file": "gdtファイルを選択してください",
    "please_select_days_to_purchase": "購入日数を選択してください！",
    "not_uploaded": "未アップロード",
    "uploaded": "アップロード済み",
    "image_not_designed_or_failed": "画像が未設計、または設計に失敗しました",
    "edit": "編集",
    "process_json_error": "JSONデータの処理エラー",
    "no_related_projects": "関連するプロジェクトはありません",
    "no_related_project_ids": "関連するプロジェクトID情報がありません",
    "download_failed": "ダウンロードに失敗しました",
    "video_badge": "動画"
  },
  "wallet": {
    "back_to_home": "ホームに戻る",
    "available_balance": "現在利用可能ポイント",
    "monthly_points_label": "月間ポイント",
    "permanent_points_label": "永久ポイント",
    "coin_unit": "pt",
    "refresh_balance": "残高を更新",
    "go_recharge": "チャージへ",
    "plan_monthly_badge": "月額",
    "coin_plan_title": "ポイント残高",
    "coin_plan_subtitle": "月間ポイントと永久ポイントの概要",
    "total_coins_label": "合計ポイント",
    "current_coins_label": "利用可能ポイント",
    "used_coins_label": "使用済ポイント",
    "plan_period_label": "プラン有効期間",
    "start_at_label": "開始",
    "end_at_label": "終了",
    "plan_detail_button": "残高の詳細を見る",
    "recent_transactions_title": "最近のポイント取引記録",
    "recent_transactions_desc": "直近30日間の最新ポイント変動状況",
    "refresh": "更新",
    "view_all": "すべて表示",
    "loading_transactions": "取引記録を読み込み中...",
    "no_recent_transactions": "最近のポイント取引記録はありません",
    "transaction_tab": "ポイント取引記録",
    "orders_tab": "チャージ注文",
    "filter_type_placeholder": "取引タイプ",
    "range_separator": "〜",
    "start_time_placeholder": "開始時間",
    "end_time_placeholder": "終了時間",
    "ref_id_placeholder": "冪等キー",
    "filter_apply": "フィルター",
    "filter_reset": "リセット",
    "filter_export": "請求書をエクスポート",
    "no_transactions": "ポイント取引記録がありません",
    "balance_after_prefix": "残高",
    "prev_page": "前へ",
    "page_indicator": "{current} / {total} ページ",
    "next_page": "次へ",
    "order_status_placeholder": "注文ステータス",
    "loading_orders": "注文を読み込み中...",
    "no_orders": "チャージ注文はまだありません",
    "order_id_prefix": "注文番号:",
    "order_desc_topup": "チャージ注文",
    "order_desc_consume": "消費注文",
    "order_desc_monthly_standard": "月額サブスクリプション注文",
    "order_desc_subscription_renewal": "月初自動引き落とし",
    "order_desc_refund": "返金注文",
    "payment_amount_prefix": "支払金額 : ",
    "view_detail": "詳細を見る",
    "order_detail_title": "注文詳細",
    "detail_loading": "詳細を読み込み中...",
    "my_favorite": "お気に入り",
    "new_user_notice": "AI real CG をご利用いただくにはサブスクリプションの開始が必要です。下の「サブスクリプション」から開始すると、すぐにご利用いただけます。",
    "loading_favorites": "お気に入りを読み込み中...",
    "no_favorites": "お気に入りの画像がありません",
    "fetch_favorites_failed": "お気に入りの画像の取得に失敗しました",
    "order_id_label": "注文番号",
    "status_label": "注文ステータス",
    "order_type_label": "注文タイプ",
    "expected_coins_label": "入金予定ポイント",
    "paid_amount_label": "支払金額",
    "payment_channel_label": "支払チャネル",
    "idempotency_key_label": "冪等キー",
    "created_at_label": "作成日時",
    "updated_at_label": "更新日時",
    "paid_at_label": "支払日時",
    "detail_empty": "注文詳細を取得できませんでした",
    "applying_invoice": "申請中...",
    "apply_invoice": "請求書を申請",
    "view_related_transactions": "関連取引を見る",
    "need_login": "ウォレットを表示するにはログインしてください",
    "fetch_wallet_failed": "ウォレット情報の取得に失敗しました",
    "fetch_transactions_failed": "利用可能画像の取引の取得に失敗しました",
    "fetch_orders_failed": "注文の取得に失敗しました",
    "apply_invoice_todo": "請求書申請機能は準備中です",
    "invoice_download_success": "請求書のダウンロードを開始しました",
    "invoice_not_paid": "支払い成功した注文のみ請求書を取得できます",
    "invoice_missing_key": "注文の冪等キーがありません。請求書をダウンロードできません",
    "invoice_download_failed": "請求書のダウンロードに失敗しました。しばらくしてから再試行してください",
    "transaction_desc_topup": "利用可能画像チャージ",
    "transaction_desc_consume": "利用可能画像の消費",
    "transaction_desc_adjustment": "システム調整",
    "transaction_desc_project_consume": "プロジェクトポイント消費",
    "transaction_desc_design_failed_refund": "プロジェクトデザイン失敗返金ポイント",
    "transaction_desc_monthly_points_issued": "月次ポイント付与",
    "transaction_desc_expired_points_deducted": "期限切れ月次ポイント差し引き",
    "transaction_desc_admin_deduct_monthly": "管理者による月次ポイント差し引き",
    "transaction_desc_admin_issue_monthly": "管理者による月次ポイント付与",
    "transaction_desc_admin_deduct_permanent": "管理者による永久ポイント差し引き",
    "transaction_desc_admin_issue_permanent": "管理者による永久ポイント付与",
    "transaction_desc_register_bonus": "登録ボーナスポイント",
    "transaction_desc_campaign_code": "キャンペーンコード交換",
    "transaction_type_all": "すべてのタイプ",
    "transaction_type_topup": "チャージ",
    "transaction_type_consume": "消費",
    "transaction_type_adjust": "調整",
    "order_status_all": "すべてのステータス",
    "order_status_init": "支払待ち",
    "order_status_processing": "処理中",
    "order_status_success": "支払成功",
    "order_status_failed": "支払失敗",
    "order_status_cancelled": "キャンセル",
    "shortcut_7_days": "過去7日間",
    "shortcut_30_days": "過去30日間",
    "shortcut_90_days": "過去90日間",
    "export_bill_todo": "明細のエクスポート機能は準備中です",
    "fetch_order_detail_failed": "注文詳細の取得に失敗しました",
    "order_type_topup": "チャージ注文",
    "order_type_consume": "アルゴリズム課金",
    "order_type_refund": "返金",
    "usage_quota_title": "AI real CG利用可能回数",
    "usage_quota_loading": "読み込み中...",
    "usage_quota_image_label": "画像生成",
    "usage_quota_video_label": "動画生成",
    "usage_quota_upscale_label": "高解像度化ダウンロード",
    "usage_quota_unlimited": "無制限",
    "usage_quota_footnote": "週次の利用回数は毎週月曜 0:00（日本時間）にリセットされます。",
    "registration_trial_expiry_label": "登録体験の有効期限：",
    "subscription_status_label": "サブスクリプション状態：",
    "subscription_status_active": "サブスクリプション中",
    "subscription_status_inactive": "未サブスクリプション",
    "subscription_status_cancelled": "サブスクリプションキャンセル済み",
    "subscription_status_active_cancelled": "更新キャンセル済み",
    "subscription_button_subscribe": "サブスクリプション",
    "subscription_button_unsubscribe": "サブスクリプションをキャンセル",
    "subscription_button_processing": "処理中...",
    "subscription_end_time_label": "サブスクリプション終了時間：",
    "subscription_next_billing_label": "次回請求時間：",
    "subscription_confirm_subscribe_message": "月額プランにサブスクリプションしますか？",
    "subscription_confirm_unsubscribe_message1": "サブスクリプションを停止しますか？",
    "subscription_confirm_unsubscribe_message2": "※停止後も有効期間終了までに利用できます。",
    "subscription_confirm_title": "確認",
    "subscription_redirecting_to_pay": "決済ページにリダイレクトしています...",
    "subscription_redirecting_to_process": "処理ページにリダイレクトしています...",
    "subscription_subscribe_success": "サブスクリプション成功",
    "subscription_unsubscribe_request_submitted": "キャンセルリクエストを送信しました",
    "subscription_subscribe_failed": "サブスクリプションに失敗しました。もう一度お試しください",
    "subscription_unsubscribe_failed": "キャンセルに失敗しました。もう一度お試しください",
    "subscription_payment_cancelled": "お支払いがキャンセルされました",
    "subscription_payment_failed": "お支払いに失敗しました。もう一度お試しください",
    "subscription_cannot_cancel_during_free_trial": "初回支払い前はサブスクリプションをキャンセルできません",
    "subscription_service_title": "サブスクリプションサービス",
    "subscription_description_title": "サブスクリプションのご案内",
    "subscription_description_step_1": "■<strong>月額料金について</strong><br>本サービスは月額33,000円（税込）にてご利用いただけます。",
    "subscription_description_step_2": "■<strong>登録時のクレジットカード確認と初月無料について</strong><br>ご登録の際、クレジットカードが有効であるかを確認するため、<br><strong>33,000円の与信枠を一時的に確保（オーソリ）</strong>いたします。<br>こちらは確認のための処理であり、<strong>実際に請求が発生するものではございません</strong>。<br>与信枠はすぐに取り消されますので、ご安心ください。<br>また、<strong>ご登録日から当月末までは無料でご利用いただけます</strong>。",
    "subscription_description_step_3": "■<strong>毎月の更新と決済について</strong><br>月額料金は、<strong>毎月第一営業日に当月分として自動的に決済</strong>されます。",
    "subscription_description_step_4": "■<strong>解約手続きについて</strong><br>ご登録開始から<strong>初回の決済（最初の毎月第一営業日の決済）が完了するまで</strong>は、<br>解約手続きを行うことができません。<br>初回決済が完了した後は、いつでも解約いただけます。",
    "subscription_description_step_5": "■<strong>解約後のご利用について</strong><br>解約手続き後も、<strong>当月末まではサブスクリプション特典をご利用いただけます</strong>。<br>未使用のポイントも同様に、当月末までご利用可能です。<br>なお、<strong>毎月1日の決済が確認できなかった場合、サブスクリプションを継続することができないため、その月よりサービスのご利用が停止となります</strong>。",
    "subscription_description_step_6": "",
    "subscription_description_step_7": "",
    "subscription_gmo_description_step_2": "■<strong>登録時のお支払いとカード登録について</strong><br>サブスクリプション登録時に決済ページへ移動します。<br>カード情報の入力と3Dセキュア認証が完了すると、33,000円が即時決済されます。<br>決済完了後、次回以降の更新は自動で行われます。",
    "subscription_gmo_description_step_3": "■<strong>毎月の更新と決済について</strong><br>次回決済は翌月の同日に自動で実行され、その後も各請求月の同日に自動決済されます。",
    "subscription_gmo_description_step_4": "■<strong>解約手続きについて</strong><br>初回決済完了後は、いつでも解約いただけます。<br>解約後、次回以降の更新と決済は行われません。",
    "subscription_gmo_description_step_5": "■<strong>解約後のご利用について</strong><br>解約手続き後も、現在の請求期間終了までご利用いただけます。",
    "subscription_description_footnote": "",
    "subscription_plan_title": "利用申し込み",
    "subscription_plan_free_month": "申込月無料※",
    "subscription_plan_monthly_fee": "月間費用¥33,000（税込）",
    "subscription_plan_cancel_anytime": "いつでもキャンセル可能※",
    "subscription_plan_monthly_points": "月10,000ポイント付与",
    "subscription_plan_monthly_quota_benefit": "画像無制限生成",
    "subscription_plan_monthly_quota_benefit_note": "※動画週100本、アップスケール週250回まで",
    "subscription_plan_free_month_note": "※申込日～当該月末まで無料、翌月1日に請求が発生します。",
    "subscription_plan_cancel_note": "※無料期間は除く",
    "subscription_gmo_plan_free_month": "即時決済※",
    "subscription_gmo_plan_free_month_note": "※お申し込み時に即時決済され、次回決済は翌月の同日です。",
    "subscription_gmo_plan_cancel_note": "※解約後も現在の請求期間終了までは利用できます。",
    "subscription_plan_terms_note": "※利用規約とプライバシーポリシーが適用されます。",
    "subscription_plan_apply_button": "カード登録へ",
    "subscription_campaign_code_placeholder": "キャンペーンコードを入力（任意）",
    "subscription_campaign_code_invalid": "キャンペーンコードが無効です",
    "subscription_campaign_original_amount": "通常価格",
    "subscription_campaign_discount_amount": "割引額",
    "subscription_campaign_final_amount": "お支払い金額",
    "subscription_try_first_button": "プロジェクト一覧へ",
    "subscription_gmo_try_first_button": "利用開始",
    "subscription_try_first_desc": "マイページから、いつでもサブスクリプションをお申し込みいただけます。",
    "favorite_target_missing": "対応するプロジェクト結果を特定できませんでした",
    "favorite_total": "合計 {count} 件",
    "favorite_show_more": "もっと見る"
  },
  "recharge": {
    "back_to_wallet": "マイページに戻る",
    "select_package_title": "チャージプランを選択",
    "flow_title": "チャージ手順",
    "flow_step_1": "プランを選択し入金予定ポイントを確認",
    "flow_step_2": "注文作成後、決済ページへ遷移します。案内に従ってお支払いください",
    "flow_step_3": "支払い完了後、ポイントは自動的に反映されウォレットで確認できます",
    "flow_step_4": "永久ポイントの購入はサブスクリプション会員のみ可能です",
    "loading_packages": "プランを読み込み中...",
    "empty_packages": "利用可能なプランがありません",
    "package_expected_coins": "入金予定 {coins} {unit}",
    "package_base_coins": "基本 {coins} 利用可能画像",
    "package_bonus_coins": "ボーナス {coins} 利用可能画像",
    "package_no_bonus": "追加ボーナスなし",
    "button_creating": "作成中...",
    "button_purchase": "今すぐチャージ",
    "order_payment_title": "注文の支払い",
    "scan_hint": "支払いアプリでQRコードを読み取り支払いを完了してください",
    "payment_support": "利用可能な決済: WeChat Pay / Alipay / Stripe",
    "order_id_label": "注文番号",
    "merchant_order_id_label": "加盟店注文番号",
    "package_expected_coins_label": "入金予定の利用可能画像",
    "continue_select": "他のプランを選ぶ",
    "view_wallet": "ウォレットを確認",
    "currency_cny": "人民元",
    "currency_jpy": "日本円",
    "currency_usd": "米ドル",
    "load_packages_failed": "プランの読み込みに失敗しました",
    "login_required": "チャージする前にログインしてください",
    "create_order_failed": "注文の作成に失敗しました",
    "create_order_retry": "注文の作成に失敗しました。時間をおいて再試行してください",
    "order_status_timeout": "注文ステータスの確認がタイムアウトしました。後ほどウォレットでご確認ください",
    "payment_success": "支払いが完了し、利用可能画像が入金されました",
    "payment_pending": "支払いが完了していません。再度お試しください",
    "status_awaiting_payment": "支払待ち",
    "status_message_default": "注文が作成されました。期限内に支払いを完了するとステータスが自動更新されます",
    "status_message_success": "支払い成功！利用可能画像がウォレットに入金されました",
    "status_message_pending": "支払いが完了していません。別のプランを選ぶか時間をおいて再試行してください",
    "status_message_processing": "注文処理中です。しばらくお待ちいただき再度更新してください",
    "monthly_plan_badge": "月額",
    "per_month_suffix": "月あたり",
    "image_unit": "枚の画像",
    "package_images_included": "{count} {unit}",
    "package_expiration_days": "有効期間 {days} 日",
    "package_monthly_desc": "支払い成功後すぐに有効になります",
    "package_name_1": "プラン1",
    "package_name_2": "プラン2",
    "package_name_3": "プラン3",
    "package_name_4": "プラン4",
    "package_name_5": "プラン5",
    "package_name_6": "プラン6",
    "package_name_7": "プラン7",
    "package_name_8": "プラン8",
    "package_name_9": "プラン9",
    "package_name_10": "プラン10",
    "package_info_no_expiration": "有効期限なし",
    "package_info_terms": "※利用規約が適用されます。",
    "package_info_button": "チャージ",
    "merchant_info_title": "販売業者情報",
    "merchant_name": "販売業者",
    "merchant_name_value": "ＭａｋｅＨｏｕｓｅ株式会社",
    "representative": "代表責任者",
    "representative_value": "眞木 健一",
    "address": "所在地",
    "address_value": "〒107-0052\n東京都 港区 赤坂８丁目５番４０号ペガサス青山４１０号室",
    "phone": "電話番号",
    "phone_value": "03-6450-2957",
    "phone_hours": "電話受付時間",
    "phone_hours_value": "10：00〜18：00",
    "email": "メールアドレス",
    "email_value": "info@makehouse.co.jp",
    "site_url": "サイトURL",
    "site_url_value": "https://www.sumaidesign.ai",
    "selling_price": "販売価格",
    "selling_price_value": "各商品の紹介ページに記載している価格とします。",
    "additional_fees": "商品代金以外に必要な料金",
    "additional_fees_value": "消費税",
    "delivery_time": "引き渡し時期",
    "delivery_time_value": "ご注文から即日以内に発送します。",
    "payment_method": "お支払い方法とお支払いの時期",
    "payment_method_value": "クレジットカード決済：ご注文の翌月にお支払いが確定します。",
    "return_policy": "返品・交換・キャンセルについて",
    "return_policy_value": "使用前の場合、申込後3日以内に限り返品可\n使用後の返品・交換・キャンセルには、基本的に対応しておりません。\n商品に欠陥がある場合のみ交換が可能ですのでご連絡ください。",
    "return_deadline": "返品期限",
    "return_deadline_value": "商品出荷から3日以内にご連絡ください。",
    "return_shipping": "返品送料",
    "return_shipping_value": "商品に欠陥がある場合は、弊社で負担いたします。\nそれ以外は、お客さまのご負担になります。",
    "antique_license": "古物商許可証",
    "antique_license_value": "該当しない"
  },
  "nav": {
    "initial_page": "ホーム",
    "member_site": "会員専用\nポータルサイト",
    "member_inquiry": "会員専用お問合せ",
    "intel_product": "インテリジェント設計製品",
    "developing_products": "開発中の製品",
    "typical_cases": "典型的な事例集",
    "HemuNews": "Hemuニュース",
    "about_hemu": "Hemuについて",
    "about_us": "会社概要",
    "sign_up": "登録/ログイン",
    "main_business": "主要事業",
    "wallet": "マイページ",
    "facade": "外観",
    "interior": "内観",
    "drawing_vectorize": "3D"
  },
  "products": {
    "shearwall_structure": "耐震壁構造",
    "frame_structure": "フレーム構造",
    "core_structure": "フレーム - コアチューブ構造",
    "structure_intel": "建築構造設計のインテリジェント化",
    "watch_video": "動画を見る",
    "production_and_solution": "製品とソリューション",
    "local_assistant": "Copilot-local ローカル版インテリジェント設計アシスタント",
    "local_assistant_content": "AIstructure-CopilotはCADプラットフォームベースの建築構造インテリジェント設計アシスタントです",
    "platform_cloud": "Intelligent Design インテリジェント設計プロジェクト管理プラットフォーム",
    "platform_cloud_content": "AIstructure-PlatformはWebベースのプロジェクトインテリジェント設計・管理プラットフォームです",
    "shearwall_structure_design_title": "耐震壁構造インテリジェント設計",
    "shearwall_structure_design_content": "自社開発の拡散モデル、GAN、GNNなどの生成AI技術に基づき、建築平面図を入力することで、AIが対応する耐震壁-梁構造配置設計、構造部材寸法設計を自動生成し、構造計算と最適化を実施します",
    "frame_structure_design_title": "フレーム構造インテリジェント設計",
    "look_forward": "自社開発の拡散モデル、異種GNNなどの生成AI技術に基づき、建築とフレーム柱の平面図を入力することで、AIが対応するフレーム梁構造配置設計、構造梁柱部材寸法設計を自動生成し、フレーム構造計算を実施します",
    "core_structure_design_title": "フレーム-コアチューブ構造断面インテリジェント設計",
    "core_structure_desgin_content": "生成的敵対ネットワークなどの生成AI技術に基づき、フレーム-コアチューブ構造の平面図を入力することで、AIが対応する構造部材断面寸法設計を自動生成します",
    "key_component": "コア能力",
    "key_component_content1": "「データ-力学-知識」結合",
    "key_component_content2": "駆動型インテリジェント生成設計アルゴリズム",
    "patent": "発明特許",
    "product_download": "製品ダウンロード",
    "intel_product_content1": "AIstructure-CopilotはCADプラットフォームベースの建築構造インテリジェント設計アシスタントです。",
    "intel_product_content2": "ローカルコンピュータにAIstructure.exeプログラムをインストールすると、プログラムはローカルにインストールされたCADプラットフォーム（現在はAutodesk CADおよびTianzheng CADを推奨）に基づいてCopilotを自動作成します。AIstructure-Copilotに基づいて、ローカルコンピュータのCADプラットフォームで建築構造のインテリジェント設計を実現できます。",
    "intel_platform": "インテリジェント設計プロジェクト管理",
    "intel_platform_tips": "(典型的な事例の試用をサポート、日本語・英語)",
    "sign_in": "ログイン",
    "instruction": "使用説明",
    "intel_platform_content1": "インテリジェント設計プロジェクト管理プラットフォームは、耐震壁部材設計、梁-スラブ部材設計、フレーム-コアチューブ部材設計を備え、アップロードされたデータと建築ピクセル図をインテリジェント処理し、構造ピクセル図を生成して元の建築CADにインポートします。",
    "intel_platform_content2": "現在、耐震壁部材設計の使用を推奨します。梁-スラブ部材設計、フレーム-コアチューブ部材設計モジュールは改善・調整中です。試用を歓迎します。",
    "automated_rule_interpretation": "規則自動解釈",
    "automated_rule_interpretation_content1": "コンピュータが土木工学分野の設計規範を理解し、自動的にコンピュータコードに翻訳できれば、構造設計のインテリジェント化レベルが大幅に向上します。",
    "automated_rule_interpretation_content2": "このため、AI規則自動解釈モジュールを開発しました。ユーザーが自然言語で表現された文を入力すると、AIは単語の意味を認識し、自然言語のテキストにタグを付け、テキスト内容を対応する構文木構造に翻訳し、任意のコンピュータ言語のコードに変換できます。",
    "enter_automated": "規則自動解釈インターフェースに入る",
    "AIstructure-Copilot": "AIstructure-Copilot",
    "AIstructure-Copilot_tips": "(ローカル版CADプラグイン、日本語・英語)",
    "software_copyrights": "9つのソフトウェア著作権を取得",
    "enter_cloud": "インテリジェント設計プラットフォームに入る"
  },
  "auth": {
    "back_to_main": "公式サイトに戻る",
    "system_update_tips": "システム更新により、2024年3月29日以前に登録されたユーザーは、ログイン時の「パスワードを忘れた」でパスワードを変更してください。",
    "hello": "こんにちは",
    "please_sign_in": "ログインしてください",
    "click_to_sign_up": "初めての方はこちらからアカウントを作成してください",
    "phone_number": "電話番号",
    "password": "パスワード",
    "forget_password": "※パスワードをお忘れの方はこちら",
    "sign_in_now": "ログイン",
    "sign_in_by_code": "認証コードでログイン",
    "please_sign_up": "登録へようこそ",
    "account_name": "会員ID:",
    "enter_english_account_name": "お好きな会員IDを設定してください",
    "chinese_name": "氏名（中国語）:",
    "enter_chinese_name": "中国語名を入力してください",
    "unit_name": "会社名:",
    "enter_unit_name": "会社名を入力してください",
    "address": "住所:",
    "enter_address": "会社の住所を入力してください",
    "profile_dialog_title": "会社情報の入力が必要です",
    "profile_dialog_desc": "サブスクリプションを続けるには、会社名と住所の入力が必要です。",
    "phone_dialog_title": "電話番号のご登録",
    "phone_dialog_hint": "ご連絡用の電話番号をご登録ください。Google アカウントでのご登録では電話番号を取得できないため、初回のみお願いしています。",
    "profile_company_hint": "お申込みの際は、会社名とご住所をご入力ください。",
    "campaign_code": "キャンペーンコード",
    "enter_campaign_code": "キャンペーンコードを入力してください（任意）",
    "invalid_campaign_code": "キャンペーンコードが正しくありません",
    "expired_campaign_code": "キャンペーンコードの有効期限が切れています",
    "enter_phone_number": "電話番号を入力してください",
    "enter_password": "パスワードを入力してください",
    "enter_old_password": "現在のパスワードを入力してください",
    "enter_new_password": "新しいパスワードを入力してください",
    "confirm_password": "パスワード確認:",
    "enter_password_again": "パスワードを再入力してください",
    "sex": "性別:",
    "male": "男性",
    "female": "女性",
    "phone_code": "電話認証コード:",
    "email": "メールアドレス:",
    "code": "認証コード",
    "get_code": "認証コードを取得",
    "code_sent_success": "認証コードを送信しました",
    "email_code_sent_to": "認証コードを送信しました",
    "enter_code_from_email": "メール",
    "sign_up_now": "同意して次へ",
    "previous_step": "前のステップに戻る",
    "register_different_email": "別のメールアドレスを登録する",
    "resend_verification_code": "認証コードを再送",
    "verify_code_not_received_title": "認証コードが届かない場合",
    "verify_code_not_received_1": "ご入力いただいたメールアドレスのご確認お願いします。",
    "verify_code_not_received_2": "迷惑メールフォルダやゴミ箱のご確認お願いします。",
    "verify_code_not_received_3": "ドメイン指定受信をご利用されている方は、「sumaidesign.ai」からのメール受信可能にしてください。",
    "need_help_click_here": "お困りの方はこちら",
    "account_sign_in_now": "アカウントをお持ちの方はログイン",
    "create_account": "アカウント作成",
    "reset_password": "パスワードをリセット",
    "enter_6_code": "6桁の認証コードを入力してください",
    "change_now": "今すぐ変更",
    "back_to_sign_in": "ログインに戻る",
    "sign_in_by_password": "パスワードでログイン",
    "enter_correct_phone_number": "正しい電話番号形式を入力してください",
    "correct_password_format": "パスワードは12-20文字の非空白文字である必要があります",
    "correct_code_format": "認証コードは6桁の文字です",
    "correct_chinese_name_format": "氏名は2-8文字の漢字である必要があります",
    "correct_english_name_format": "会員IDは3-11文字の半角英数字の組み合わせで、少なくとも1つの文字（大文字小文字可）を含む必要があります",
    "choose_sex": "性別を選択してください",
    "sign_in_success": "登録に成功しました",
    "verify_code_sent_too_frequently": "認証コードの送信が頻繁です",
    "uncorrect_code": "認証コードが正しくないか期限切れです！",
    "update_success": "変更に成功しました。再度ログインしてください！",
    "login_failed_tips": "アカウントまたはパスワードの検証に失敗しました。再入力してください",
    "login_success_tips": "ログインに成功しました",
    "already_registered": "このメールアドレスは既に登録されています。",
    "auth_expired_relogin": "認証の有効期限が切れました。再度ログインしてください。",
    "error_e205": "認証コードに誤りがあります",
    "error_e206": "ユーザーが存在しません。管理者（info@makehouse.co.jp）にご連絡ください",
    "error_e207": "入力した旧パスワードが正しくありません",
    "error_e208": "ログイン時のユーザー名、アドレス、またはパスワードの検証に失敗しました。再入力するか、管理者（info@makehouse.co.jp）にご連絡ください",
    "error_e209": "登録時のメールアドレスは既に存在します。再入力してください",
    "error_e2010": "登録時の携帯電話番号は既に存在します。再入力してください",
    "error_e2011": "認証コードの取得に失敗しました",
    "error_e2012": "登録時のメールアドレスは既に存在します。再入力してください",
    "error_e2013": "認証コードの送信が頻繁すぎます",
    "error_e200": "アカウントの検証に失敗しました。再ログインするか、管理者（info@makehouse.co.jp）にご連絡ください",
    "error_e201": "アップロードが失敗しました。管理者（info@makehouse.co.jp）にご連絡ください",
    "error_e202": "生成の送信が失敗しました。管理者（info@makehouse.co.jp）にご連絡ください",
    "error_e203": "管理者トークンの検証に失敗しました。再ログインしてください",
    "error_e204": "パスワードの変更に失敗しました。管理者（info@makehouse.co.jp）にご連絡ください",
    "error_e215": "現在の権限では、この画面または機能にアクセスできません",
    "error_e210": "生成がタイムアウトしました。管理者（info@makehouse.co.jp）にご連絡ください",
    "error_e211": "ダウンロードが失敗しました。管理者（info@makehouse.co.jp）にご連絡ください",
    "error_e400": "データベースの入力データ記録エラー",
    "error_e410": "データベースの出力データ記録エラー",
    "error_e411": "データベースがタイムアウトしました。出力データを取得できませんでした",
    "error_e300": "プロジェクト作成は失敗しました。",
    "error_e301": "注文ステータスの取得に失敗しました",
    "error_e302": "注文リストの照会に失敗しました",
    "error_e303": "支払い詳細の取得に失敗しました",
    "error_e304": "ユーザーが存在しません。プロジェクト作成は失敗しました。",
    "error_e305": "ウォレットが封鎖されています。プロジェクト作成は失敗しました。",
    "error_e306": "ポイント残高が不足しています。",
    "error_e307": "支払いの実行に失敗しました。既に支払い済みの注文は再度選択できません",
    "error_e308": "支払いの継続リクエストに失敗しました",
    "error_e309": "削除に失敗しました。支払い開始から2時間後にのみ削除できます",
    "error_e310": "サブスクリプションプランIDは空にできません",
    "error_e311": "サポートされていないサブスクリプションプランです",
    "error_e312": "冪等キーは空にできません",
    "error_e313": "重複したプロジェクトを送信しないでください",
    "error_e314": "ユーザーは無料トライアル期間中です。サブスクリプションをキャンセルできません",
    "error_e315": "サブスクリプションユーザーのみが永久ポイントをチャージできます",
    "error_e316": "システムが注文処理中です。02:00以降にサブスクリプションをキャンセルしてください",
    "error_e317": "前の画像生成が処理中です。しばらくお待ちください。",
    "error_e318": "AI real CGの利用回数上限に達しました",
    "error_e319": "この冪等キーに該当する注文が見つかりません",
    "error_e320": "注文は未払いのため請求書を生成できません",
    "error_e321": "この注文にアクセスする権限がありません",
    "error_e322": "PDFの生成に失敗しました",
    "error_e401": "ウォレットデータの取得に失敗しました",
    "error_e500": "サブスクリプション情報の取得に失敗しました",
    "error_e501": "サブスクリプションの作成に失敗しました",
    "error_e502": "サブスクリプションプランの取得に失敗しました",
    "error_e600": "コイン取引記録の照会に失敗しました",
    "error_e700": "AI real CGプロジェクトの作成が失敗しました",
    "error_e701": "予期しないエラーが発生しました",
    "error_e800": "画像のお気に入り状態の取得に失敗しました",
    "error_e801": "画像をお気に入りに設定できませんでした",
    "error_e802": "画像のお気に入りを解除できませんでした",
    "error_e803": "ユーザーがログインしていないか、ユーザー情報の取得に失敗しました",
    "error_e804": "画像URLが空です",
    "error_e805": "プロジェクトIDが空です",
    "error_e806": "画像レコードが存在しないため、お気に入りを設定できません",
    "error_e807": "お気に入り画像の上限に達しました。解除してから再試行してください",
    "error_e808": "該当する生成結果が見つかりません",
    "error_e1000": "アカウントの作成に失敗しました。",
    "error_e1001": "アカウントの一括発行に失敗しました。",
    "error_e1002": "変更する権限がありません。",
    "error_e900": "入力されたキャンペーンコードが正しくありません。もう一度ご確認ください。",
    "error_e901": "入力されたキャンペーンコードの有効期限が切れています。",
    "error_e902": "自動更新のお支払いには、キャンペーンコードをご利用いただけません。",
    "error_e903": "このキャンペーンコードは、月額サブスクリプションのお申し込みにのみご利用いただけます。",
    "error_e904": "入力されたキャンペーンコードの使用回数上限に達しました。",
    "error_e905": "現在のお支払い方法では、キャンペーンコードをご利用いただけません。",
    "sign_in_by_phone": "電話で登録",
    "sign_in_by_email": "メールで登録",
    "email_code": "メール認証コード",
    "login_phone": "電話でログイン",
    "login_email": "メールでログイン",
    "input_correct_email_format": "正しいメール形式を入力してください",
    "password_login": "パスワードでログイン",
    "login_number": "ID/メールアドレス",
    "email_code_login": "認証コードでログイン",
    "phone_code_login": "電話認証コードでログイン",
    "reset_phone_password": "電話パスワードを変更",
    "reset_email_password": "メールパスワードを変更",
    "username": "ユーザー名",
    "new_password": "新しいパスワード",
    "old_password": "現在のパスワード",
    "confirm_new_password": "新しいパスワード（確認）",
    "same_password_error": "新しいパスワードは以前のパスワードと異なる必要があります！",
    "passwords_not_match": "2回の新パスワードが一致しません！",
    "terms_agreement_required": "会員への登録には利用規約およびプライバシーポリシーへの同意が必要です。",
    "terms_of_service": "利用規約",
    "privacy_policy": "プライバシーポリシー",
    "agree_to_terms": "利用規約およびプライバシーポリシーに同意する",
    "terms_of_service_content": "この利用規約（以下単に「本利用規約」といいます）は、Make House株式会社（以下「当社」といいます）がサービスを提供するにあたっての利用条件を定めるものです。\n第1条（定義）\n 本利用規約において使用する用語は、以下の意味を持ちます。\n1. 契約企業：自己の事業のために本サービスを利用する会社又は事業者をいいます。\n2. アカウント：本サービスにアクセスし利用するために契約企業に付与される権利・資格をいいます。\n3. 契約企業情報：契約企業が本サービスに申し込み、又はこれを利用することによって当社が得た契約企業、その連絡先若しくは担当者、又はその他の事項に関する情報をいいます。\n4. 告知：当社から、契約企業の全部又は一部に一斉に行う通知・連絡をいいます。この告知は、当社が指定するウェブサイトへの掲載又はその他当社が適切と考える方法をもって行うものとし、当該掲載の時点をもって告知がなされたものとみなします。\n5. 所定通知手段：付随規定等において当社が定める、契約企業から当社への連絡・通知手段をいいます。\n6. 生成画像：入力等データをAIにより生成又は出力される建築物の完成画像をいいます。\n7. 知的財産権等：特許権、実用新案権、意匠権、著作権、商標権、及びその他の知的財産にかかる権利（登録可能か否かを、また登録の有無を問いません）、営業秘密若しくはノウハウを独占的に利用できる権利、並びに出願登録可能な知的財産権について登録を受ける権利のほか、不正競争防止法上の権利、肖像権、パブリシティ権、名誉権、プライバシー権及びその他の一切の権利の総称又はそのいずれかをいいます。\n8. 通知等：利用契約若しくは本サービスに関連して当社が行う通知又は連絡をいいます。その方法については、第30条に定めるところによります。\n9. 入力等データ：契約企業が本サービスを利用するために、本サービスにおいてアップロードする、建築パース、イラスト画像、及び背景画像、並びにその他の関連するデータ又は情報の総称又はそのいずれかをいいます。\n10. 反社会的勢力：暴力団、暴力団類似団体、暴力団関係企業、総会屋、社会運動標ぼうゴロ、政治活動標ぼうゴロ、特殊知能暴力集団、又はその他の犯罪若しくは暴力を特色とする集団をいいます。\n11. 付随規定等：本サービスに関し当社が、ウェブサイトその他の媒体において掲載し、又は契約企業に個別に提示する、ウェブページ上の記載、本利用規約以外の諸規程、マニュアル及びその他のドキュメント、並びに契約企業と当社との間で別途書面により成立した合意内容の総称又はそのいずれかをいいます。\n12. 本サービス：当社がクラウド上で提供する、AIによる建築物の完成画像を自動生成するサービスをいいます。\n13. 本サービス等：本サービス又は本システムの総称又はそのいずれかをいいます。\n14. 本システム：本サービスを提供するために当社又は他のサービス提供事業者が運用管理するクラウドサーバの環境、機器、ネットワーク回線、並びにこれらにおいて実行されるAIツール、OS、アプリケーション、及び他のソフトウェア、データベース、及びデータ、並びにその他のシステム構成要素の総称又はそのいずれかをいいます。\n15. 本利用規約等：本利用規約及び付随規定等の総称又はそのいずれかをいいます。\n16. 申込企業：本サービスの利用を申し込む企業をいいます。\n17. 利用契約：当社と申込企業との間で成立する、本サービスの利用とその条件に関して合意した契約をいいます。\n18. 利用料金：本サービスの対価として、契約企業が当社に支払うべき料金をいいます。\n第2条（本利用規約等の適用と付随規定等）\n1. 本利用規約等の規定は、本サービスの利用の前後を問わず、本サービスに関する当社と契約企業又は申込企業との間の権利義務関係に適用され、両者間の法律関係となります。\n2. 本利用規約にない事項又は本利用規約の内容と矛盾抵触する規定が付随規定等に定められている場合、付随規定等が優先します。\n第3条（利用契約の成立）\n1. 本サービスの利用を希望する申込企業は、本利用規約等の内容に同意した上で、当社の指定する方式で利用の申込を行います。当社は申込に対して審査を行い、当社が当該審査の結果利用契約の締結を承認する旨の通知等をした時点で、利用契約が成立します。\n2. 本サービスについては、自己の事業のために本サービスを利用する会社又は事業者のみが申し込むことができ、非事業者である個人が申し込むことはできません。\n3. 当社は、その裁量で、申込企業からの申込を承諾しないことができます。この場合であっても、その理由を開示又は説明する義務を負いません。\n第4条（契約企業の登録とアカウントの管理）\n1. 当社は、利用契約が成立した契約企業に対し、本サービス利用のための登録の処理を行い、契約企業に対してアカウントを発行します。\n2. 契約企業は、アカウントに含まれるパスワードを秘密情報として厳重に管理し、他者に知られることがないよう管理する責任を負います。\n3. あるアカウントについて、所定のパスワードを用いて行われた行為は、第三者が不正に行った行為であっても契約企業の行為とみなし、そのために生じる義務、責任及び損害等はすべて契約企業が負います。\n第5条（利用期間）\n1. 本サービスの利用期間は、当社が本サービスの利用申込を承諾した日から開始するものとし、本利用規約等に従って終了しない限り、以後、申込日を起算日として1か月単位で自動的に更新されるものとします。\n2. 契約企業は、当社が別途定める方法により、いつでも解約手続きを行うことができます（無料期間は除く）。この場合、解約手続きを行った月の末日をもって利用契約は終了し、当該末日までは本サービスを利用することができます。\n3. 前項に基づき利用契約が解約された場合であっても、当該解約日までに発生した利用料金その他の債務について、契約企業は何らの免責を受けないものとします。\n第6条（利用料金）\n1. 本サービスに対する対価として、契約企業は、月単位で利用料金を支払います。\n2. 当社は、理由の如何にかかわらず、すでに支払われた利用料金を返還する義務を負いません。\n3. 当社は、利用料金を改定することがあります。この場合当社は、改定後の利用料金を適用する3か月前までに告知します。\n4. 本サービスには、利用料金として「基本料金（毎月発生する月額料金）」及び、契約企業が任意に購入する「追加チャージ」があります。\n5. 基本料金には、本サービスを利用するための使用権および月間の基本使用容量が含まれます。\n6. 契約企業が月間に利用できる基本使用容量は、当該月の末日をもって失効し、翌月以降に繰り越すことはできません。\n7. 契約企業が基本使用容量を超えて本サービスを利用する場合、当社が定める方法により追加チャージを購入することができます。追加チャージによって付与された使用容量は、契約企業が利用契約を継続している限り、有効期間中は翌月以降に繰り越すことができます。\n8. 本サービスにおける使用容量の消費順序は、以下のとおりとします。\n (1) 基本料金に含まれる基本使用容量\n (2) 追加チャージにより付与された使用容量\n9. 契約企業が利用契約を解約した場合、基本料金に含まれる使用権および使用容量、ならびに未使用の基本使用容量は、解約日の到来と同時に失効し、以後利用することはできません。また、追加チャージによって付与された使用容量が未使用で残存していた場合でも、同様に利用することはできません。\n第7条（本サービスの概要及び内容）\n1. 本サービスの主要な機能は、契約企業が、建築物に関する「建築パース」又は「イラスト画像」と、「背景画像」を本システムにアップロードすることで、AIによって建築物の完成画像を自動生成するものです。\n2. 本サービスの具体的な内容と仕様については、付随規定等において具体的に特定します。付随規定等に明示的に記載のない内容については、当社が口頭・電子メールその他の方法でこれに反することを利用企業に述べたとしても、本サービスの内容を構成しません。\n第8条（本サービスの利用方法）\n1. 利用契約を締結した契約企業は、付与されたアカウントを使用して、本サービスの機能を利用することができます。\n2. 契約企業は、本サービスにアクセスし利用するために必要なコンピュータ端末、ソフトウェア、ネットワーク環境、その他の機器と環境を、自己の費用と責任において準備し維持します。\n3. 本サービスの利用地域は日本国内とします。また、本サービスの提供言語は日本語のみとします。\n第9条（本サービスの種類及び内容）\n1. 契約企業は、本サービスが定める所定の操作方法にて、入力等データをアップロードし、AIによって自動生成された建築物の完成画像（画像ファイルの形式は当社が定めます）を得ることができます。\n2. 入力等データ及び生成画像については、当社は、本システムにおいて保存して契約企業の利用に供します。契約企業は、生成した生成画像をダウンロードすることができ、本利用規約等に違反しない限り、生成画像をそのまま、又は適宜改変して自己の事業にために利用することができます。ここには、特定の顧客又は見込客に対する提供が含まれます。\n3. 契約企業が生成できる生成画像の数量、及び生成した生成画像のダウンロード数については、月ごとに上限回数があります。当該上限回数については、付随規定等において定めます。\n第10条（生成画像の利用に関する契約企業の責任）\n1. 当社は、本サービスの提供にあたり、入力等データを所与の前提とすれば足り、生成画像の出力にあたり、入力等データの法令適合性、正確性、有用性、妥当性を検証する義務と責任を負いません。\n2. 契約企業は、生成画像が、AIによって機械的に生成されるものであり、入力等データを正確に反映するとは限らず、法令適合性、再現性、的確性、網羅性、利用可能性、有用性、又はその他の事項に関して何らかの不備がありうることを十分に理解の上、生成画像を、自己の責任で検証し、適切と考える場合に自己の責任で利用します。\n3. 当社は、生成画像の使用、又は生成画像の不備に伴い契約企業又は第三者に損害が生じても、何ら責任を負いません。\n第11条（入力等データにかかる利用権限の保証）\n 契約企業は、アップロードした入力等データについては、自ら著作権や意匠権等の必要な知的財産権等を有するものであるか、又は本サービスの利用に必要なすべての行為について権利者の許諾を得たものであることを保証します。\n第12条（データの利用目的）\n データの利用目的について、データを、当社又は第三者のAIモデル（基盤モデルを含みます）の学習、訓練、又はファインチューニングのために利用することは一切ありません。\n第13条（問い合せ・サポート）\n 当社は、本サービスの利用に関し、契約企業への問い合わせ対応・操作説明・及びその他の情報提供を、当社の通常の営業日と営業時間内において行います。また契約企業からの質問については、回答に調査を要する場合を含め、当社の事情によって返答に時間を要する場合があります。\n第14条（生成画像等にかかる知的財産権等の侵害の場合の措置）\n1. 契約企業がアップロードした入力等データ、又はこれに基づき生成された生成画像に関し第三者の知的財産権等を侵害する行為をしたとき若しくは第三者から侵害の主張があったときは、契約企業自身においてその解決を図ることとします。\n2. 前項にかかわらず、当社に対して、本システムに保存されている入力等データ又はこれに基づき生成された生成画像について、第三者から知的財産権等の侵害であるとの主張があったとき、又は当社の裁量で侵害の疑いがあると判断したときは、関係する契約企業の承諾なく、関連する入力等データ又は生成画像を削除することができ、当社は削除後、当該契約企業に通知等をします。この場合、後日結果として侵害の事実がなかったことが明らかになった場合でも、当該契約企業に対し、損害賠償その他何らの責を負いません。\n3. 入力等データ又は生成画像に関する第三者の知的財産権等の侵害について、当社が第三者から苦情若しくは請求を受け当社が対応した場合には、当該契約企業は、結果のいかんにかかわらず、当社が解決のために要した弁護士費用、鑑定費用、権利取得費用、実施料、使用料、損害賠償、和解金、解決金、並びにその他一切の諸経費及び損害を当社に補償するものとします。\n第15条（知的財産権等の帰属）\n1. 本サービス等に含まれ若しくはこれらに関連して実施若しくは使用される知的財産権等は、当社に独占的に帰属します。契約企業による当該知的財産権等の利用は、本サービスにおいて明示的に許された操作方法によって本サービス又は生成画像を利用する範囲に限ります。\n2. 契約企業が本サービスを利用してアップロードした入力等データの著作権については、これが第11条の保証のとおりである限り、当該契約企業又は契約企業に利用を許諾した権利者に留保されます。\n3. 契約企業が本サービスを利用してアップロードした入力等データに基づき生成された生成画像について、これについて著作権が成立する場合には、当該著作権は契約企業に帰属します。\n第16条（本サービスの内容の変更）\n1. 当社は、利用契約締結後であっても、事前の予告なく、本サービスの機能・仕様・動作・画面構成・操作方法、又はその他の委細事項について、当社の裁量で随時追加、変更、停止若しくは廃止をすることができます。\n2. 当社は、前項の行為によって契約企業に損害が生じるとしても、賠償その他の責を負いません。\n第17条（本サービスの提供の停止・中断）\n1. 当社は、以下のいずれかに該当する場合、当社の帰責事由の有無を問わず、随時、本サービスの提供を停止若しくは中断することができます。ただし当社の責に帰すべき事由による停止若しくは中断については、当社は、回復のための合理的な措置をできるだけ速やかに講じるよう努力します。\n (1) 本システムの保守又は維持管理のための必要又は相当な場合\n (2) 本システムに障害が発生した場合\n (3) 本サービスの仕様変更、機能変更又は改良のために必要な場合\n (4) 本サービスの全部又は一部が、第三者の知的財産権等を侵害する旨の疑義又は主張があり、当該侵害若しくはこれに伴う損害の回避、予防又は軽減のために必要又は適当と判断される場合\n (5) その他技術的、商業的又は他の理由によって本サービスの提供が不可能又は困難となった場合\n2. 当社は、前項の本サービスの停止若しくは中断によって契約企業に損害が生じるとしても、賠償その他の責を負いません。\n第18条（禁止事項）\n1. 契約企業は、以下の行為をしません。\n (1) 本サービスにおいて明示的に許された通常の方法によらず本システムにアクセスし、又は不正な命令若しくは異常な負荷を与える行為\n (2) 本システムに含まれるソフトウェア、データベース若しくはデータ、又はその他のコンテンツの複製、改変若しくはその他の知的財産権等の侵害行為、逆コンパイル等の解析又はリバースエンジニアリング\n (3) わいせつその他の公序良俗違反、人種・国籍・性別の不当な差別、その他の社会的非難に値する行為を助長する内容、又は法令に違反する内容を含むデータをアップロードし、又は保存する行為\n (4) 本システムに継続的な高負荷をかけるおそれのある行為、又はその他本サービスの運営を妨げる行為\n (5) コンピュータウイルス等の有害なプログラムに感染した、または同様の有害なプログラムを含むデータをアップロードし、又は保存する行為\n (6) その他当社が不適切であると判断する行為\n2. 契約企業は、前項の禁止事項に違反し、当社又は第三者に損害を与えた場合、自己の費用と責任をもって損害を賠償します。\n第19条（非保証）\n1. 前項に加え、本サービスについて、当社は以下の事項を保証せず、これらの事項によって契約企業又は第三者が損害を受けたとしても、何ら責を負いません。\n (1) 契約企業の期待する機能、性能又は操作性がすべて備えられていること\n (2) アクセス可能性、アクセスへの中断（中断時間の長短を問わない）、又は、表示若しくは反応速度の低下が生じないこと\n (3) 本システムの障害、不備、不完全性若しくは動作の中断がないこと（障害等の時間の長短、規模、原因を問いません）、又はエラーが生じないこと\n (4) 本システムにおいて入力等データ又は生成画像について、消失、改ざん、漏えい又は損傷が生じないこと（ただし当社はこれら事象が生じないよう合理的なセキュリティ措置を講じます）\n (5) 契約企業が使用する他の端末・機器・設備・通信環境・ミドルウェア・ソフトウェアとの相性不良が生じないこと\n (6) 何らかのセキュリティ上の障害が生じないこと（ただし当社は当該事象が生じないよう合理的なセキュリティ措置を講じます）\n (7) 本サービスの提供、運用若しくは使用、又は生成画像が、国内外を問わず、第三者の知的財産権等を侵害しないこと、又は侵害の主張が生じないこと\n2. 当社は前項の事項に関し契約企業に生じたいかなる損害についても、何らの責を負いません。\n第20条（責任の制限）\n1. 本サービス、生成画像の利用又はその方法に関し、契約企業が何らかの損害を受け若しくは第三者に対し損害を与えた場合、又は契約企業と第三者との間にトラブルや係争が生じた場合、当社は、理由の如何を問わず一切の責任を負いません。\n2. 本サービスの提供に関連し、万一何らかの理由で当社が契約企業に対して賠償責任（不当利得返還責任その他の一切の金銭補償責任を含みます）を負う場合も、当社に故意若しくは重過失がある場合に限るものとし、賠償の範囲は、直接かつ現実の損害に限られ、逸失利益、事業機会の損失、間接的損害、又は特別損害（予見可能性を問いません）についてはいかなる場合も賠償の責を負いません。また、本サービスに関して当社が契約企業に負う賠償と補償の責任（不当利得返還義務その他の一切の金銭補償責任を含みます）の総額（利用契約の全期間におけるあらゆる責任の総額）は、いかなる場合も、1か月分の本サービスの利用料金相当額を超えないものとします。\n第21条（秘密保持）\n1. 契約企業は、本サービスの提供に関連して当社より開示された公開されていない技術情報、本サービスに関連した当社との連絡通信の内容を、本サービスの目的以外では使用せず、かつ、当社の事前の書面による同意なくして公開若しくは第三者に対して開示漏えいしません。\n2. 当社は、契約企業が登録した契約企業情報及びアップロードした入力等データについての秘密を保持し、本利用規約等に定める目的以外では使用せず、本サービスの委託先等本利用規約等で許された第三者を除き、第三者に対して開示漏えいしません。\n3. 当社は、利用契約を締結して本サービスを利用している契約企業の法人名、団体名及びロゴを、ウェブサイトを含む本サービスの販促資料又は当社の会社案内において、当社の取引先の紹介の目的で掲載及び表示することができ、契約企業はこれに同意します。\n4. 本条の規定は、利用契約終了後も存続します。\n第22条（対象データの保存及び安全管理）\n当社は、本サービスの提供にあたり、契約企業から提供を受けた入力等データ、生成画像、及び個人情報を含む契約企業情報（以下総称して「対象データ」といいます）を、適切かつ安全に保存し、管理します。\n当社は、対象データへの不正アクセス、滅失、毀損、改ざん及び漏えい等を防止するため、必要かつ合理的な技術的及び組織的安全管理措置を講じます。\n第23条（契約企業情報等の利用）\n1. 当社は、本利用規約等で別途定めるもののほか、契約企業情報を、下記の目的で使用することができ、契約企業はこれに同意します。\n (1) 本サービスの運用・提供のため\n (2) 契約企業へのサポート・問い合わせ対応又は契約企業への連絡のため\n (3) 契約企業による本サービス等の利用状況の確認のため\n (4) 本サービス等の運用の全部又は一部を委託する委託先に提供するため\n (5) 契約企業に本サービス以外の当社又は第三者のサービスや製品について案内するため\n (6) 契約企業に対して当社の権利を行使するため\n (7) 契約企業の個別の同意を得た目的と用途のため\n (8) 前各号に関連・付随した事項のため\n2. 当社は、入力等データ及び生成画像について、より精度の高い生成画像の出力を含めた本サービスの改良、拡張、及び補修、並びにこれらに関連した目的のために利用（複製、改変、解析を含みます）することができます。契約企業は、当社又は第三者によるこれらの利用に関して入力等データにかかる著作権人格権を行使せず、前項の権利者に行使させません。\n3. 当社は、契約企業との利用契約が終了した場合、又は本サービスを廃止した場合、契約企業情報、入力等データ及び生成画像の全部又は任意の一部を、当社が適切と考える時期に削除することができます。\n第24条（委託）\n 当社は、本サービスの提供又は運営の全部又は一部を、第三者に委託することができます。当社は、当該委託先に対し、契約企業情報、入力等データ、生成画像及びその他委託に必要な情報を開示又は提供することができます。\n第25条（利用契約の解除等）\n1. 当社は、契約企業に次の事由が発生した場合、何らの通知催告なく、利用契約の全部又は一部を解除することができます。\n (1) 本利用規約等のいずれかの規定に違反したとき\n (2) 本利用規約等の特定の規定の有効性、本利用規約等に定める義務若しくは責任の存在、又は本利用規約等に基づく当社の権利について異議を述べた場合\n (3) 契約企業が、当社の競業他社、若しくは本サービスと競合するサービスを提供し若しくは提供しようとする企業であることが判明し、又はこれらの企業に対して本サービスを実際に利用しないと知り得ない情報を提供することを目的としていたことが判明したとき\n (4) 当該契約企業にかかる入力等データ、又はこれに基づき生成された生成画像について、第14条に定める知的財産権等の侵害の主張又はその疑義が生じたとき\n (5) 破産、特別清算、民事再生若しくは会社更生の申立てがあったとき\n (6) 仮差押、仮処分、差押、競売、その他の強制執行又は滞納処分による差押を受けたとき\n (7) 手形、小切手の不渡処分を受け、又は銀行取引停止処分を受けたとき\n (8) 債務の整理を債権者に通知したとき\n (9) 解散若しくは清算に入ったとき\n (10) 事業を廃止したとき、又は事業を停止したとき\n (11) 当社に対する他の債務の履行を怠ったとき\n (12) 第29条に違反したことが判明し、又は違反に至ったとき（これらの事実についての報道や捜査機関からの情報提供がされた場合を含みます）\n2. 前項によって利用契約を解除したときは、当社は、本サービスの提供の中止、及び本サービスへのアクセスができないようにする措置を行うことができます。また契約企業は当社に対する一切の債務につき期限の利益を失います。\n3. 契約企業につき第1項各号のいずれかの事由に該当する疑いが生じた場合、当社は、当該事由が解消されるまで、前項の措置を取ることができます。\n4. 契約企業は、前二項にかかる本サービスの提供の中止、又は前二項の措置によって何らかの損害を被っても、当社に対して賠償又は補償を求めることはできません。\n第26条（本サービスの廃止）\n1. 当社は、当社の都合により本サービスの全部、又は主要な一部を廃止することができます。なお、本サービスの機能のうち主要な部分の廃止以外の廃止については、第16条1項に定める変更の規定を適用します。\n2. 当社は、前項の規定により本サービスの全部の廃止を行う場合には、3か月前までに告知し、かつ契約企業等に通知等をなします。廃止の効力は、告知において定めた日に生じます。\n3. 前項にかかわらず、当社が以下に該当するとその裁量により判断する場合は、廃止日までの期間を任意に短縮することができます。\n (1) 本サービスにつき、第三者から知的財産権等を侵害する旨主張があり、又は当社が侵害の原因があると認め、当該侵害の回避のために本サービスの廃止が必要な場合\n (2) 商業的又は技術的な理由から、本サービスの提供が不可能又は困難となった場合\n4. 契約企業は、前各項にかかる本サービスの廃止によって何らかの損害を被っても、当社に対して賠償又は補償を求めることはできません。\n第27条（不可抗力）\n 天災地変（大地震、津波、台風、高潮、落雷、竜巻、洪水を含みます）、戦争（宣戦布告の有無を問いません）、内乱、暴動、革命、内外法令の制定・改廃、行政若しくは司法機関による命令・処分・指導、感染症の流行若しくは拡大（それに基づく政府による命令や要請を含みます）、争議行為、異常・計画停電、極度のエネルギー不足、ネットワーク回線の障害、その他当社の合理的な制御を超えた事由を原因とする、本サービス提供の遅滞、不完全履行又は履行不能については、当社は一切の責を負いません。また、本サービスの運営の委託先に生じた不可抗力事由についても同様とします。\n第28条（遅延損害金・損害賠償）\n1. 契約企業が当社に対する利用料金又はその他の債務の履行を怠った場合、当社に対し、当該履行日の翌日から支払済まで年14％の遅延損害金を支払います（1年を365日として計算します）。\n2. 契約企業が本利用規約等に違反した場合、又はその他契約企業の故意若しくは過失によって当社が損害を被ったときは、契約企業は、当社に対して賠償をするものとします。\n第29条（反社会的勢力の排除）\n1. 当社と契約企業は、自ら並びにその主要株主、役員及び主要従業員が、過去5年間、現在及び将来にわたって、以下の事項につき表明・保証します。\n (1) 反社会的勢力、又はその構成員若しくは準構成員でないこと\n (2) 反社会的勢力による経営への支配若しくは実質的な関与がないこと\n (3) 反社会的勢力と、資金提供、便宜供与、継続的取引、若しくはその他社会的に非難されるべき関係がないこと\n (4) 反社会的勢力の威力を明示・暗示して、他者に要求行為を行ったことがないこと\n2. 各当事者は、自ら又は第三者を利用して、暴力的若しくは脅迫的な要求行為、法的な責任を超えた不当な要求行為、風説の流布、又は偽計若しくは威力を用いた相手方の信用毀損若しくは業務妨害行為を行いません。\n第30条（通知等）\n1. 本利用規約等において別段の明示的な定めがない限り、当社から個々の契約企業への通知等は、契約企業が当社に届け出た契約企業情報に含まれる電子メールアドレス連絡先のいずれかに対する郵送、電子メールの送信又はファクシミリ送信をもって行います。\n2. 契約企業は、契約企業情報に変更が生じた場合、速やかに当社が定める方法によって当社に届け出ます。契約企業が契約企業情報について変更の届出をしなかった場合には、当社は、変更前の連絡先に通知等をすることができます。\n3. 当社から契約企業への通知等は、前二項によって当社に届け出られた連絡先に行った場合、当社からの発信の時点をもって到達したものとみなします。\n第31条（本利用規約等の変更）\n1. 以下のいずれかの場合、当社は随時、本利用規約等を変更することがあります。\n (1) 本利用規約等の変更が、契約企業の一般の利益に適合するとき\n (2) 本利用規約等の変更が、本サービスの目的に反せず、かつ、変更の必要性、変更後の内容の相当性、変更の内容その他の変更に係る事情に照らして合理的なものであるとき\n2. 変更については、効力発生日の1週間前までに、変更後の内容と効力発生日について、適宜の方法で告知します。\n3. 契約企業は、本サービスの利用にあたっては、本利用規約等を随時閲覧し、内容を確認します。本利用規約等が変更された後の本サービスの提供条件は、変更後の本利用規約等によります。\n第32条（権利の譲渡等）\n1. 契約企業は、利用契約上の地位、並びに利用契約に基づく一切の権利義務を第三者に譲渡、担保差入、又はその他形態を問わず処分することはできません。\n2. 当社は、事業譲渡その他の事業再編のために、利用契約上の地位を第三者に譲渡することができます。契約企業は、予めその旨を承諾します。\n第33条（準拠法及び合意管轄裁判所）\n1. 本サービスの利用に関する法律関係並びに本利用規約等の解釈は、日本法に準拠します。\n2. 本サービスに関連する当社と契約企業との紛争については、原因のいかんを問わず、訴額に応じ、東京地方裁判所又は東京簡易裁判所を第一審の専属的管轄裁判所とするほか、これらの裁判所を民事調停の合意管轄裁判所とします。\n第34条（存続規定）\n 契約企業と当社との利用契約が終了した後も、本利用規約、第4条3項、第6条3項、第7条2項、第10条、第11条、第12条、第14条、第15条、第16条2項、第17条2項、第18条2項、第19条から第23条、第25条2項及び4項、第26条4項、第27条から第30条、並びに第32条から第34条の規定は、当該契約企業に適用されます。また本サービスが廃止された後も、これらの規定は有効に存続します。",
    "privacy_policy_content": "Make House株式会社（以下「当社」といいます。）は、お客様の個人情報に関する法令を遵守し、以下に示すポリシーに従い、適切な取扱い及び保護に努めます。\n1. 個人情報の定義\n 個人情報とは、個人に関する情報であり、お名前、生年月日、性別、電話番号、電子メールアドレス、職業、勤務先等、特定の個人を識別し得る情報をいいます。\n2. 個人情報の収集・利用\n 当社は、以下の目的のため、その範囲内においてのみ、個人情報を収集・利用いたします。\n 当社による個人情報の収集・利用は、お客様の自発的な提供によるものであり、お客様が個人情報を提供された場合は、当社が本方針に則って個人情報を利用することをお客様が許諾したものとします。\n- ご注文された当社の商品をお届けするうえで必要な業務\n- 新商品の案内など、お客様に有益かつ必要と思われる情報の提供\n- 業務遂行上で必要となる当社からの問い合わせ、確認、およびサービス向上のための意見収集\n- 各種のお問い合わせ対応\n3. 個人情報の第三者提供\n 当社は、法令に基づく場合等正当な理由によらない限り、事前に本人の同意を得ることなく、個人情報を第三者に開示・提供することはありません。\n4. 委託先の監督\n 当社は、お客様へ商品やサービスを提供する等の業務遂行上、個人情報の一部を外部の委託先へ提供する場合があります。その場合、業務委託先が適切に個人情報を取り扱うように管理いたします。\n5. 個人情報の管理\n 当社は、個人情報の漏洩、滅失、毀損等を防止するために、個人情報保護管理責任者を設置し、十分な安全保護に努め、また、個人情報を正確に、また最新なものに保つよう、お預かりした個人情報の適切な管理を行います。\n6. 情報内容の照会、修正または削除\n 当社は、お客様が当社にご提供いただいた個人情報の照会、修正または削除を希望される場合は、ご本人であることを確認させていただいたうえで、合理的な範囲ですみやかに対応させていただきます。\n7. セキュリティーについて\n 当社では、ジオトラスト社発行のサーバ証明書によるSSL（Secure Sockets Layer）暗号化技術を用いて、お客様の情報が送信される際の通信を暗号化しております。",
    "login_terms_agreement": "利用規約およびプライバシーポリシーに同意の上、ログインしてください。",
    "terms_update_title": "規約が更新されました",
    "terms_update_desc": "利用規約およびプライバシーポリシーが更新されました。内容を確認し、同意してから続行してください。",
    "terms_update_checkbox": "更新後の利用規約およびプライバシーポリシーを確認し、同意します。",
    "terms_update_accept": "同意して続行",
    "terms_update_decline": "同意せずログアウト",
    "terms_update_accept_failed": "同意状態の保存に失敗しました。もう一度お試しください。",
    "google_login": "Googleでログイン",
    "info_confirm_title": "情報確認",
    "info_confirm_desc": "会員への登録には利用規約およびプライバシーポリシーへの同意が必要です。",
    "agree_and_register": "同意して続行",
    "register": "登録",
    "go_to_credit_card": "同意して登録",
    "edit_information": "情報を修正する",
    "credit_card_title": "サブスクリプション案内",
    "credit_card_payment_type": "サブスクリプション詳細",
    "complete_credit_card": "サブスクリプションへ進む",
    "skip_subscription_login": "サブスクリプションをスキップしてログインへ進む",
    "redirecting_to_payment": "登録中",
    "registration_complete": "登録完了!",
    "first_billing_date": "初回請求日は{monthNumber}月{dayNumber}日",
    "go_to_project_list": "プロジェクト一覧へ"
  },
  "platform": {
    "intelli_design": "インテリジェント設計",
    "change_password": "パスワード変更",
    "admin_page": "管理者ページ",
    "log_out": "ログアウト",
    "my_project": "マイプロジェクト",
    "shearwall_design": "耐震壁設計",
    "frame_design": "フレーム構造設計",
    "frame_core_desgin": "フレーム - コアチューブ設計",
    "cad_plugin": "CAD前後処理プラグイン",
    "tool_download": "パラメトリックモデリングツールダウンロード",
    "order_list": "マイ注文"
  },
  "project": {
    "enter_project_title": "プロジェクトを検索",
    "enter_project_name": "プロジェクト名を入力してください",
    "enter_project_name_to_search": "検索するプロジェクト名を入力してください",
    "shearwall_project": "耐震壁プロジェクト",
    "import_project": "プロジェクトをインポート",
    "creat_project": "新規プロジェクト",
    "add_shearwall_design": "耐震壁設計を追加",
    "add_shearwall_tips": "（典型的な事例から「入力建築データ(.json)」をダウンロードして試用してください）",
    "project_name": "プロジェクト名",
    "vector_data": "ベクターデータ",
    "component_img": "建築部材図",
    "space_img": "建築空間図",
    "correct_project_title_format": "プロジェクト名は英字、数字、またはアンダースコアである必要があります",
    "choose_component_img": "建築部材図を選択してください",
    "choose_space_img": "建築空間図を選択してください",
    "choose_json_file": "json形式のファイルを選択してください",
    "input_archi": "建築部材図を入力",
    "download_input_image": "入力画像をダウンロード",
    "edit_input_image": "入力画像を編集",
    "click_design_to_generate_this_image": "設計をクリックしてこの画像を生成",
    "design_button_tips": "設計ボタンをクリックして出力設計を取得",
    "click_design_button_to_get_output_design": "設計ボタンをクリックして出力設計を取得",
    "shearwall_pic_instruct": "耐震壁-梁構造設計（赤い軸線は耐震壁、青い軸線は梁）",
    "diffusion_model": "拡散モデル設計構造図",
    "material_predict": "材料使用量インテリジェント予測",
    "GAN_pic": "GAN設計構造図",
    "GNN1_pic": "GNN1設計構造図",
    "GNN2_pic": "GNN2設計構造図",
    "Latest_test_version": "最新テスト版設計構造図",
    "AlgorithmA": "アルゴリズムA設計構造図",
    "AlgorithmB": "アルゴリズムB設計構造図",
    "AlgorithmC": "アルゴリズムC設計構造図",
    "design_structure_image": "設計構造画像",
    "shearwall": "耐震壁",
    "beam": "梁",
    "material_usage": "材料使用量",
    "downloadJOSN": "jsonデータをダウンロード",
    "case_legend": "*図の説明：灰色の軸線は建築壁、緑色の軸線はドアと窓、赤色の軸線は耐震壁、青色の軸線は梁",
    "archi_floor": "建築標準階",
    "GAN_floor": "GANモデル構造標準階",
    "GNN1_floor": "GNN1モデル構造標準階",
    "GNN2_floor": "GNN2モデル構造標準階",
    "Diffusion_floor": "拡散モデル構造標準階",
    "architectural_rendering_project": "建築レンダリングプロジェクト",
    "add_architectural_rendering": "建築レンダリングを追加",
    "add_architectural_rendering_project": "プロジェクトを作成",
    "load_project_failed": "プロジェクトの読み込みに失敗しました",
    "add_rendering_tips": "建物の画像と背景画像をアップロードし、詳細なレンダリング要件を記入してください",
    "house_image": "建物画像",
    "background_image": "背景画像",
    "time_period": "シーン時間",
    "render_prompt": "レンダリングプロンプト",
    "choose_house_image": "建物画像を選択してください",
    "choose_background_image": "背景画像を選択してください",
    "choose_time_period": "シーン時間を選択してください",
    "enter_render_prompt": "レンダリングプロンプトを入力してください",
    "project_name_max_50": "プロジェクト名は50文字を超えることはできません",
    "prompt_min_10": "プロンプトは10文字未満にすることはできません",
    "only_image_file": "JPG/PNG形式の画像のみサポート",
    "image_size_max_50M": "画像サイズは50MBを超えることはできません",
    "create_project_success": "レンダリングプロジェクトの作成に成功しました",
    "create_project_failed": "レンダリングプロジェクトの作成に失敗しました",
    "render_success": "レンダリング完了！",
    "render_failed": "レンダリングに失敗しました。再試行してください",
    "load_detail_failed": "プロジェクト詳細の読み込みに失敗しました",
    "Architectural_Rendering_desgin": "建築レンダリング設計",
    "edit_input_design": "入力設計を編集",
    "edit_beam_design": "梁・スラブ設計を編集",
    "edit_shearwall_design": "耐震壁設計を編集",
    "shearwall_design_image": "耐震壁構造設計画像",
    "shearwall_design_file_name": "耐震壁設計ファイル名",
    "shearwall_component_design": "耐震壁部材設計",
    "space_layout_image": "建築空間レイアウト画像",
    "space_layout": "建築空間レイアウト",
    "vector_reference": "ベクター参照",
    "design_list": "設計リスト",
    "add_design": "設計を追加",
    "beam_design_method": "梁設計方法",
    "boundary_length": "連結梁とフレーム梁の境界長さ",
    "beam_height_max": "梁高さ(最大)",
    "beam_height_min": "梁高さ(最小)",
    "condition_n": "条件 {n}",
    "enter_beam_design_method": "梁設計方法を入力してください",
    "choose_structure_image": "構造設計画像を選択してください",
    "choose_space_layout_image": "建築空間レイアウト画像を選択してください",
    "enter_boundary_length": "境界長さを入力してください",
    "enter_beam_height_min": "最小梁高さを入力してください",
    "enter_beam_height_max": "最大梁高さを入力してください",
    "please_select_condition_n": "条件 {n} を選択してください",
    "add_beam_design": "梁・スラブ設計を追加",
    "input_data_visualization": "入力データ可視化",
    "output_image": "出力画像",
    "project_title": "プロジェクトタイトル",
    "seismic_intensity": "耐震設計烈度",
    "seismic_intensity_with_unit": "設計烈度(g)",
    "architectural_floor_plan": "建築平面図",
    "building_structure_height": "建築構造高さ",
    "structure_total_height_with_unit": "構造総高さ(m)",
    "building_component_image": "建築構成要素図",
    "building_space_image": "建築空間図",
    "design_seismic_group": "設計地震グループ",
    "earthquake_group": "地震グループ",
    "site_category": "サイトカテゴリ",
    "basic_wind_pressure": "基本風圧",
    "wind_pressure": "基準風圧",
    "ground_roughness": "地表面粗さ",
    "structure_total_height": "構造の総高さ",
    "standard_floor_elevation": "標準階高さ",
    "standard_floor_wall_column_layout": "標準階壁柱配置",
    "add_core_tube_component_design": "コアチューブコンポーネント設計を追加",
    "edit_core_tube_component_design": "コアチューブコンポーネント設計を編集",
    "core_tube_file_download_operations": "コアチューブファイルダウンロード操作",
    "core_tube_file_download_info": "コアチューブファイルダウンロード情報",
    "component_dimension_diagram": "コンポーネント寸法図",
    "modeling_data": "モデリングデータ",
    "please_upload_csv_file": "CSVファイルをアップロードしてください！",
    "download_input_data_vis": "入力データ可視化をダウンロード",
    "download_output_design": "出力設計をダウンロード",
    "component_layout_image": "部材配置図",
    "component_size_image": "部材寸法図",
    "model_data": "モデリングデータ",
    "edit_core_section_design": "フレーム・コア筒部材断面設計を編集",
    "input_image": "入力画像",
    "core_tube_project": "フレーム - コアチューブプロジェクト",
    "enter_project_id": "プロジェクトIDを入力してください",
    "project_id": "プロジェクトID",
    "not_designed_yet": "現在のプロジェクトは未設計です！",
    "download_diffusion_sizes": "拡散モデル生成寸法をダウンロード",
    "download_gnn_sizes": "GNN生成寸法をダウンロード",
    "download_yjk_model_file": "YJKモデリングファイルをダウンロード",
    "download_pkpm_model_file": "PKPMモデリングファイルをダウンロード",
    "view_opt_before": "最適化前の指標を表示",
    "download_opt_before_model": "最適化前モデルをダウンロード",
    "view_opt_after": "最適化後の指標を表示",
    "download_opt_after_model": "最適化後モデルをダウンロード",
    "design_time": "設計時刻",
    "design_duration_seconds": "設計所要時間(s)",
    "create_time": "作成時間",
    "enter_standard_floor_height": "標準階高さを入力してください",
    "enter_floor_width": "平面幅を入力してください",
    "enter_floor_length": "平面長さを入力してください",
    "enter_material_grade": "材料等級を入力してください",
    "design_info": "設計情報",
    "frame_design_file_name": "フレーム設計ファイル名",
    "frame_beam_design": "フレーム梁設計",
    "section_size_design": "断面寸法設計",
    "mechanical_calculation_results": "力学計算結果"
  },
  "product": {
    "core_tube_product_intro": "フレーム - コアチューブ 製品紹介",
    "click_to_buy": "クリックして購入",
    "core_tube_component_design": "フレーム - コアチューブ コンポーネント設計",
    "buy_now": "今すぐ購入"
  },
  "cases": {
    "case_intro": "事例紹介",
    "input_pixel_diagram": "入力ピクセル図",
    "click_to_download_data": "ベクターデータをダウンロード",
    "engineer_design_pixel_diagram": "エンジニア設計ピクセル図",
    "StructGAN_design_pixel_diagram": "StructGAN設計ピクセル図",
    "StructGAN_design_model": "StructGAN設計計算モデル",
    "input_data": "入力データ",
    "engineer_design": "エンジニア設計",
    "StruGAN_design": "StruGAN設計",
    "input": "入力",
    "interpretation": "解釈",
    "input_example": "以下の規則例を入力してみてください：",
    "case1_title": "事例1の紹介：",
    "case1_tips": "建築構造高さ75m、階高3m、全25階、耐震設計強度8度（0.20g）、敷地特性周期0.4s。",
    "case2_title": "事例2の紹介：",
    "case2_tips": "建築構造高さ81m、階高3m、全27階、耐震設計強度7度（0.10g）、敷地特性周期0.45s。",
    "case3_title": "事例3の紹介：",
    "case3_tips": "建築構造高さ54m、階高3m、全18階、耐震設計強度7度（0.10g）、敷地特性周期0.35s。",
    "case4_title": "事例4の紹介：",
    "case4_tips": "建築構造高さ54m、階高3m、全18階、耐震設計強度6度（0.05g）、敷地特性周期0.45s。",
    "case5_title": "事例5の紹介：",
    "case5_tips": "建築構造高さ78m、階高3m、全26階、耐震設計強度7度（0.10g）、敷地特性周期0.4s。",
    "case6_title": "事例6の紹介：",
    "case6_tips": "建築構造高さ54m、階高3m、全18階、耐震設計強度6度（0.05g）、敷地特性周期0.45s。",
    "case7_title": "事例7の紹介：",
    "case7_tips": "建築構造高さ54m、階高3m、全18階、耐震設計強度6度（0.05g）、敷地特性周期0.45s。",
    "case8_title": "事例8の紹介：",
    "case8_tips": "建築構造高さ99m、階高3m、全33階、耐震設計強度7度（0.10g）、敷地特性周期0.35s。",
    "case9_title": "事例9の紹介：",
    "case9_tips": "建築構造高さ51m、階高3m、全17階、耐震設計強度7度（0.10g）、敷地特性周期0.4s。",
    "case10_title": "事例10の紹介：",
    "case10_tips": "建築構造高さ51m、階高3m、全17階、耐震設計強度7度（0.10g）、敷地特性周期0.4s。"
  },
  "about": {
    "company_intro": "会社紹介",
    "company_intro_content1": "Hemu Zhigouは2022年3月に設立され、建設業界の非効率な現状を改善し、土木工学のデジタル化とインテリジェント化を支援することに専念しています。",
    "company_intro_content2": "Hemu Zhigouは、設計図面、設計条件、設計規範、構造力学などのData-DrivenとAI for Scienceに基づくインテリジェント設計の主要技術を独自に開発し、各主要設計要素をカバーする一連の特許を取得し、経験学習と力学分析能力を備えた建築構造生成型インテリジェント設計製品を形成しました。この技術は、複雑な標準規範要件に適合する構造計画設計タスクを自動的に完了でき、AI設計の材料使用量はエンジニア設計と同等であり、建築構造設計時間を10倍以上短縮し、エンジニアの作業量を50%以上削減します。",
    "company_intro_content3": "将来的には、建築工学、新インフラ、交通、エネルギー建設に全く新しい設計パラダイムと生産モデルをもたらします。",
    "hemu_team": "Hemuチーム",
    "hemu_team_content": "構造設計+AI賦能。清華大学土木系教授が率い、建築分野の著名な専門家と共同で設立し、トップクラスの研究チーム+ベテラン業界チームを形成しています。",
    "history": "発展の歴史",
    "awards": "栄誉資格",
    "quality_and_award": "資格&受賞",
    "quality": "革新型中小企業、北京市科学技術型中小企業",
    "research_process": "研究開発プロセス"
  },
  "contact": {
    "basic_info": "基本情報を記入",
    "name": "氏名",
    "input_name": "氏名を入力してください",
    "unit": "組織",
    "input_unit": "組織を入力してください",
    "email": "メールアドレス",
    "input_email": "メールアドレスを入力してください",
    "contact_phone": "連絡先電話",
    "input_phone": "電話番号を入力してください",
    "question_detail": "問題の詳細",
    "input_question_detail": "問題の詳細を入力してください",
    "other_suggestion": "その他の問題または改善提案",
    "input_suggestion": "提案を入力してください",
    "product_please_contact": "製品使用に関する問題は、お問い合わせください：",
    "hemu_please_contact": "Hemu製品/ソリューションに興味がある、またはその他の協力を希望する場合は、お問い合わせください：",
    "name_length_limit": "長さは2〜5文字",
    "incorrect_email": "メール形式が正しくありません",
    "incorrect_phone": "電話番号形式が正しくありません",
    "contact_person": "連絡先：",
    "contact_email": "連絡先メール：",
    "cooperate": "協力",
    "communication_group": "AI-structure交流グループ",
    "QQ_group": "QQグループ：",
    "case_number": "登録番号：",
    "suggest_chrome": "より良い体験のために、Chromeブラウザでこのウェブサイトを閲覧することをお勧めします",
    "product_problem": "製品の問題",
    "coopetration": "ビジネス協力",
    "wechat": "（WeChatも同じ）"
  },
  "news": {
    "news": "ニュース",
    "news_title": "ニュースタイトル",
    "news_content": "ニュース内容",
    "learn_more": "詳細を見る",
    "more_news": "もっとニュースを見る",
    "known_more": "詳細を見る"
  },
  "admin": {
    "menu": {
      "data_analysis": "データ分析",
      "user_list": "ユーザーリスト",
      "project_overview": "プロジェクト一覧",
      "architectural_rendering_project": "建築画像レンダリングプロジェクト",
      "user_feedback": "ユーザーフィードバック",
      "campaign_code": "キャンペーンコード",
      "video_management": "動画管理"
    },
    "video": {
      "title": "動画管理",
      "subtitle": "デザイン中に表示される背景動画を管理します。アップロードすると現在の動画が上書きされます。",
      "current_video_title": "現在の動画",
      "uploaded_tag": "アップロード済み",
      "no_video": "動画がありません。トップページ動画をアップロードしてください。",
      "loading": "読み込み中...",
      "upload_title": "新しい動画をアップロード",
      "select_file": "動画ファイルを選択",
      "file_tip": "mp4 / mov / webm / avi 形式に対応、ファイルサイズは 500MB 以内",
      "uploading": "アップロード中...",
      "confirm_upload": "アップロードを確認",
      "exceed_limit": "一度にアップロードできる動画ファイルは1つのみです。選択したファイルを削除してください。",
      "confirm_dialog_title": "アップロードの確認",
      "confirm_dialog_content": "アップロードすると現在のトップページ動画が上書きされます。続けますか？",
      "upload_success": "動画のアップロードが完了しました！",
      "upload_failed": "アップロードに失敗しました。再試行してください",
      "upload_failed_network": "アップロードに失敗しました。ネットワーク接続を確認して再試行してください",
      "delete": "動画を削除",
      "delete_confirm_title": "削除の確認",
      "delete_confirm_content": "現在の動画を削除してもよろしいですか？削除後は復元できません。",
      "delete_success": "動画を削除しました",
      "delete_failed": "削除に失敗しました。後でもう一度お試しください"
    },
    "campaign_code": {
      "add": "キャンペーンコード追加",
      "refresh": "更新",
      "no_data": "キャンペーンコードがありません",
      "code_text": "コード",
      "points": "割引額（円）",
      "effective_time": "有効開始",
      "expire_time": "有効期限",
      "max_usage_count": "最大使用回数",
      "used_count": "使用回数",
      "created_at": "作成日時",
      "unlimited": "無制限",
      "add_dialog_title": "キャンペーンコード追加",
      "placeholder_code": "コードを入力",
      "placeholder_points": "割引額（円）を入力",
      "placeholder_effective_time": "有効開始日時を選択",
      "placeholder_expire_time": "有効期限を選択",
      "max_usage_tip": "0で無制限",
      "points_min": "ポイントは0以上にしてください",
      "rule_code_required": "コードを入力してください",
      "rule_points_required": "ポイントを入力してください",
      "rule_effective_time_required": "有効開始日時を選択してください",
      "rule_expire_time_required": "有効期限を選択してください",
      "add_success": "追加しました",
      "add_failed": "追加に失敗しました",
      "load_failed": "読み込みに失敗しました",
      "delete": "削除",
      "confirm_delete": "キャンペーンコード「{code}」を削除しますか？この操作は元に戻せません。",
      "delete_success": "削除しました",
      "delete_failed": "削除に失敗しました"
    },
    "news": {
      "edit_news_info": "ニュース情報を編集",
      "news_time_label": "ニュース日時",
      "news_link_label": "ニュースリンク",
      "news_image_label": "ニュース画像",
      "enter_title": "タイトルを入力してください",
      "enter_news_time": "ニュース日時を入力してください",
      "enter_news_link": "ニュースリンクを入力してください",
      "upload_news_image": "ニュース画像をアップロードしてください",
      "publish_success": "ニュースを公開しました！",
      "update_success": "ニュースを更新しました！",
      "rewrite": "書き直し"
    },
    "version": {
      "sort": "並び順",
      "sort_desc": "降順",
      "sort_asc": "昇順",
      "publish": "公開",
      "add": "追加",
      "publish_success": "バージョンを公開しました！",
      "publish_at": "公開日時",
      "version_number": "バージョン",
      "version_desc": "リリースノート",
      "publisher": "公開者",
      "publish_time": "公開時間",
      "edit_version_info": "バージョン情報を編集",
      "please_enter_version_number": "バージョン番号を入力してください",
      "please_enter_admin_name": "管理者名を入力してください",
      "please_enter_version_desc": "リリースノートを入力してください",
      "please_enter_content_max_chars": "内容を入力してください（最大{max}文字）",
      "please_complete_all_fields": "すべての情報を入力してください！",
      "upload_success": "アップロード成功！",
      "update_success": "バージョンを更新しました！",
      "rewrite": "リセット"
    },
    "message": {
      "publisher": "公開者",
      "publish_message": "メッセージ",
      "please_enter_admin_name": "管理者名を入力してください",
      "please_enter_message": "メッセージ内容を入力してください",
      "please_enter_message_limit": "メッセージ内容を入力してください（最大{max}文字）",
      "send_success": "送信に成功しました！",
      "please_fill_all_info": "すべての情報を入力してください！"
    },
    "user": {
      "enter_phone_username_account_to_search": "電話番号・ユーザー名・アカウントで検索してください",
      "search_placeholder": "検索可能：アカウント、所属、住所、メールアドレス",
      "reset": "リセット",
      "username": "ユーザー名",
      "name": "氏名",
      "company": "所属",
      "account": "アカウント",
      "organization": "所属",
      "phone_number": "電話番号",
      "user_type": "ユーザー種別",
      "password": "パスワード",
      "actions": "操作",
      "registered_at": "登録日時",
      "subscription_start_date": "購読開始日時",
      "sort_by": "並び順",
      "sort_by_registered": "登録日時",
      "sort_by_subscription_start": "購読開始日時",
      "sort_order": "順序",
      "sort_order_newest": "新しい順",
      "sort_order_oldest": "古い順",
      "total_projects": "プロジェクト総数",
      "cumulative_design_duration_seconds": "累計設計時間（秒）",
      "view_projects": "プロジェクトを表示",
      "view": "表示",
      "modify_permissions": "ユーザー種別を変更",
      "modify_user_permissions": "ユーザー種別を変更",
      "authority_type": "ユーザー種別",
      "option_general_user": "一般ユーザー",
      "option_admin": "最高管理者",
      "option_mh_member": "MH社員",
      "option_mh_partner": "MHパートナー",
      "render_admin": "レンダー管理者",
      "render_admin_hint": "最高管理者は既にレンダー管理画面へのアクセス権を持つため、個別設定は不要です",
      "set_render_admin": "レンダー管理者に設定",
      "cancel_render_admin": "レンダー管理者を解除",
      "set_render_admin_success": "レンダー管理者に設定しました",
      "cancel_render_admin_success": "レンダー管理者を解除しました",
      "filter_user_type": "ユーザー種別",
      "option_super_admin": "スーパー管理者",
      "address": "住所",
      "email": "メールアドレス",
      "credit_card": "クレジットカード番号",
      "delete_user": "アカウント削除",
      "delete_user_confirm": "このユーザーアカウントは完全に削除されます。続行しますか？",
      "delete_user_success": "ユーザーを削除しました！",
      "ban_wallet": "ウォレット凍結",
      "ban_wallet_success": "ウォレットを凍結しました！",
      "ban_wallet_confirm": "凍結すると、このユーザーは注文や設計ができなくなります。続行しますか？",
      "unban_wallet": "ウォレット凍結解除",
      "unban_wallet_success": "凍結を解除しました！",
      "unban_wallet_confirm": "このユーザーのウォレット凍結を解除しますか？",
      "wallet_status": "ウォレットステータス",
      "account_status": "アカウントステータス",
      "monthly_points": "月間ポイント",
      "permanent_points": "永久ポイント",
      "subscription_status": "サブスクリプション状態",
      "ban_account": "アカウント凍結",
      "unban_account": "アカウント凍結解除",
      "ban_account_confirm": "凍結されたアカウントはチャージと設計ができません。このアカウントを凍結しますか？",
      "unban_account_confirm": "このアカウントの凍結を解除しますか？",
      "ban_account_success": "アカウント凍結成功",
      "unban_account_success": "アカウント凍結解除成功",
      "adjust_monthly_points": "月間ポイント調整",
      "adjust_permanent_points": "永久ポイント調整",
      "enter_points": "ポイント",
      "points_must_be_positive": "ポイントは0より大きい必要があります",
      "increase": "増加",
      "decrease": "減少",
      "wallet_banned": "凍結中",
      "wallet_active": "正常",
      "modify_password_success": "ユーザーパスワードの変更に成功しました",
      "modify_authority_success": "ユーザー種別の変更に成功しました",
      "modify_user_info_success": "ユーザー情報の更新に成功しました",
      "modify_user_info_failed": "ユーザー情報の更新に失敗しました",
      "increase_monthly_points_success": "ユーザーの月間ポイントを {points} ポイント増加させました",
      "decrease_monthly_points_success": "ユーザーの月間ポイントを {points} ポイント減少させました",
      "increase_permanent_points_success": "ユーザーの永久ポイントを {points} ポイント増加させました",
      "decrease_permanent_points_success": "ユーザーの永久ポイントを {points} ポイント減少させました",
      "adjust_quota_limits": "利用上限を調整",
      "adjust_quota_limits_title": "AI デザイン利用上限の調整",
      "quota_limit_hint": "-1＝無制限、0＝利用不可、1 以上＝週次上限",
      "invalid_quota_limit": "上限は -1、0、または 1 以上の整数である必要があります",
      "update_quota_limits_success": "利用上限を更新しました",
      "update_quota_limits_failed": "利用上限の更新に失敗しました"
    },
    "project": {
      "title": "建築画像レンダリングプロジェクト",
      "search_placeholder": "検索",
      "reset": "リセット",
      "no_project_data": "プロジェクトデータがありません",
      "project_id": "プロジェクト ID：",
      "user": "ユーザー：",
      "create_time": "作成時間：",
      "idempotency": "べき等：",
      "order": "注文：",
      "input_info": "入力情報",
      "text_requirement": "テキスト要件",
      "style_setting": "スタイル設定",
      "output_size": "出力サイズ",
      "time_period": "時間帯",
      "max_images": "最大画像数",
      "input_reference_images": "入力参照画像",
      "load_failed": "読み込み失敗",
      "descriptive_image": "説明図",
      "main_reference_image": "メイン参照画像",
      "background_reference_image": "背景参照画像",
      "render_results": "レンダリング結果（最新10件）",
      "loading": "読み込み中...",
      "no_design_results": "設計結果がありません",
      "fetch_project_data_failed": "プロジェクトデータの取得に失敗しました",
      "project_data_load_failed": "プロジェクトデータの読み込みに失敗しました。後でもう一度お試しください"
    },
    "user_feedback": {
      "fields": {
        "user_request": "テキスト要件",
        "resolution": "解像度",
        "aspect_ratio": "アスペクト比",
        "angle": "画角",
        "wall_material": "外壁材質",
        "wall_width": "外壁幅",
        "wall_direction": "外壁方向",
        "wall_color": "外壁色",
        "window_material": "窓枠材質",
        "window_color": "窓枠色",
        "background_name": "背景",
        "time_period": "時間帯"
      },
      "images": {
        "main_reference": "メイン参照画像",
        "background_reference": "背景参照画像",
        "wall_reference": "外壁参照画像",
        "reference_1": "参照画像1",
        "reference_2": "参照画像2",
        "reference_3": "参照画像3"
      },
      "sections": {
        "generated_image": "生成画像"
      }
    }
  },
  "business": {
    "business_title": "主要事業",
    "business_content": "Hemu Zhigouは2022年3月に設立された科学技術企業で、土木工学関連分野に向けて、業界にデジタル化、インテリジェント化などの関連サービスを提供しています。現在、インテリジェント設計製品は2023年7月に公式サイトで発表され、900人のユーザーが登録して使用し、耐震壁住宅設計を3000件以上完了しました。当社は以下のサービスを提供できます：",
    "business_content1": "1、パーソナライズされた製品展開（プライベートクラウド展開、ローカルサーバー展開サービスを提供可能）",
    "business_content2": "2、カスタマイズ開発（ユーザーのニーズに応じて、関連する学際分野の生成型研究開発、パーソナライズされたデータトレーニングなどのサービスを含むがこれに限定されない、ターゲットを絞った開発作業を行うことができます）",
    "business_content3": "3、共同開発（上流および下流の各産業端と相互に接続し、協力してウィンウィンを実現できます）"
  },
  "render": {
    "header_title": "Make House",
    "header_ai_title": "AIリアルCG",
    "header_subtitle": "AI 建築レンダリング",
    "ratio_header_label": "画像サイズ\n選択",
    "detail_settings_label": "詳細設定",
    "detail_image_count_label": "枚数",
    "detail_resolution_label": "解像度",
    "detail_angle_label": "画角",
    "angle_same": "元と同じ",
    "angle_front": "正面",
    "angle_diagonal": "斜め",
    "input_section_title": "入力セクション",
    "input_section_desc": "画像をアップロードしてレンダリング設定を構成します",
    "upload_house_image": "画像アップロード",
    "background_image": "背景",
    "upload_collapse_label": "折りたたむ",
    "upload_expand_label": "展開",
    "detailed_instruction": "詳細指示（任意）",
    "content_other_title": "その他",
    "content_wall_title": "外壁",
    "content_window_title": "窓枠",
    "window_material": "材質",
    "window_color": "色",
    "wall_material": "材質",
    "wall_width": "幅",
    "wall_direction": "向き",
    "wall_color": "色",
    "none": "無",
    "open_color_picker": "カラーピッカーを開く",
    "reset_color": "リセット",
    "wall_material_galvalume": "ガルバリウム鋼板",
    "wall_material_wood_grain": "木目調",
    "wall_material_metal_siding": "金属サイディング",
    "wall_material_brick_block": "レンガ・ブロック",
    "wall_material_stone_tile": "石積み・タイル調",
    "wall_material_border_line": "ボーダー・ライン調",
    "wall_material_painted_wall": "塗り壁",
    "wall_width_wide": "幅広い",
    "wall_width_narrow": "細い",
    "wall_width_normal": "普通",
    "wall_direction_horizontal": "横張",
    "wall_direction_vertical": "縦張",
    "window_material_metal": "金属",
    "window_material_resin": "樹脂",
    "window_material_wood": "木",
    "drag_house_instruction": "立面図・建物の画像",
    "browse_text": "クリック・ドラッグ・貼り付け",
    "support_formats": "JPEG / PNG / WebP / PDF（50MB まで）",
    "paste_image": "画像を貼り付け",
    "clipboard_no_image": "クリップボードに画像が見つかりません",
    "clipboard_read_failed": "クリップボードの読み取りに失敗しました。ブラウザの権限を確認してください",
    "time_section_title": "スタイル",
    "time_morning_label": "朝",
    "time_morning_desc": "柔らかな黄金の光",
    "time_afternoon_label": "午後",
    "time_afternoon_desc": "明るい日光",
    "time_evening_label": "夕方",
    "time_evening_desc": "温かい夕日の輝き",
    "time_night_label": "夜",
    "time_night_desc": "月明かりの雰囲気",
    "time_midsummer_noon_label": "真夏の正午",
    "time_midsummer_noon_desc": " ",
    "time_cloudy_day_label": "曇りの日",
    "time_cloudy_day_desc": " ",
    "time_night_cityscape_label": "夜景",
    "time_night_cityscape_desc": " ",
    "time_minimalist_gray_label": "ミニマリストグレー",
    "time_minimalist_gray_desc": " ",
    "time_overcast_gray_label": "曇天グレー",
    "time_overcast_gray_desc": " ",
    "time_rainy_gray_label": "雨の日グレー",
    "time_rainy_gray_desc": " ",
    "time_spring_day_label": "春の日",
    "time_spring_day_desc": " ",
    "time_blue_hour_label": "ブルーアワー",
    "time_blue_hour_desc": " ",
    "time_post_rain_blue_hour_label": "雨上がりのブルーアワー",
    "time_post_rain_blue_hour_desc": " ",
    "time_sunset_glow_label": "夕焼け",
    "time_sunset_glow_desc": " ",
    "time_clear_tone_label": "クリア",
    "time_clear_tone_desc": " ",
    "time_golden_hour_label": "ゴールデンアワー",
    "time_golden_hour_desc": " ",
    "time_champagne_gold_label": "シャンパンゴールド",
    "time_champagne_gold_desc": " ",
    "time_bright_rainy_scene_label": "明るい雨景",
    "time_bright_rainy_scene_desc": " ",
    "add_background_images": "カスタム背景画像を1枚アップロード（既定背景を置き換えます）",
    "draw_edit_area_button": "画像を編集",
    "crop_input_button": "範囲を選ぶ",
    "crop_dialog_title": "使う範囲を選ぶ",
    "crop_dialog_title_pdf": "ページと範囲を選ぶ",
    "crop_dialog_pages": "使うページ",
    "crop_dialog_hint": "枠をドラッグして範囲を選べます。",
    "crop_dialog_reset": "全体に戻す",
    "crop_dialog_apply": "この範囲で使う",
    "crop_dialog_failed": "ファイルを読み込めませんでした。",
    "crop_dialog_loading": "読み込んでいます…",
    "delete_mask_button": "削除",
    "render_instructions_title": "レンダリング指示",
    "customize_instruction_title": "詳細<br>指示",
    "render_instructions_placeholder": "指示入力\n例：グレー部分の外壁は塗り壁／建物の前に白いジムニーを生成／玄関ドアは参考画像と同じく",
    "render_instructions_placeholder_line1": "指示入力",
    "render_instructions_placeholder_line2": "例：グレー部分の外壁は塗り壁／建物の前に白いジムニーを生成／玄関ドアは参考画像と同じく",
    "interior_render_instructions_placeholder_line2": "例：ソファを参考画像に変更して",
    "quick_templates_title": "⚡ クイックテンプレート:",
    "quick_template_1": "外壁材を参考画像と同じく",
    "quick_template_2": "外壁材は横方向の細かい黒い金属サイディング",
    "quick_template_3": "屋根に太陽光を設置",
    "quick_template_4": "ぼやけた歩行者を生成",
    "submit_start": "生成開始",
    "submit_submitting": "送信中…",
    "submit_submitting_do_not_close": "設計を送信中です。画面を閉じないでください",
    "designing": "設計中…",
    "cost_points_label": "消費ポイント:",
    "coin_cost_label": "今回の設計では {coins}{unit}のリソースを消費します",
    "coin_cost_loading": "必要な{unit}リソースを計算しています…",
    "coin_cost_unknown": "必要な{unit}リソースを取得できません",
    "image_resource_unit": "枚",
    "image_resource_point": "ポイント",
    "order_status_label": "注文ステータス: {status}",
    "output_section_title": "出力セクション",
    "output_section_desc": "AI が生成した建築レンダリング",
    "loading_title": "生成中…",
    "loading_desc": "数分かかる場合があります。お待ちください",
    "upscale_running": "解像度を上げています…",
    "placeholder_title": "ここにレンダリング結果が表示されます",
    "guide_upload_house": "建物画像をアップロード",
    "guide_select_time": "シーン時間を選択",
    "guide_add_backgrounds": "背景を追加",
    "guide_start_rendering": "レンダリング開始",
    "generated_desc": "生成完了: {time} シーン、背景 {count} 枚",
    "download_image": "画像をダウンロード",
    "download_quality_normal": "通常品質",
    "download_quality_high": "高品質",
    "download_quality_ultra": "最高品質",
    "download_quality_points": "{count}ポイント",
    "download_quality_normal_tooltip": "通常品質：SNS用に向け",
    "download_quality_high_tooltip": "高品質：印刷用に向け",
    "download_quality_ultra_tooltip": "最高品質：広告用に向け",
    "embedded_results_title": "生成結果",
    "embedded_settings_title": "設定",
    "embedded_quality_original": "原寸",
    "embedded_selected_count": "{count} 枚を選択中",
    "embedded_select_hint": "左上のチェックで選択 ・ 画像をクリックで拡大",
    "embedded_select_all": "すべて選択",
    "embedded_select_image": "選択",
    "embedded_clear_selection": "選択を解除",
    "embedded_download_selected": "選択した画像をダウンロード",
    "embedded_results_empty": "左の画像と設定で「生成開始」を押すと、ここに結果が並びます",
    "embedded_downloading_progress": "ダウンロード中 {done}/{total}",
    "embedded_upscaling_progress": "高画質化してダウンロード中 {done}/{total}",
    "embedded_capturing": "カメラの画像を撮影しています…",
    "embedded_capture_failed": "カメラの画像を撮影できませんでした。カメラの位置を確認して撮り直してください",
    "favorite_button": "お気に入り",
    "download_quality_upscale_todo": "高解像度ダウンロードは準備中です。",
    "drawing_text_preset_ldk": "LDK",
    "drawing_text_preset_master_bedroom": "主寝室",
    "drawing_text_preset_bedroom": "寝室",
    "drawing_text_preset_entrance": "玄関",
    "drawing_text_preset_porch": "ポーチ",
    "drawing_text_preset_toilet": "トイレ",
    "drawing_text_preset_bathroom": "浴室",
    "drawing_text_preset_dressing_room": "脱衣室",
    "drawing_text_preset_washroom": "洗面室",
    "drawing_text_preset_wic": "WIC",
    "drawing_text_preset_atrium": "吹抜",
    "generate_time_lapse_video_button": "時間変化動画を生成",
    "generate_time_lapse_video_points": "200ポイント",
    "share_result": "結果を共有",
    "share_todo": "共有機能は近日公開",
    "alt_house_preview": "建物画像プレビュー",
    "alt_background_preview": "背景画像プレビュー",
    "alt_render_placeholder": "レンダリングプレースホルダー",
    "alt_render_result": "生成されたレンダリング",
    "dialog_title": "レンダリング進行状況",
    "dialog_loading_spinner": "読み込み中…",
    "dialog_loading_desc": "レンダリング中です…",
    "dialog_success": "レンダリングが完了しました！",
    "dialog_failed": "レンダリングに失敗しました。再試行してください。",
    "dialog_back_to_list": "一覧に戻る",
    "dialog_cancel": "キャンセル",
    "dialog_download_result": "結果をダウンロード",
    "error_submit": "設計の送信に失敗しました。もう一度お試しください。",
    "error_result": "レンダリング結果の取得に失敗しました。",
    "error_design_busy": "現在サーバー側が大変混雑しています。恐れ入りますが、しばらくしてから再度お試しください。",
    "error_create_first": "まずプロジェクトを作成してください。",
    "session_occupied": "このアカウントは別のデバイスで AI Real CG を使用中です。",
    "session_takeover": "強制的に引き継ぐ",
    "session_leave": "離れる",
    "session_taken_over": "別のデバイスで AI Real CG の使用が開始されたため、このデバイスでの使用を終了しました。",
    "error_pricing_missing": "生成が失敗しました。",
    "error_house_image_load_failed": "元画像の読み込みに失敗しました。再度アップロードしてください。",
    "error_background_image_load_failed": "背景画像の読み込みが失敗しました。再度アップロードしてください。",
    "error_wall_image_load_failed": "外壁画像の読み込みが失敗しました。再度アップロードしてください。",
    "error_order_id_missing": "プロジェクトIDの作成は失敗しました。",
    "valid_project_id_required": "プロジェクトIDを入力してください。",
    "valid_upload_house": "元画像をアップロードしてください",
    "valid_upload_interior_input": "元画像をアップロードしてください",
    "valid_upload_background": "背景画像をアップロードしてください",
    "valid_select_time": "シーン時間を選択してください",
    "valid_prompt_min": "プロンプトは10文字以上にしてください",
    "style_realistic_label": "リアリスティック",
    "style_realistic_desc": "フォトリアルなレンダリング",
    "style_pencil_label": "鉛筆スケッチ",
    "style_pencil_desc": "手描き鉛筆スタイル",
    "style_marker_label": "マーカー",
    "style_marker_desc": "大胆なマーカースケッチスタイル",
    "style_watercolor_label": "水彩画",
    "style_watercolor_desc": "芸術的な水彩画",
    "style_model_label": "物理モデル",
    "style_model_desc": "建築模型風",
    "count_one_label": "1枚",
    "count_one_desc": "1枚の画像を生成",
    "count_three_label": "3枚",
    "count_three_desc": "3つのバリエーションを生成",
    "count_five_label": "5枚",
    "count_five_desc": "5つのバリエーションを生成",
    "bg_mountain_name": "自然",
    "bg_mountain_desc": "豊かな別荘地",
    "bg_urban_name": "住宅街",
    "bg_urban_desc": "緑と家並み",
    "bg_forest_name": "森",
    "bg_forest_desc": "静かな自然",
    "count_section_title": "生成する画像枚数",
    "style_section_title": "生成スタイル",
    "aspect_ratio_section_title": "アスペクト比と画像サイズ",
    "bg_choose_default": "デフォルト背景から1つを選択：",
    "bg_upload_own": "またはカスタム背景を1枚アップロード：",
    "bg_custom_placeholder_title": "任意の画像",
    "bg_custom_placeholder_desc": "敷地の写真など",
    "aspect_ratio_subtitle": "アスペクト比を選択（画像サイズは自動的に決定されます）：",
    "aspect_ratio_print_landscape": "印刷(横)",
    "aspect_ratio_presentation": "プレゼン",
    "aspect_ratio_square_feed": "フィード",
    "aspect_ratio_print_portrait": "印刷(縦)",
    "aspect_ratio_vertical_reel": "リール",
    "reference_image_subtitle": "参考画像をアップロード（オプション、最大3枚）：",
    "reference_image_title_only": "参考画像",
    "reference_image_optional": "（任意）",
    "reference_image_max_warning": "参考画像は最大3枚までアップロードできます。",
    "resolution_tooltip_1k": "一番速い · 10pt/枚",
    "resolution_tooltip_2k": "バランスよく · 20pt/枚",
    "resolution_tooltip_4k": "高品質 · 40pt/枚",
    "use_as_input": "元画像としてアップロード",
    "edit_result_image_button": "画像を編集",
    "object_rotate_tool": "オブジェクトを3Dで回す",
    "object_rotate_drag_hint": "家具をドラッグで移動、足元の黄色い環をドラッグで回転（赤の矢印＝左右だけ、緑の矢印＝上下だけ）",
    "object_rotate_no_plate": "背景を作れなかったため、動かすと元の位置に家具が残ります。回転だけなら問題ありません。",
    "object_rotate_plate_kept": "{labels} は背景から消せませんでした。動かすと元の位置にも残ります。",
    "object_rotate_scanning": "動かせるものを探しています…",
    "object_rotate_applied": "合成しました。「生成」で仕上げます",
    "object_rotate_pick_hint": "動かしたい家具の点を押してください（触れている家具も一緒に 3D になります）",
    "object_rotate_preparing": "3D を用意しています…",
    "object_rotate_prepared": "3D の用意ができました",
    "object_rotate_bring_forward": "前へ",
    "object_rotate_send_backward": "後ろへ",
    "object_rotate_building": "3Dに起こしています…",
    "object_rotate_failed": "3D化に失敗しました",
    "object_rotate_reselect": "選び直す",
    "object_rotate_mode_move": "移動",
    "object_rotate_mode_rotate": "回転",
    "object_rotate_mode_scale": "拡大縮小",
    "object_rotate_perspective": "遠近",
    "object_rotate_reset": "元に戻す",
    "object_rotate_apply": "確定",
    "feedback_issue": "フィードバック",
    "feedback_image_title": "フィードバック画像（入力パラメータから自動アップロード）",
    "feedback_description_label": "問題の説明",
    "feedback_description_placeholder": "発生した問題について詳しく説明してください...",
    "feedback_description_required": "問題の説明を入力してください",
    "feedback_submit": "送信",
    "feedback_submit_success": "フィードバックが送信されました",
    "feedback_submit_failed": "フィードバックの送信に失敗しました",
    "download_all": "すべてダウンロード",
    "result_sent_to_input": "生成した画像をインプットとして使用できます。",
    "no_result_to_send": "送信できる結果がありません",
    "failed_send_result_to_input": "生成した画像の送信は失敗しました",
    "recent_generations": "最近の生成",
    "generated_result": "{time}シーンで{count}枚の画像を生成しました",
    "history_empty": "履歴はまだありません",
    "history_tab_input": "入力",
    "history_tab_output": "出力",
    "history_preview_title": "画像プレビュー",
    "prompt_download_title": "",
    "prompt_download_desc": "",
    "prompt_download_button": "プロンプトをダウンロード",
    "prompt_download_success": "プロンプトをダウンロードしました",
    "prompt_download_empty": "ダウンロードできるプロンプト情報がありません",
    "favorite_add_success": "お気に入りに追加",
    "favorite_remove_success": "お気に入りを解除しました",
    "favorite_add_failed": "お気に入りに失敗",
    "favorite_remove_failed": "お気に入りの解除に失敗しました",
    "result_delete_button": "この結果を削除",
    "result_delete_confirm": "この生成結果を削除しますか？履歴とお気に入りから消え、元に戻せません。",
    "result_delete_success": "結果を削除しました",
    "result_delete_failed": "結果の削除に失敗しました",
    "ai_assistant_greeting": "👋 何かお手伝いできますか？",
    "ai_assistant_placeholder": "ご質問を入力してください...",
    "qa_float_ball_label": "ヘルプ",
    "interior_floorplan_title": "平面図画像アップロード",
    "interior_floorplan_heading": "スケッチ・CAD の平面図",
    "interior_room_title": "内装画像アップロード",
    "interior_room_heading": "スケッチ・写真",
    "interior_upload_methods": "クリック・ドラッグ・貼り付け",
    "interior_upload_formats": "JPEG / PNG / WebP / PDF（50MB まで）",
    "interior_or_divider": "または",
    "interior_style_title": "内装",
    "interior_style_japandi": "ジャパンディ",
    "interior_style_natural": "ナチュラル",
    "interior_style_simple_modern": "シンプルモダン",
    "interior_style_vintage": "ヴィンテージ",
    "interior_style_empty": "空室",
    "interior_style_none": "指定なし",
    "interior_style_none_desc": "3D モデルの家具をそのまま使う",
    "interior_style_custom": "カスタム",
    "interior_style_custom_placeholder_title": "任意のスタイル",
    "interior_style_custom_placeholder_desc": "お好みの画像をアップロード",
    "interior_style_canvas_title": "カスタムスタイル編集",
    "interior_style_canvas_save": "保存",
    "interior_style_canvas_cancel": "キャンセル",
    "interior_style_canvas_upload": "画像追加",
    "interior_style_canvas_add_text": "テキスト追加",
    "interior_style_canvas_delete": "削除",
    "interior_style_canvas_forward": "前面へ",
    "interior_style_canvas_backward": "背面へ",
    "interior_style_canvas_fit": "キャンバスに合わせる",
    "interior_style_canvas_hint": "クリックまたはドラッグで画像を追加",
    "interior_style_canvas_default_text": "名称を入力してください",
    "interior_style_canvas_edit": "編集",
    "interior_style_canvas_delete_confirm": "このボードを削除しますか？",
    "interior_style_canvas_name_label": "ボード名",
    "interior_style_canvas_name_placeholder": "ボード名を入力",
    "interior_style_canvas_rename": "名称変更",
    "interior_style_canvas_rename_prompt": "ボード名を入力してください",
    "interior_style_canvas_rename_title": "名称変更",
    "interior_style_canvas_name_max_length": "名称は128文字以内で入力してください",
    "interior_style_canvas_name_update_failed": "ボード名の更新に失敗しました",
    "style_canvas_save_failed": "ボードを保存できませんでした。もう一度保存してください。",
    "interior_style_canvas_default_name": "ボード {index}",
    "interior_style_canvas_layout_alt": "レイアウトボード",
    "interior_scenery_title": "風景",
    "interior_scenery_optional_hint": "（任意）",
    "only_image_file": "JPEG/PNG/WebP 画像のみサポート",
    "image_size_max_50M": "画像サイズは50MBを超えないでください",
    "interior_style_chooser_title": "新規ボード作成",
    "interior_stylized_title": "スタイル<br>選択",
    "interior_stylized_sketch": "スケッチ",
    "interior_stylized_watercolor": "水彩",
    "interior_stylized_realism": "リアル",
    "facade_style_canvas_title": "外構",
    "facade_style_canvas_chooser_title": "新規ボード",
    "facade_layout_test1": "ボード 1",
    "facade_layout_test2": "ボード 2",
    "facade_layout_test3": "ボード 3"
  },
  "payment": {
    "wechat_pay": "WeChat Pay",
    "payment_success": "支払いに成功しました！",
    "continue_payment": "支払いを続ける",
    "delete_order": "注文を削除",
    "product_name": "製品名",
    "create_time": "作成時刻",
    "payment_status": "支払い状況",
    "unpaid": "未払い",
    "paid": "支払い済み",
    "payment_amount": "支払い金額",
    "order_number": "注文番号"
  },
  "user": {
    "username": "ユーザー名"
  },
  "usage": {
    "enter_number_of_layers": "Please enter number of stories (superstructure)",
    "enter_floor_height_m": "Please enter story height (unit: m)",
    "enter_basic_design_acceleration": "Please enter basic design acceleration",
    "enter_site_category": "Please enter site category",
    "enter_earthquake_grouping": "Please enter seismic grouping"
  },
  "docs": {
    "title": "使い方マニュアル",
    "expand_menu": "目次を開く",
    "collapse_menu": "目次を閉じる",
    "loading": "マニュアルを読み込んでいます…",
    "load_failed": "マニュアルを読み込めませんでした",
    "retry": "再試行",
    "back_to_app": "メイン画面へ戻る",
    "copied": "コピーしました",
    "copy_failed": "コピーできませんでした",
    "image_preview": "画像の拡大表示",
    "audience_ai": "AI real CG ユーザー向け",
    "audience_partner": "BS加盟店向け",
    "audience_mh": "MH社員・案件担当者・管理者向け",
    "catalog": {
      "group_ai": "AI real CG",
      "ai_overview": "使い方マニュアル トップ",
      "ai_intro": "第1章 はじめに",
      "ai_facade": "第2章 外観CGをつくる",
      "ai_interior": "第3章 内観CGをつくる",
      "ai_3d": "第4章 3D機能からCGをつくる",
      "ai_edit": "第5章 画像を編集する",
      "ai_export": "第6章 書き出す・動画にする",
      "ai_usage": "第7章 活用方法",
      "ai_trouble": "第9章 困ったとき",
      "ai_subscription": "第8章 サブスクリプションと利用回数",
      "group_partner": "商品資料・案件依頼（BS加盟店）",
      "case_overview": "メイン画面",
      "case_catalog": "商品資料ライブラリ",
      "case_create": "案件を依頼する",
      "case_structure_calc": "構造計算を依頼する",
      "case_detail": "案件詳細と進行",
      "group_mh": "案件管理・商品管理・権限（MH社員）",
      "mh_roles": "ロールと権限の考え方",
      "mh_accounts": "アカウント発行と権限設定",
      "mh_cases": "案件の進行管理",
      "mh_contractors": "外注の登録と承認",
      "mh_products": "商品管理（商品資料・タグ）",
      "mh_statistics": "統計",
      "mh_settings": "設定・操作ログ・管理者ページ"
    }
  },
  "case": {
    "onboarding": {
      "ui": {
        "skip": "スキップ",
        "next": "次へ",
        "back": "戻る",
        "start": "利用開始",
        "close": "閉じる",
        "help": "使い方"
      },
      "cases": {
        "menu": {
          "title": "すべての案件",
          "body": "ご依頼済みの案件はここに集まります。進行中・完了を問わず、過去の案件もこの一覧から確認できます。"
        },
        "create": {
          "title": "案件作成",
          "body": "新しい案件を登録するときは、このボタンから始めます。入力は4ステップ、15分ほどで完了します。"
        },
        "list": {
          "title": "案件の状態を確認する",
          "body": "カードには工事名称と「ステータス：第◯段階…・担当者」が表示されます。ステータスは基本設計・確認申請・実施設計の3段階のうち、どこまで進んだかを示します。"
        },
        "search": {
          "title": "案件を探す",
          "body": "案件が増えてきたら工事名称で検索できます。作成時に「施主名＋工事区分」の形で名前を付けておくと見つけやすくなります。"
        },
        "filters": {
          "title": "絞り込みと表示切替",
          "body": "ステータス・優先度・依頼日、未読メッセージの有無で案件を絞り込めます。右側の切替ボタンで、カード表示と、案件名・依頼日・ステータスが並ぶ一覧表示を行き来できます。"
        },
        "user": {
          "title": "アカウント情報",
          "body": "会社名・ご担当者名・連絡先はここで確認できます。この内容が案件作成時に自動で反映されます。"
        }
      },
      "create0": {
        "stepper": {
          "title": "入力は4ステップ",
          "body": "基本情報 → 商品・敷地情報 → 設備・インフラ → 建物・プラン希望 の順に進みます。現在地はここで確認できます。"
        },
        "terms": {
          "title": "2つの同意が必要です",
          "body": "利用約款とプライバシーポリシー、両方にチェックを入れないと次へ進めません。約款には契約成立のタイミングと検収の条件が定められています。"
        },
        "company": {
          "title": "会社情報は自動で入ります",
          "body": "会社名はアカウント登録情報から自動で反映され、変更できません。ご担当者名・連絡先が古い場合は、この場で修正してください。"
        },
        "projectname": {
          "title": "工事名称は一意に",
          "body": "「施主名＋工事区分」の形でご記入ください（例：山田邸 新築工事）。あとで案件一覧から探すときの手がかりになります。"
        }
      },
      "create1": {
        "product": {
          "title": "商品は左の丸で選びます",
          "body": "商品名や画像をクリックすると拡大プレビューが開くだけで、選択されません。行の左端にある丸をクリックしてください。選択されると行が黄色く囲まれます。"
        },
        "cost": {
          "title": "建物本体コストは選択式",
          "body": "自由入力ではなくプルダウンです。1500万円以下から3000万円以上まで、100万円刻みの16段階からお選びください。"
        },
        "attachments": {
          "title": "添付は任意ですが、あると早く進みます",
          "body": "この5枠は未添付でも送信できます。ただし下の法規項目はすべて必須で、その多くは重要事項説明書から転記できます。"
        },
        "zoning": {
          "title": "該当がなくても「なし」を選んでください",
          "body": "用途地域・防火指定・その他の地域地区・地区計画は、いずれも必須です。該当がない場合は「なし」「指定なし」を選択しないとエラーになります。"
        }
      },
      "create2": {
        "lifeline": {
          "title": "ライフラインの状況",
          "body": "水道・ガス・電気・汚水・雑排水・雨水の6項目です。「敷地内桝あり／なし」の別は外構計画と工事費に直結します。不明な場合は現地でご確認ください。"
        }
      },
      "create3": {
        "priority": {
          "title": "優先順位は1つだけ",
          "body": "項目名は「優先順位」ですが、入力形式は単一選択です。複数の順位づけはできません。最も重視される点を1つお選びください。"
        },
        "freetext": {
          "title": "ご要望はここに具体的に",
          "body": "間取りで外せない条件と、施主様の強いご希望をご記入ください。「2階にトイレ必須」「仏間を1階南側に」といった粒度が理想です。"
        },
        "submit": {
          "title": "送信＝契約成立ではありません",
          "body": "「案件を作成」はお申込みです。弊社より見積をご提示し、ご承諾いただいた時点で契約成立となります。社内確認が必要な場合は「一時保存」をお使いください。"
        }
      },
      "library": {
        "products": {
          "title": "ご購入済みの商品はここに",
          "body": "ご契約中の商品が一覧に並びます。商品名をクリックすると、その商品に紐づく資料が表示されます。"
        },
        "types": {
          "title": "資料の種類から探す",
          "body": "プラン集・イメージパースなど、資料種類ごとにもまとめて確認できます。"
        },
        "tags": {
          "title": "タグで絞り込む",
          "body": "平屋・2階建て・ガレージなどのタグで絞り込めます。複数選択も可能です。絞り込み中は「クリア」で解除できます。"
        },
        "search": {
          "title": "文字で検索",
          "body": "商品名だけでなく、資料名やタグでも検索できます。目当てのものが決まっているときは、サイドバーやタグで絞り込むより早く見つかります。"
        },
        "card": {
          "title": "カードの見方",
          "body": "左上がファイル形式（PDF／画像／Word／Excel など）、下段に商品名と資料の種類、その下が資料名です。#付きがタグ、右下に更新日が入ります。カードをクリックするとプレビューが開きます。"
        },
        "size": {
          "title": "表示サイズの切替",
          "body": "小・中・大でカードの大きさを変えられます。図面を確認したいときは「大」、一覧性を優先するときは「小」が便利です。"
        },
        "select": {
          "title": "まとめてダウンロード",
          "body": "「選択してダウンロード」を押すとカードが選択できるようになります。必要な資料を選び、画面下の「まとめてダウンロード」で ZIP として一括保存できます（最大 50 件）。"
        }
      },
      "detail": {
        "info": {
          "title": "ご依頼内容の確認",
          "body": "「作成時の入力情報」を開くと、ご依頼時にフォームへ入力した内容をすべて確認できます。"
        },
        "gantt": {
          "title": "全体スケジュール",
          "body": "案件フェーズごとにスケジュール予定が表示されます。"
        },
        "progress": {
          "title": "設計タスクの進捗",
          "body": "各タスクの状態を表示します。"
        },
        "files": {
          "title": "成果物の確認",
          "body": "完成した成果物・納品書・請求書はページ上で確認できます。"
        },
        "chat": {
          "title": "ご連絡はこちらから",
          "body": "案件担当者へ直接メッセージを送れます。LINE と連携すると、LINE にも通知が届きます。"
        }
      }
    },
    "common": {
      "office_projects": "Office プロジェクト",
      "office_project_basic": "基本設計",
      "office_project_application": "申請サポート",
      "office_project_done": "完了",
      "no_data": "データなし",
      "unassigned": "未割り当て",
      "not_started": "未開始",
      "in_progress": "進行中",
      "completed": "完了",
      "processing": "処理中…",
      "search": "検索",
      "no_match": "一致する候補はありません",
      "select_from_list": "リストから選択",
      "cancel": "キャンセル",
      "confirm": "確定",
      "close": "閉じる",
      "delete": "削除",
      "add_detail": "明細を追加",
      "total": "合計：¥{amount}",
      "preview_failed": "プレビューに失敗しました",
      "download_failed": "ダウンロードに失敗しました",
      "delete_success": "削除しました",
      "delete_failed": "削除に失敗しました",
      "missing_case_key": "案件IDが指定されていません",
      "operation_failed": "操作に失敗しました",
      "request_failed": "リクエストに失敗しました",
      "upload_failed": "アップロードに失敗しました",
      "assignee": "担当者",
      "status": "ステータス",
      "all": "すべて",
      "create_case": "新規依頼",
      "all_cases": "設計サポート",
      "statistics": "統計",
      "management": "管理",
      "product_list": "商品一覧",
      "material_files": "資料一覧"
    },
    "boolean": {
      "yes": "はい",
      "no": "いいえ"
    },
    "pdf": {
      "quotation": "見積書",
      "delivery_note": "納品書",
      "request_form": "請求書",
      "preview": "PDFプレビュー",
      "loading_preview": "プレビューを読み込み中"
    },
    "errors": {
      "e1100": "案件操作に失敗しました。しばらくしてから再度お試しください",
      "e1101": "案件が存在しないか、案件IDが不正です",
      "e1102": "この案件にアクセスまたは操作する権限がありません",
      "e1103": "案件リクエストのパラメータが不足しているか、形式が正しくありません",
      "e1104": "現在の案件ステータスではこの操作を実行できません",
      "e1105": "サブタスクの割り当て、または完了条件を満たしていません",
      "e1106": "外注情報の登録、または承認条件を満たしていません",
      "e1107": "商品リクエスト、フィードバック、または段階確認の条件を満たしていません",
      "e1108": "段階移行フォームが未提出、または内容が不足しています",
      "e1109": "案件ファイルのアップロードまたはダウンロードに失敗しました",
      "e1110": "案件PDFの生成またはダウンロードに失敗しました",
      "e1111": "案件統計または操作ログの取得に失敗しました",
      "e1112": "案件チャット操作に失敗しました",
      "design_asset_code_exists": "この商品コードはすでに別の素材で使われています。別のコードを入力してください"
    },
    "chat": {
      "resize_aria": "チャット欄の幅を調整",
      "line_binding": "LINEアカウント連携",
      "line_binding_status": "{count}件連携済み",
      "refresh_line_binding": "LINE連携状態を更新",
      "line_command": "LINE連携コマンド",
      "copy": "コピー",
      "unbinding": "解除中...",
      "unbind_from_web": "Webから連携解除",
      "loading": "読み込み中...",
      "retry": "再試行",
      "line_status_failed": "LINE連携状態の取得に失敗しました",
      "copy_success": "コピーしました",
      "copy_failed": "コピーに失敗しました",
      "unbind_confirm": "現在のMHアカウントに連携済みのLINEアカウントを解除しますか？",
      "unbind_title": "確認",
      "unbind_button": "解除",
      "unbind_success": "連携を解除しました（{count}件）",
      "unbind_failed": "連携解除に失敗しました",
      "title": "チャット",
      "empty_hint": "ここでメッセージを送信し、案件関係者とやり取りできます。Enterで改行、送信ボタンで送信します。",
      "load_older": "以前のメッセージを表示",
      "input_placeholder": "メッセージを入力…",
      "close_aria": "チャットを閉じる",
      "preview_image_aria": "画像をプレビュー",
      "download_file_aria": "ファイルをダウンロード",
      "remove_file_aria": "ファイルを削除",
      "attach_file_aria": "ファイルを添付",
      "send_aria": "送信",
      "send": "送信",
      "edited": "編集済み",
      "edit_message": "編集",
      "delete_message": "削除",
      "save_edit": "保存",
      "cancel_edit": "キャンセル",
      "delete_confirm": "このメッセージを削除しますか？相手の画面からも消えます。",
      "delete_confirm_title": "メッセージの削除",
      "edit_failed": "メッセージの編集に失敗しました",
      "delete_failed": "メッセージの削除に失敗しました",
      "line_command_account_placeholder": "<MHアカウント>",
      "uploading_file": "アップロード中",
      "upload_failed_file": "アップロード失敗",
      "line_command_prefix": "アカウント連携"
    },
    "transition": {
      "product_feedback": "チェックバック",
      "feedback_once_hint": "チェックバックは1回のみ送信できます。送信後は変更できません。",
      "feedback_description": "フィードバック内容",
      "feedback_placeholder": "フィードバックまたは修正内容を入力してください",
      "attachments": "添付ファイル",
      "no_attachments": "添付ファイルはありません",
      "submit_feedback": "チェックバック送信",
      "transition_tab": "次フェーズ依頼",
      "confirm_product": "検収完了",
      "save_draft": "次フェーズ依頼下書き保存",
      "submit_continue": "次フェーズ依頼送信",
      "missing_required": "未入力の項目があります: {items}",
      "feedback_required": "フィードバック内容を入力するか、添付ファイルをアップロードしてください",
      "confirm_submit_message": "現在の内容を送信して続行しますか？",
      "confirm_submit_title": "送信確認",
      "confirm_submit_button": "送信する",
      "direct_continue_message": "次のフェーズへ直接進むと、フィードバック・修正依頼は送信できなくなります。続行しますか？",
      "direct_continue_title": "次の段階へ進む確認",
      "feedback_confirm_message": "チェックバックは1回のみ送信できます。送信後は変更できません。送信しますか？",
      "feedback_confirm_title": "チェックバック送信確認",
      "complete_confirm_message": "現在のフェーズを完了すると、フィードバック・修正依頼は送信できなくなります。商品に問題がないことを確認して完了しますか？",
      "complete_confirm_title": "現在段階の完了確認",
      "complete_confirm_button": "完了する",
      "dialog_subtitle": "必要情報を入力して、次の段階へ進む準備を行います。",
      "drag_upload_text": "ファイルをここにドラッグ、または",
      "click_upload": "クリックしてアップロード",
      "upload_tip_50mb": "複数ファイルに対応しています。1ファイル最大50MBです",
      "deposit_title": "預り金（概算金）",
      "deposit_line_1": "1. 預り金の目的 建築基準法に基づく建築確認申請・中間検査・完了検査等申請の際、指定確認検査機関に支払う手数料（非課税）を、弊社がお客様に代わって一時的にお預かりし支払うものです。",
      "deposit_line_2": "2. 預かり金額 金 100,000 円",
      "deposit_line_3": "3. 精算について お預かりした金額は、業務完了時に精算させていただきます。申請後に発行される領収書（原本）を添付し、最終代金精算時に過不足を精算させていただきます。",
      "deposit_line_4": "4. 勘定科目 本件は、弊社の売上ではなく、一時的な「預り金」として負債計上し管理いたします。",
      "agree_deposit": "上記内容に同意する",
      "application_conditions": "申請条件",
      "structure_spec_label": "構造仕様を選択してください。",
      "structure_kanamono": "金物工法",
      "structure_zairai": "在来工法",
      "thermal_spec_label": "温熱仕様を選択してください。",
      "thermal_ua_046": "目標Ua=0.46",
      "thermal_ua_034": "目標Ua=0.34",
      "thermal_ua_028": "目標Ua=0.28",
      "spec_change_note": "※原則では構造・温熱仕様の変更は受けられません。具体的な仕様は納品物の標準仕様書をご確認してください。",
      "plan_change_label": "プランの変更ございますか。",
      "yes": "あり",
      "no": "なし",
      "yes_polite": "はい",
      "no_polite": "いいえ",
      "file_attachment": "ファイル添付",
      "application_type_label": "ご要望の申請種別を選択してください。",
      "attachments_section": "添付資料",
      "current_survey_map_file": "現状測量図を添付してください。",
      "site_investigation_report_file": "現地調査報告書を添付してください。",
      "government_investigation_report_file": "役所調査報告書を添付してください。",
      "final_survey_map_file": "確定測量図を添付してください。",
      "additional_confirmation": "追加確認",
      "ground_survey_label": "地盤調査データはお持ちでしょうか？",
      "ground_survey_file": "地盤調査データを添付してください。",
      "ground_survey_expected_date": "調査結果予定日",
      "ground_survey_expected_date_label": "調査結果予定日をご記入ください。",
      "battery_installation_label": "蓄電池を設置しますか。",
      "install": "設置する",
      "not_install": "設置しない",
      "subsidy_note_label": "補助金申請予定がある場合、名称と必須等級や数値をご記入ください。",
      "ventilation_plan_label": "換気計画について",
      "ventilation_default": "基本仕様（スティーベル　品番：VLR-70）",
      "other": "その他",
      "ventilation_plan_drawing_file": "換気計画図を添付してください。",
      "ventilation_calculation_file": "換気計算書を添付してください。",
      "construction_conditions": "実施設計条件",
      "construction_no_extra_input": "実施設計へ進むために追加で入力する項目はありません。送信して次の段階へお進みください。",
      "lighting_plan_label": "照明計画について",
      "lighting_default": "基本仕様（オーデリック）",
      "lighting_plan_file": "照明計画図を添付してください。",
      "additional_review_title": "追加検討項目が必要な場合はチェックを入れてください。",
      "additional_creation_title": "追加作成項目が必要な場合はチェックを入れてください。",
      "additional_verification_title": "追加検証項目が必要な場合はチェックを入れてください。",
      "review_three_story_garage_skip": "3階建て・インナーガレージ・スキップフロアがある場合",
      "review_irregular_plan": "平面不整形（突出やくびれ、斜め建物）",
      "review_deep_foundation": "深基礎・母屋下げ・ロフト等がある場合",
      "review_floor_area_150": "延べ床面積が150㎡以上の場合",
      "review_fire_resistant": "耐火構造",
      "creation_attic_ventilation": "小屋裏換気計算書",
      "creation_plan_detail": "平面詳細図",
      "creation_electrical_wiring": "電気配線図",
      "creation_kanabakari": "矩計図（1面）",
      "creation_axonometric": "軸組図（全通り）",
      "uploaded": "アップロード済み",
      "add_file": "追加",
      "select_file": "選択",
      "dialog_title_product_confirm": "商品確認",
      "dialog_title_product_and_next": "商品確認と次段階情報",
      "dialog_title_construction": "実施設計へ進む時の入力情報",
      "dialog_title_application": "申請サポートへ進む時の入力情報",
      "faq_section": "FAQ（任意）",
      "faq_label": "確認申請のよくある疑問",
      "faq_check": "確認する",
      "faq_skip": "確認しない",
      "faq_text": "よくある質問（FAQ）｜確認申請業務\n1｜確認申請の基本的な流れと役割分担の明確化\n1-1．申請手続きの主導権と責任\nQ．確認申請の「申請者」は誰ですか？\nA．申請者は建築主です。\nただし、実務上は建築士が代理人として申請手続きを代行するのが一般的であり、その場合は建築主からの委任状が必要となります。\nQ．書類不備や虚偽の記載があった場合の責任は誰にありますか？\nA．申請書類の内容が事実に相違ないことを誓約するのは申請者（建築主）です。\n一方で、実務を担う設計者（建築士）は、設計契約に基づき善管注意義務を負います。\nなお、虚偽記載は法令違反となり、罰則や処罰の対象となる可能性があります。\n1-2．業務分担の明確化ポイント\nQ．施工者と外部設計事務所で分担すべき範囲は？\nA．一般的な役割分担は以下のとおりです。\n* 設計事務所：建築基準法への適合性確認、設計図書の作成、確認申請の代理業務\n* 施工者：工事内容・工程に関する情報提供、工程管理\nなお、申請前に設計者・工事監理者・施工者が確定している場合は、その情報を代理申請者へ事前に共有する必要があります。\nQ．工事中の「計画変更」の判断は誰が行いますか？\nA．軽微な変更を除き、建築基準法への適合性や構造基準に影響する変更については、設計者が判断し、必要に応じて計画変更申請を行う必要があります。\n施工者が独断で変更を行うことはできず、必ず事前に設計者へ相談してください。\n1-3．トラブル防止のための確認事項\nQ．完了検査の申請は誰の役割ですか？\nA．完了検査の申請義務は建築主にあります。\n工事完了日から4日以内に申請する必要がありますが、実務上は代理者が建築主の代理として手続きを行うのが一般的です。\nQ．確認申請が不要なケースでも注意点はありますか？\nA．確認申請が不要な場合であっても、建築基準法への適合義務は免除されません。\n将来のリフォームや売却時に「既存不適格」とならないよう、採光・換気・構造などの法令遵守を確認しておくことが重要です。\n2｜必要な書類と情報共有の徹底\nQ．なぜ情報共有が重要なのですか？\nA．主な理由は以下のとおりです。\n* 審査の遅延防止：書類や図面の不備・齟齬による審査長期化を防ぐため\n* 手戻りの削減：設計段階での要件共有により、施工時の変更を防止するため\n* 法令遵守の徹底：最新の建築基準法や関連法規（2025年4月改正等）に対応するため\nQ．どのような情報を共有すべきですか？\nA．以下の情報を関係者間で共有することが重要です。\n* 最新版の設計図書・仕様書（バージョン管理の徹底）\n* 申請スケジュール（中間検査・完了検査を含む）\n* 法改正・条例情報\n* 審査機関からの質疑・指摘事項と対応状況\nQ．情報共有を効率化する方法は？\nA．以下の方法が有効です。\n* クラウドサービスによる図書の一元管理\n* ビジネスチャット・施工管理アプリによるリアルタイム共有\n* 定例会議による進捗・課題の共有\n3｜法令遵守と近年の改正点\nQ．2025年4月からの主な法改正ポイントは？\nA．主な改正点は以下のとおりです。\n* 4号特例の縮小（新2号・新3号建築物の導入）\n* 省エネ基準適合の義務化（全ての新築建築物が対象）\n* 大規模リフォームへの確認申請義務化\n* 木造構造基準（壁量計算等）の見直し\nQ．構造計算はすべての木造住宅で義務化されましたか？\nA．木造2階建て以上（新2号建築物）では構造関係図書の提出が必須です。\n延床面積300㎡超では許容応力度計算が義務化されています。\nQ．リフォームでも確認申請が必要になるケースは？\nA．以下の場合に注意が必要です。\n* 用途変更（住宅→店舗・事務所など）\n* 大規模の修繕・模様替（主要構造部の過半）\nQ．施主への説明で注意すべき点は？\nA．コスト増および工期延長について、契約前に丁寧な説明が必要です。\n4｜事前審査制度の活用\nQ．事前審査制度とは何ですか？\nA．本申請前に計画内容を確認してもらう非公式な制度です。\nQ．事前審査のメリットは？\nA．審査迅速化、手戻り防止、違法建築回避、将来の安心につながります。\nQ．事前審査は必須ですか？\nA．法的義務ではありませんが、大規模・複雑な案件では推奨されます。\n5｜申請手数料の納付\nQ．申請手数料はいくらですか？\nA．床面積等により異なり、各検査機関が定めています。\nQ．申請手数料は誰が支払いますか？\nA．原則は建築主負担です。立替対応となる場合があります。\n6｜審査期間の長期化\nQ．審査期間はどれくらいかかりますか？\nA．法改正後は、最長で35日〜70日かかる場合があります。\nQ．長期化を防ぐための対策は？\nA．事前相談、書類の万全な準備、余裕ある工程管理が重要です。\n※本ページは確認申請業務に関する一般的な補足説明です。契約条件は、フォーム内の約款および入力内容を優先します。",
      "application_type_note": "※上記以外の許認可についてはお受け出来かねますので予めご了承ください。",
      "attachments_hint": "お手元にある資料を添付してください。未確定・未入手の資料がある場合は、下の「受付条件の確認」で該当項目を「いいえ」にしてください（仮受付）。",
      "important_matters_file": "重要事項説明書（土地）を添付してください。",
      "current_survey_map_file": "現況測量図を添付してください。",
      "cadastral_survey_map_file": "地積測量図を添付してください。",
      "ground_survey_report_file": "地盤調査報告書を添付してください。",
      "ground_improvement_analysis_file": "地盤改良の場合、解析結果検討書を添付してください。",
      "other_permit_label": "建築基準法以外の各許認可の資料を添付してください（例：都市計画法、土地区画整理法第76条など）。",
      "other_permit_attach": "添付する",
      "other_permit_none": "該当なし",
      "other_permit_file": "許認可の資料（複数添付可）",
      "applicant_section": "申請者情報",
      "applicant_name_label": "申請者氏名（個人名または法人名）",
      "applicant_name_placeholder": "株式会社〇〇〇〇〇〇",
      "owner_name_label": "建築主氏名（単名）",
      "last_name": "姓",
      "first_name": "名",
      "owner_kana_label": "名前（フリガナ）",
      "last_name_kana": "セイ",
      "first_name_kana": "メイ",
      "owner_address_label": "建築主現住所",
      "postal_code": "郵便番号",
      "prefecture_placeholder": "都道府県を選択してください",
      "city": "市区町村",
      "street": "番地",
      "building": "建物名・部屋番号（任意）",
      "owner_phone_label": "建築主電話番号（20文字以内）",
      "sole_applicant_label": "申請は単名ですか？",
      "parties_section": "設計者・工事監理者・工事施工者情報",
      "designer_info_file": "設計者情報をアップロードしてください。",
      "supervisor_info_file": "工事監理者情報をアップロードしてください。",
      "contractor_info_file": "工事施工者情報をアップロードしてください。",
      "schedule_section": "工事予定年月日（事前工事は除く）",
      "construction_start_label": "建物着工予定年月日",
      "handover_label": "建物引渡し予定年月日",
      "date_placeholder": "年／月／日",
      "intermediate_inspection_label": "特定工程（中間検査）の有無",
      "intermediate_inspection_note": "※検査の立会いは弊社では行いませんので予めご了承ください。",
      "acceptance_section": "受付条件の確認（全て必須）",
      "plan_fixed_label": "プランの確定：建築主の最終合意が済んでおり、間取りや開口部等の変更はありません。",
      "spec_fixed_label": "仕様の確定：断熱・サッシ・換気・住設・給湯など省エネ計算に伴う仕様の変更はありません。",
      "ground_survey_done_label": "地盤調査の完了：地盤調査報告書が添付されており、基礎判定の変更はありません。",
      "review_agency_label": "提出審査機関：指定確認検査機関が決定しています。",
      "review_agency_name_placeholder": "機関名（任意入力）",
      "provisional_agree_label": "上記に未決定がある場合は仮受付とし、全項目が揃った日を受付開始日とさせていただきます。",
      "provisional_banner": "現在【仮受付】モードです。資料・仕様が確定するまで受付にはなりません。",
      "required_other_permit": "建築基準法以外の許認可資料の有無",
      "required_other_permit_file": "許認可の資料の添付",
      "required_provisional_agree": "仮受付への同意",
      "application_confirmation": "確認申請",
      "flat35_design": "フラット35（設計）",
      "flat35_intermediate": "フラット35（中間）",
      "flat35_completion": "フラット35（竣工）",
      "energy_performance": "省エネ適判",
      "long_term_quality_housing": "長期使用構造等の確認",
      "housing_performance_design": "住宅性能評価（設）",
      "housing_performance_design_build": "住宅性能評価（設＆建）",
      "verification_kanabakari": "矩計図追加作成（1面）",
      "verification_axonometric": "軸組図追加作成（全通り）",
      "verification_irregular_plan": "平面不整形（突出やくびれ、斜め建物）",
      "required_deposit_agreement": "預り金の同意",
      "required_structure_spec": "構造仕様",
      "required_thermal_spec": "温熱仕様",
      "required_plan_change": "プラン変更",
      "required_plan_change_file": "プラン変更ファイル",
      "required_application_type": "申請種別",
      "required_current_survey_map": "現状測量図",
      "required_site_investigation_report": "現地調査報告書",
      "required_government_investigation_report": "役所調査報告書",
      "required_final_survey_map": "確定測量図",
      "required_ground_survey": "地盤調査データ",
      "required_ground_survey_expected_date": "調査結果予定日",
      "required_battery": "蓄電池",
      "required_ventilation_plan": "換気計画",
      "required_ventilation_plan_drawing": "換気計画図",
      "required_ventilation_calculation": "換気計算書",
      "required_lighting_plan": "照明計画",
      "required_lighting_plan_file": "照明計画図",
      "bels": "BELS"
    },
    "create": {
      "back": "戻る",
      "save_draft": "一時保存",
      "save_next": "保存して次へ",
      "create_case": "新規依頼",
      "creating_case": "案件を作成中",
      "draft_saved": "一時保存しました",
      "cleared": "入力内容をクリアしました",
      "required_missing": "必須項目を入力してください",
      "required_field": "必須項目です",
      "required_company": "会社名を入力してください",
      "choose_at_least_one": "少なくとも1つ選択してください",
      "reattach_required": "ファイルは下書きに保存されないため、もう一度選択してください（不要なら × で削除）",
      "draft_files_not_restored": "下書きを復元しました。添付ファイルは復元できないため、ファイル名だけ表示されている欄はもう一度選択してください。",
      "reattach_before_submit": "再添付が必要なファイルがあります。もう一度選択するか、× で削除してください",
      "invalid_email": "メールアドレスの形式が正しくありません",
      "number_required": "数値を入力してください",
      "created": "案件を作成しました",
      "create_failed": "案件の作成に失敗しました",
      "submit_failed": "ネットワークエラー、または送信に失敗しました",
      "product_cover": "商品カバー",
      "optional_suffix": "（任意）",
      "page_title": "案件作成",
      "page_description": "基本設計の依頼内容を入力してください。",
      "edit_title": "依頼情報の編集",
      "edit_description": "「{name}」の依頼情報を直します。依頼内容・会社名・添付資料は変えられません（添付資料は案件詳細の「依頼資料」で追加できます）。",
      "edit_save": "依頼情報を保存",
      "edit_next": "次へ",
      "edit_saving": "保存中...",
      "edit_saved": "依頼情報を保存しました",
      "edit_failed": "依頼情報を保存できませんでした",
      "edit_load_failed": "案件を読み込めませんでした",
      "edit_forbidden": "依頼情報を直せるのはプラットフォーム管理者だけです",
      "edit_attachments_note": "添付資料はここでは変えられません。案件詳細の「依頼資料」で確認・追加してください。",
      "clear_all": "すべての入力をクリア",
      "terms_title": "【Make House 設計サポート利用約款】",
      "privacy_title": "【プライバシーポリシー】",
      "required_badge": "必須",
      "agree_terms": "約款に同意する",
      "agree_privacy": "同意する",
      "select_placeholder": "選択してください",
      "no_product": "選択できる商品がありません。",
      "loading_product": "商品情報を読み込んでいます。",
      "attachments": "添付資料",
      "upload_add": "追加",
      "upload_select": "選択",
      "default_requirements": "基本設計依頼",
      "request_type_note": "構造計算のみをご依頼の場合は「構造計算」を選択してください。専用フォームに切り替わります。",
      "structure_calc_terms_agree": "「構造計算サービス利用約款」に同意のうえ、業務を依頼します。",
      "structure_calc_attachments": "添付資料（構造計算）",
      "desired_delivery_note": "最短納期は御見積書兼発注書に押印頂いてから当社営業日（土日祝休日）換算で10日以上となります。",
      "additional_verification_note": "追加料金が発生する項目になります。項目に無い場合は別途お見積りいたします。",
      "safety_certificate_note": "※安全証明書の発行が必要な場合はご依頼時に必ず確認してください。作業着手後にご依頼頂いた場合、業務フローが変わるため追加費用や納期延長が発生してしまいますのでご注意ください。",
      "structure_calc_plan_note": "※納期について ① 通常プラン▶︎10営業日以内にて納品させていただきます ② お急ぎプラン▶︎5営業日以内にて納品させていただきます。土日祝日と夏季冬季休暇以外を営業日と定めております。",
      "plan_other_placeholder": "ご希望の内容をご記入ください",
      "date_placeholder": "年／月／日",
      "default_requirements_structure_calc": "構造計算依頼"
    },
    "form": {
      "sections": {
        "basic_info": "基本情報",
        "product_site_info": "商品・敷地情報",
        "utilities_info": "設備・インフラ",
        "plan_preference_info": "建物・プラン希望",
        "request_type": "依頼内容",
        "structure_calc_info": "構造計算 依頼内容",
        "application_conditions": "申請条件",
        "construction_conditions": "実施設計条件",
        "additional_confirmation": "追加確認",
        "additional_review": "追加検討項目",
        "additional_creation": "追加作成項目",
        "additional_verification": "追加検証項目",
        "applicant_info": "申請者情報",
        "construction_schedule": "工事予定年月日",
        "acceptance_conditions": "受付条件の確認",
      },
      "labels": {
        "companyName": "会社名",
        "contactName": "担当者氏名",
        "contactKanaName": "名前（フリガナ）",
        "email": "メールアドレス",
        "phone": "電話番号",
        "projectName": "工事名称について",
        "siteLotNumber": "建設地地番を記入してください。",
        "requestType": "ご依頼内容を選択してください。",
        "seismicGrade": "希望耐震等級を選択ください。",
        "desiredDeliveryDate": "希望納期",
        "additionalVerificationItems": "追加検証項目が必要な場合はチェックを入れてください。",
        "firstRequest": "当社への構造計算のご依頼は初めてですか？",
        "structureCalcPlan": "今回のご依頼プランをご選択ください",
        "structureCalcRemarks": "備考事項",
        "floorPlanPdf": "平面詳細図1/50（PDF）",
        "elevationPdf": "立面図（PDF）",
        "sectionPdf": "矩計図（PDF）",
        "floorPlanCad": "平面詳細図1/50（JWW・DXF）",
        "elevationCad": "立面図（JWW・DXF）",
        "sectionCad": "矩計図（JWW・DXF）",
        "structureCalcOther": "その他資料",
        "applicantName": "申請者氏名（個人名または法人名）",
        "ownerName": "建築主氏名（単名）",
        "ownerKanaName": "建築主氏名（フリガナ）",
        "ownerAddress": "建築主現住所",
        "ownerPhone": "建築主電話番号",
        "soleApplicant": "申請は単名ですか？",
        "constructionStartDate": "建物着工予定年月日",
        "handoverDate": "建物引渡し予定年月日",
        "intermediateInspection": "特定工程（中間検査）の有無",
        "planFixed": "プランの確定",
        "specFixed": "仕様の確定",
        "groundSurveyDone": "地盤調査の完了",
        "reviewAgencyDecided": "提出審査機関の決定",
        "reviewAgencyName": "提出審査機関名",
        "otherPermitDocs": "建築基準法以外の各許認可の資料",
        "buildingFloors": "建物階数を選択してください。",
        "baseProduct": "ベース商品を選択してください",
        "solarPanel": "太陽光パネルを設置しますか。",
        "basicDesignRequest": "基本設計ご依頼内容",
        "akagakiPlan": "赤書きプランをアップロードしてください。",
        "buildingSize": "建物サイズを教えてください。",
        "longTermQualityHousing": "長期使用構造等の確認は取得されますか。",
        "buildingCost": "建物本体コストを教えてください。",
        "hasGuideMapData": "案内図のデータはお持ちですか。",
        "urbanPlanning": "都市計画に当てはまるものを全て選択してください。",
        "useDistricts": "用途地域について当てはまるものを選択してください。",
        "firePrevention": "防火指定について当てはまるものを選択してください。",
        "otherDistricts": "その他の地域地区に当てはまるものを全て選択してください。",
        "districtPlans": "地区計画に当てはまるものを全て選択してください。",
        "districtPlansOther": "地区計画 その他",
        "siteArea": "当該敷地面積をご入力ください。",
        "buildingCoverageRatio": "建蔽率をご記入ください。",
        "floorAreaRatio": "容積率をご記入ください。",
        "absoluteHeight": "絶対高さをご記入ください。",
        "wallSetback": "壁面後退について当てはまるものを選択してください。",
        "wallSetbackOther": "壁面後退 その他",
        "frontRoad": "前面道路について当てはまるものを選択してください。",
        "frontRoadOther": "前面道路 その他",
        "otherApplications": "その他申請があれば全て選択してください。",
        "otherApplicationsOther": "その他申請の内容",
        "waterPipe": "ライフラインについて、水道・敷地内配管はありますか？",
        "gasPipe": "ライフラインについて、ガス・敷地内配管はありますか？",
        "electricity": "ライフラインについて、電気はありますか？",
        "sewageType": "ライフラインについて、汚水の種類を教えてください。",
        "grayWaterType": "ライフラインについて、雑排水の種類を教えてください。",
        "rainWaterType": "ライフラインについて、雨水の種類を教えてください。",
        "facadeDirection": "ファサード面の希望があれば選択してください。",
        "facadeDirectionOther": "ファサード面 その他",
        "contractStatus": "契約ステータスの確認。",
        "contractStatusOther": "契約ステータス その他",
        "priority": "優先順位について。",
        "car": "自動車について。",
        "bicycle": "自転車について。",
        "motorcycle": "オートバイについて。",
        "builtInGarage": "ビルトインガレージは必要ですか？",
        "planNotes": "プランに際しての必須項目等をご記載ください。",
        "structureSpec": "構造仕様",
        "thermalSpec": "温熱仕様",
        "planChange": "プラン変更",
        "applicationTypes": "申請種別",
        "groundSurvey": "地盤調査データ",
        "groundSurveyExpectedDate": "調査結果予定日",
        "batteryInstallation": "蓄電池設置",
        "subsidyNote": "補助金申請メモ",
        "ventilationPlan": "換気計画",
        "lightingPlan": "照明計画",
        "additionalReviewThreeStoryGarageSkip": "3階建て・インナーガレージ・スキップフロアがある場合",
        "additionalReviewIrregularPlan": "平面不整形（突出やくびれ、斜め建物）",
        "additionalReviewDeepFoundation": "深基礎・母屋下げ・ロフト等がある場合",
        "additionalReviewFloorArea150": "延べ床面積が150㎡以上の場合",
        "additionalReviewFireResistant": "耐火構造",
        "additionalCreationAtticVentilation": "小屋裏換気計算書",
        "additionalCreationPlanDetail": "平面詳細図",
        "additionalCreationElectricalWiring": "電気配線図",
        "additionalCreationKanabakari": "矩計図（1面）",
        "additionalCreationAxonometric": "軸組図（全通り）",
        "additionalVerificationKanabakari": "矩計図追加作成（1面）",
        "additionalVerificationAxonometric": "軸組図追加作成（全通り）",
        "additionalVerificationIrregularPlan": "平面不整形（突出・くびれ・斜め建物）"
      },
      "placeholders": {
        "contactName": "姓・名",
        "contactKanaName": "セイ・メイ",
        "projectName": "施主名＋工事区分など、一意の名前",
        "siteLotNumber": "地番まで正確に記入"
      },
      "upload": {
        "guideMap": "地番表記のある案内図をアップロードしてください。",
        "registryCopy": "登記簿謄本をアップロードしてください。",
        "officialMap": "公図をアップロードしてください。",
        "surveyMap": "現状測量図をアップロードしてください。",
        "importantExplanation": "重要事項説明書をアップロードしてください。",
        "floorPlanPdf": "平面詳細図1/50のPDFデータを添付してください。",
        "elevationPdf": "立面図のPDFデータを添付してください。",
        "sectionPdf": "矩計図のPDFデータを添付してください。",
        "floorPlanCad": "平面詳細図1/50のJWW・DXFデータを添付してください。",
        "elevationCad": "立面図のJWW・DXFデータを添付してください。",
        "sectionCad": "矩計図のJWW・DXFデータを添付してください。",
        "structureCalcOther": "その他の資料があれば添付してください。（任意）"
      },
      "upload_names": {
        "guideMap": "地番表記のある案内図",
        "registryCopy": "登記簿謄本",
        "officialMap": "公図",
        "surveyMap": "現状測量図",
        "importantExplanation": "重要事項説明書",
        "akagakiPlan": "赤書きプラン",
        "floorPlanPdf": "平面詳細図1_50_PDF",
        "elevationPdf": "立面図_PDF",
        "sectionPdf": "矩計図_PDF",
        "floorPlanCad": "平面詳細図1_50_CAD",
        "elevationCad": "立面図_CAD",
        "sectionCad": "矩計図_CAD",
        "structureCalcOther": "その他資料"
      },
      "options": {
        "one_story": "1階建て",
        "two_story": "2階建て",
        "three_story": "3階建て",
        "install": "設置する",
        "not_install": "設置しない",
        "request_basic_design": "基本設計",
        "request_structure_calc": "構造計算",
        "grade_1": "耐震等級1",
        "grade_2": "耐震等級2",
        "grade_3": "耐震等級3",
        "first": "初めて",
        "repeat": "2回目以上",
        "standard": "① 通常プラン：18万円（税抜）",
        "express": "② お急ぎプラン：28万円（税抜）",
        "heavy_snow_area": "多雪地域",
        "axial_diagram": "軸組図",
        "floor_area_over_150": "延床面積が150㎡を超える",
        "attic_storage": "小屋裏収納",
        "open_ceiling": "吹抜け",
        "coffered_ceiling": "折上げ天井",
        "deep_foundation": "深基礎検討",
        "high_foundation": "高基礎検討",
        "cantilever_foundation": "キャンチ基礎検討",
        "sloped_ceiling_ridge_beam": "勾配天井・登り梁・桁下げ（登り梁への変更）・母屋下げ",
        "irregular_plan": "平面不整形（突出やくびれ、斜め建物）",
        "safety_certificate": "安全証明",
        "yes": "あり",
        "no": "なし",
        "acquire": "取得する",
        "not_acquire": "取得しない",
        "none": "なし",
        "unspecified": "指定なし",
        "other": "その他",
        "online_plan_and_presentation_sheet": "オンラインプラン＋プレゼンシート作成",
        "free_floor_plan": "自由間取り作成",
        "semi_order": "セミオーダー作成",
        "up_to_25_tsubo": "25坪以下",
        "up_to_30_tsubo": "30坪以下",
        "up_to_35_tsubo": "35坪以下",
        "up_to_40_tsubo": "40坪以下",
        "over_40_tsubo": "40坪以上",
        "up_to_1500_man_yen": "1500万円以下",
        "up_to_1600_man_yen": "1600万円以下",
        "up_to_1700_man_yen": "1700万円以下",
        "up_to_1800_man_yen": "1800万円以下",
        "up_to_1900_man_yen": "1900万円以下",
        "up_to_2000_man_yen": "2000万円以下",
        "up_to_2100_man_yen": "2100万円以下",
        "up_to_2200_man_yen": "2200万円以下",
        "up_to_2300_man_yen": "2300万円以下",
        "up_to_2400_man_yen": "2400万円以下",
        "up_to_2500_man_yen": "2500万円以下",
        "up_to_2600_man_yen": "2600万円以下",
        "up_to_2700_man_yen": "2700万円以下",
        "up_to_2800_man_yen": "2800万円以下",
        "up_to_2900_man_yen": "2900万円以下",
        "over_3000_man_yen": "3000万円以上",
        "urban_planning_area": "都市計画区域",
        "quasi_urban_planning_area": "準都市計画区域",
        "outside_urban_planning_area": "都市計画区域外",
        "urbanization_area": "市街化区域",
        "urbanization_control_area": "市街化調整区域",
        "non_area_divided_area": "非線引区域",
        "category_1_low_rise_residential": "第一種低層住居専用地域",
        "category_2_low_rise_residential": "第二種低層住居専用地域",
        "category_1_mid_high_rise_residential": "第一種中高層住居専用地域",
        "category_2_mid_high_rise_residential": "第二種中高層住居専用地域",
        "category_1_residential": "第一種住居地域",
        "category_2_residential": "第二種住居地域",
        "garden_residential": "田園住居地域",
        "quasi_residential": "準住居地域",
        "neighborhood_commercial": "近隣商業地域",
        "commercial": "商業地域",
        "quasi_industrial": "準工業地域",
        "industrial": "工業地域",
        "exclusive_industrial": "工業専用地域",
        "fire_prevention_area": "防火地域",
        "quasi_fire_prevention_area": "準防火地域",
        "new_fire_prevention_area": "新防火地域",
        "building_standard_act_22_23_area": "法22条・23条区域",
        "special_use_district": "特別用途地区",
        "special_floor_area_ratio_district": "特例容積率適用地区",
        "specific_use_restriction_area": "特定用途制限地域",
        "high_rise_residential_inducement_district": "高層住居誘導地区",
        "height_district": "高度地区",
        "high_level_use_district": "高度利用地区",
        "specified_block": "特定街区",
        "urban_renaissance_special_district": "都市再生特別地区",
        "specified_disaster_prevention_block_improvement_district": "特定防災街区整備地区",
        "landscape_district": "景観地区",
        "quasi_landscape_district": "準景観地区",
        "scenic_district": "風致地区",
        "parking_place_development_zone": "駐車場整備地区",
        "port_zone": "臨港地区",
        "special_historic_landscape_preservation_district": "歴史的風土特別保存地区",
        "category_1_historic_landscape_preservation_district": "第1種歴史的風土保存地区",
        "category_2_historic_landscape_preservation_district": "第2種歴史的風土保存地区",
        "special_green_space_conservation_district": "特別緑地保全地区",
        "distribution_business_district": "流通業務地区",
        "productive_green_area": "生産緑地地区",
        "traditional_buildings_preservation_district": "伝統的建造物群保存地区",
        "aircraft_noise_prevention_district": "航空機騒音障害防止地区",
        "special_aircraft_noise_prevention_district": "航空機騒音障害防止特別地区",
        "district_plan": "地区計画",
        "disaster_prevention_block_improvement_district_plan": "防災街区整備地区計画",
        "roadside_district_plan": "沿道地区計画",
        "settlement_district_plan": "集落地区計画",
        "historic_scenic_maintenance_improvement_district_plan": "歴史的風致維持向上地区計画",
        "0_5m": "0.5m",
        "1_0m": "1.0m",
        "1_5m": "1.5m",
        "building_standard_act_42_1": "建築基準法第42条第1項道路",
        "building_standard_act_42_2": "建築基準法第42条第2項道路",
        "land_readjustment_act_76_permission": "土地区画整理法第76条許可申請",
        "city_planning_act_29_permission": "都市計画法第29条許可申請",
        "city_planning_act_43_permission": "都市計画法第43条許可申請",
        "city_planning_act_53_permission": "都市計画法第53条許可申請",
        "sewer_with_site_manhole": "下水（敷地内桝あり）",
        "sewer_without_site_manhole": "下水（敷地内桝なし）",
        "septic_tank": "浄化槽",
        "rainwater_manhole_connected_with_site_manhole": "雨水桝接続（敷地内桝あり）",
        "rainwater_manhole_connected_without_site_manhole": "雨水桝接続（敷地内桝なし）",
        "ditch_discharge_with_site_manhole": "側溝放流（敷地内桝あり）",
        "ditch_discharge_without_site_manhole": "側溝放流（敷地内桝なし）",
        "north": "北",
        "east": "東",
        "west": "西",
        "south": "南",
        "northeast": "北東",
        "northwest": "北西",
        "southeast": "南東",
        "southwest": "南西",
        "pre_screening_completed": "事前審査済み",
        "land_acquired": "土地取得済み",
        "pre_screening_completed_and_land_acquired": "事前審査済み＋土地取得済み",
        "design_quality": "デザイン力",
        "planning_quality": "プランニング力",
        "earthquake_resistance": "耐震性",
        "budget_cost_performance": "予算・コストパフォーマンス",
        "solar_power": "太陽光発電",
        "equipment": "設備",
        "performance": "住宅性能",
        "owned": "所有している",
        "not_owned": "所有していない",
        "required": "必要",
        "not_required": "不要",
        "kanamono": "金物工法",
        "zairai": "在来工法",
        "ua_046": "目標Ua=0.46",
        "ua_034": "目標Ua=0.34",
        "ua_028": "目標Ua=0.28",
        "default": "基本仕様"
      }
    },
    "asset": {
      "title": "案件ファイル",
      "files": "依頼資料",
      "resume_upload": "追加アップロード",
      "cancel_all": "すべてキャンセル",
      "queued": "（待機中）",
      "cancel": "キャンセル",
      "unnamed_file": "名称未設定ファイル",
      "preview": "プレビュー",
      "download": "ダウンロード",
      "delete": "削除",
      "no_files": "アップロード済みファイルはありません",
      "deliverables": "成果物",
      "upload_deliverable": "成果物をアップロード",
      "create_deliverable_folder": "フォルダを作成",
      "create_subfolder": "サブフォルダを作成",
      "upload_to_folder": "ファイルをアップロード",
      "delete_folder": "フォルダを削除",
      "download_folder": "フォルダごとダウンロード（ZIP）",
      "folder_name_placeholder": "フォルダ名を入力",
      "folder_name_required": "フォルダ名を入力してください",
      "create_folder_success": "フォルダを作成しました",
      "create_folder_failed": "フォルダの作成に失敗しました",
      "no_deliverables": "成果物はありません",
      "feedbacks": "フィードバック・修正",
      "unsupported_preview": "このファイルタイプはオンラインプレビューに対応していません",
      "download_name_fallback": "download"
    },
    "design_info": {
      "title": "基本設計情報",
      "change_cover": "カバー変更",
      "contact_email": "依頼者のメールアドレス（通知先）",
      "change_contact_email": "変更",
      "contact_email_hint": "受付・商品リクエスト・新着メッセージのお知らせはこのアドレスへ送ります。変更はプラットフォーム管理者だけです。",
      "contact_email_prompt": "新しいメールアドレスを入力してください",
      "contact_email_invalid": "メールアドレスの形式が正しくありません",
      "save_contact_email": "保存",
      "edit_request_info": "依頼情報を編集",
      "project_name_prefix": "工事名称",
      "requirements": "要望説明",
      "creation_input_title": "作成時の入力情報",
      "creation_input_subtitle": "基本設計依頼フォームの保存内容",
      "structure_calc_title": "構造計算情報",
      "structure_calc_input_subtitle": "構造計算依頼フォームの保存内容",
      "application_input_title": "申請サポート入力情報",
      "application_input_subtitle": "確認申請へ進む際のフォーム保存内容",
      "construction_input_title": "実施設計入力情報",
      "construction_input_subtitle": "実施設計へ進む際のフォーム保存内容",
      "collapse_all": "全体を閉じる",
      "expand_all": "全体を開く",
      "loading": "読み込み中...",
      "not_found": "案件が見つかりません"
    },
    "progress": {
      "title": "案件段階の進捗",
      "close_case": "案件をクローズ",
      "delete_case": "案件を削除",
      "complete_case": "案件完成",
      "start_case": "着手",
      "generate_quotation": "見積書作成",
      "edit_quotation": "見積書を修正",
      "save_quotation": "修正を保存",
      "advance_product_request": "案件納品",
      "confirm_subtask": "確定",
      "mark_subtask_done": "完了にする",
      "outsource": "外注",
      "resubmit_outsource": "外注を再提出",
      "approve": "承認",
      "reject": "差し戻し",
      "view_outsource": "外注を確認",
      "edit_outsource": "外注を編集",
      "assignee": "担当者：{name}",
      "choose_assignee": "担当者を選択",
      "stage_assignees": "担当者",
      "stage_assignees_none": "未設定",
      "edit_stage_assignees": "担当者を変更",
      "save_stage_assignees": "保存",
      "case_name": "案件名",
      "task_name": "タスク名",
      "contractor_info": "外注先情報",
      "cost_yen": "費用（円）",
      "cost_placeholder": "費用（円）を入力",
      "expected_date": "完了予定日",
      "select_date": "日付を選択",
      "note": "備考",
      "note_placeholder": "備考を入力",
      "quotation_amount_details": "見積金額明細",
      "document_amount_title": "納品書／請求書の金額明細を確認",
      "document_amount_details": "納品書／請求書金額明細",
      "title_col": "タイトル",
      "amount_yen": "金額（円）",
      "input_title": "タイトルを入力",
      "input_note": "備考を入力",
      "input_amount": "金額を入力",
      "basic_amount": "基本金額",
      "additional_amount": "追加金額",
      "product_confirm": "検収完了",
      "product_confirm_next": "次へ",
      "confirming": "資料確認中",
      "reviewing": "見積書兼発注書押印待ち",
      "product_requesting": "検収中",
      "done_fraction": "進行中 {done}/{total}",
      "outsource_approved": "外注承認済み",
      "outsource_rejected": "外注差し戻し済み",
      "outsource_pending": "外注承認待ち",
      "dialog_view_outsource": "外注を確認",
      "dialog_edit_outsource": "外注を編集",
      "dialog_outsource": "外注",
      "stage_basic_design": "基本設計",
      "stage_application": "確認申請",
      "stage_detail_design": "実施設計",
      "stage_structure_calc": "構造計算",
      "subtask_structure_0": "仕様確認",
      "subtask_structure_1": "構造計算",
      "subtask_structure_2": "納品",
      "subtask_basic_0": "オンライン面談",
      "subtask_basic_1": "スケッチプラン納品",
      "subtask_basic_2": "ウェブプレゼン作成",
      "subtask_basic_3": "ウェブプレゼン説明",
      "subtask_basic_4": "ウェブプレゼン修正",
      "subtask_basic_5": "最終納品",
      "subtask_application_0": "構造計算",
      "subtask_application_1": "確認申請に必要な図面・書類作成",
      "subtask_application_2": "省エネ計算",
      "subtask_application_3": "図面納品",
      "subtask_application_4": "申請提出と質疑対応",
      "subtask_application_5": "最終納品",
      "subtask_detail_0": "詳細納まり図・断面詳細図の作成",
      "subtask_detail_1": "電気配管・給排水設備図の設計",
      "subtask_detail_2": "内外装仕上げ・材料詳細リストの作成",
      "subtask_detail_3": "施工用一式図面の出図と最終納品",
      "prompt_title": "確認",
      "outsource_needs_approval": "外注情報が未承認のため、サブタスクを完了できません",
      "confirm_mark_subtask_done": "このサブタスクを完了にしますか？",
      "assignee_selection_invalid": "担当者を正しく選択してください",
      "quotation_input_invalid": "見積書の入力内容を確認してください",
      "confirm_generate_quotation_message": "見積書を作成・発行しますか？",
      "confirm_update_quotation_message": "見積書を修正しますか？発行日は今日の日付になります。",
      "confirm_close_case_message": "この案件をクローズしますか？クローズ後、案件ステータスはキャンセルになります。",
      "confirm_delete_case_message": "案件「{name}」を削除しますか？削除した案件は一覧・詳細から消え、依頼者・担当者も見られなくなります。",
      "confirm_start_stage_message": "レビュー内容に問題がないことを確認し、現在のフェーズを開始しますか？",
      "confirm_current_stage_message": "現在のフェーズの成果物に問題がないことを確認し、進めますか？",
      "confirm_advance_product_request_message": "納品請求フェーズに進めますか？",
      "contractor_load_failed": "外注先リストの読み込みに失敗しました",
      "missing_outsource_info": "外注記録が存在しません",
      "confirm_approve_outsource_message": "この外注情報を承認しますか？",
      "confirm_reject_outsource_message": "この外注情報を差し戻しますか？",
      "confirm_submit_outsource_message": "この外注情報を提出しますか？",
      "missing_subtask_context": "サブタスクの情報が不足しています",
      "contractor_required": "外注先を選択してください",
      "valid_cost_required": "有効な費用を入力してください",
      "expected_date_required": "完了予定日を選択してください",
      "invalid_contractor": "外注先が不正です",
      "confirm_complete_project_message": "案件完成にしますか？完了後は進捗を変更できません。"
    },
    "status": {
      "stage_phase": "{stage} {phase}",
      "stage_basic_or_structure": "基本設計・構造計算",
      "phase_confirming": "資料確認中",
      "phase_reviewing": "見積書兼発注書押印待ち",
      "phase_in_progress": "進行中",
      "phase_product_requesting": "検収中",
      "phase_completed": "完了",
      "case_completed": "完了",
      "case_rejected": "キャンセル"
    },
    "priority": {
      "low": "低",
      "medium": "中",
      "high": "高",
      "unknown": "未設定"
    },
    "statistics": {
      "title": "案件統計",
      "case_statistics": "案件統計",
      "executor_profit": "担当者別利益",
      "case_list": "案件一覧",
      "total_cases": "総案件数",
      "unassigned_cases": "未割り当て案件",
      "in_progress_cases": "進行中案件",
      "completed_cases": "完了案件",
      "status_distribution": "ステータス分布",
      "period_start": "期間開始",
      "period_end": "期間終了",
      "assignee_keyword": "担当者キーワード",
      "amount_total": "金額合計",
      "cost_total": "原価合計",
      "profit_total": "利益合計",
      "by_assignee": "担当者別",
      "profit_note": "利益は関連金額合計から関連原価合計を差し引いた概算です。",
      "empty_adjust_filters": "該当データがありません。条件を調整してください。",
      "case_count": "案件数",
      "stage_count": "段階数",
      "related_amount_total": "関連金額合計",
      "related_cost_total": "関連原価合計",
      "involved_profit": "関与利益",
      "keyword_placeholder": "案件名、番号、担当者で検索",
      "priority": "優先度",
      "created_start": "作成日開始",
      "created_end": "作成日終了",
      "case_no": "案件番号",
      "title_column": "タイトル",
      "owner": "所有者",
      "deadline": "期限",
      "overdue": "期限超過",
      "created_at": "作成日時",
      "actions": "操作",
      "more_actions": "その他操作",
      "backend_pending": "バックエンド対応待ち",
      "overview_load_failed": "概要の読み込みに失敗しました",
      "overview_request_failed": "概要リクエストに失敗しました",
      "performance_load_failed": "実績の読み込みに失敗しました",
      "performance_request_failed": "実績リクエストに失敗しました",
      "ai_real_cg_feedback": "AI real CG フィードバック",
      "ai_users_total": "対象ユーザー数",
      "ai_active_users_14d": "直近14日アクティブ",
      "ai_trend_title": "直近30日の日別生成数",
      "ai_month_compare_title": "当月日均 / 前月日均の生成数",
      "export_short": "書き出し",
      "ai_real_cg_stats": "AI real CG統計",
      "search": "検索",
      "tel": "TEL番号",
      "last_login": "最終ログイン日時",
      "last_generation": "直近CG生成日",
      "image": "静止画",
      "video": "動画",
      "gen_14d": "過去14日間の生成数",
      "gen_cur_month": "当月日均生成数",
      "gen_prev_month": "前月日均生成数",
      "change_rate": "増減率（当月日均/前月日均）",
      "export_count": "画像書き出し数（高解像度化）",
      "cur_month_short": "当月日均",
      "prev_month_short": "前月日均",
      "contract_days": "契約経過日数",
      "cancel_date": "解約日",
      "subscription_filter_valid": "サブスク有効",
      "subscription_status": "サブスクリプション状態",
      "subscription_start_date": "サブスクリプション開始日",
      "registered_at": "登録日時",
      "ai_stats_keyword_placeholder": "ユーザー名 / 氏名 / 会社 / TEL / メールで検索",
      "ai_history_tab": "AI real CG 生成履歴",
      "ai_history_keyword_placeholder": "プロジェクト名 / ユーザー名 / 氏名 / 会社で検索",
      "ai_history_mode": "モード",
      "ai_history_mode_facade": "外観",
      "ai_history_mode_interior": "内装",
      "ai_history_date_range": "生成日",
      "ai_history_total": "{count} 件",
      "ai_history_load_failed": "AI real CG 生成履歴の取得に失敗しました",
      "ai_history_empty": "該当する生成履歴がありません",
      "ai_history_user": "ユーザー",
      "ai_history_attempt": "生成ID",
      "ai_history_order": "注文ID",
      "ai_history_inputs": "入力画像",
      "ai_history_results": "結果画像",
      "ai_history_request": "要望",
      "ai_history_style": "スタイル",
      "ai_history_time_period": "時間帯",
      "ai_history_size": "サイズ / 解像度 / 比率",
      "ai_history_angle": "視点",
      "ai_history_count": "生成枚数",
      "ai_history_no_results": "結果画像なし",
      "ai_history_kind_house": "元画像",
      "ai_history_kind_background": "背景",
      "ai_history_kind_reference": "参考画像",
      "ai_history_kind_wall": "外壁参考",
      "ai_history_kind_style": "スタイル画像",
      "ai_stats_load_failed": "AI real CG 統計の取得に失敗しました",
      "ai_stats_period": "当月 {cur} ／ 前月 {prev} ／ 直近14日 {from}〜",
      "ai_users_monthly_title": "月別ユーザー数（有効 / 新規契約 / 解約）",
      "ai_users_series_total": "総ユーザー数",
      "ai_users_series_new": "新規ユーザー",
      "ai_users_series_cancelled": "解約",
      "ai_users_series_active": "有効ユーザー",
      "ai_users_series_new_sub": "新規契約",
      "list_load_failed": "一覧の読み込みに失敗しました",
      "list_request_failed": "一覧リクエストに失敗しました"
    },
    "list": {
      "load_failed": "案件一覧の読み込みに失敗しました",
      "case_key_missing": "案件キーが不足しています",
      "submitter_only_create": "提出者のみ案件を作成できます",
      "case_no": "案件番号",
      "case_name": "案件名",
      "owner": "依頼者",
      "requested_at": "依頼日",
      "requested_from": "依頼日（開始）",
      "requested_to": "依頼日（終了）",
      "priority": "優先度",
      "deadline": "納期",
      "unread": "未読メッセージあり",
      "unread_badge": "未読 {count}",
      "empty": "該当する案件がありません",
      "reset_filters": "条件をクリア",
      "view_switch": "表示切替",
      "view_card": "カード",
      "view_table": "一覧"
    },
    "management": {
      "title": "案件管理",
      "account_issuance": "アカウント発行",
      "account_management": "アカウント管理",
      "contractor_management": "外注先管理",
      "tag_management": "タグ管理",
      "audit_logs": "操作ログ",
      "settings_tab": "設定",
      "furniture_assets": "ライブラリ",
      "furniture_backend_pending": "現在はフロントエンドの画面枠のみです。アップロード・検索・削除はバックエンド連携後に利用できます。",
      "furniture_upload_button": "素材をアップロード",
      "furniture_choose_upload_type": "アップロードする素材タイプを選択",
      "furniture_upload_model": "3Dモデルをアップロード",
      "furniture_upload_model_desc": "階段・家具・造作・照明・設備・家電・小物の GLB モデルをアップロードします",
      "furniture_upload_material": "床材・壁材をアップロード",
      "furniture_upload_material_desc": "床材・壁材などの柄の画像をアップロードします",
      "furniture_back_to_library": "ライブラリに戻る",
      "furniture_upload_title": "3D モデルを登録",
      "furniture_upload_model_tab": "モデルをアップロード",
      "furniture_upload_texture_tab": "床材・壁材をアップロード",
      "furniture_asset_name": "素材名",
      "furniture_select_files": "GLBモデルをここにドロップするか、クリックしてアップロード",
      "furniture_glb_hint": ".glb 形式に対応",
      "furniture_choose_file": "ファイルを選択",
      "furniture_glb_only": ".glb 形式のモデルファイルを選択してください",
      "furniture_one_file_only": "一度に選択できるGLBファイルは1件です",
      "furniture_library_title": "ライブラリ管理",
      "furniture_preview": "プレビュー",
      "furniture_category": "分類",
      "furniture_category_legacy": "旧分類（移行前）",
      "furniture_status": "ステータス",
      "furniture_updated_at": "更新日時",
      "furniture_empty": "素材はまだありません",
      "furniture_load_failed": "ライブラリの読み込みに失敗しました",
      "furniture_detail_title": "素材詳細",
      "furniture_detail_load_failed": "素材詳細の読み込みに失敗しました",
      "furniture_model_preview": "3Dモデルプレビュー",
      "furniture_model_loading": "3Dモデルを読み込んでいます",
      "furniture_model_load_failed": "3Dモデルを読み込めませんでした",
      "furniture_model_rotate_hint": "ドラッグで回転・ホイールで拡大縮小",
      "furniture_preview_image": "プレビュー画像",
      "furniture_top_image": "俯視図",
      "furniture_idempotency_key": "素材ID",
      "furniture_manufacturer": "メーカー",
      "furniture_product_code": "商品コード",
      "furniture_prototype": "プロトタイプ",
      "furniture_prototypes": {
        "items": "家具モデル",
        "material": "マテリアル",
        "holes": "建具",
        "lines": "壁"
      },
      "furniture_type": "タイプ",
      "furniture_rooms": "部屋",
      "furniture_styles": "スタイル",
      "furniture_sort_order": "表示順",
      "furniture_created_at": "作成日時",
      "furniture_preview_path": "プレビュー画像パス",
      "furniture_top_path": "俯視図パス",
      "furniture_model_path": "3Dモデルパス",
      "furniture_texture_path": "ベースカラーテクスチャパス",
      "furniture_normal_path": "法線テクスチャパス",
      "furniture_roughness_path": "ラフネステクスチャパス",
      "furniture_basic_params": "基本パラメータ",
      "furniture_upload_files": "アップロードファイル",
      "furniture_model_file": "GLBモデル",
      "furniture_reading_model": "モデルのサイズを読み取っています",
      "furniture_file_size": "ファイルサイズ",
      "furniture_mesh_count": "メッシュ数",
      "furniture_triangle_count": "三角形数",
      "furniture_runtime_memory": "推定実行時メモリ",
      "furniture_resource_info": "モデルリソース情報",
      "furniture_resource_good": "推奨範囲内です（推奨：10 MB以下、10万三角形以下）。",
      "furniture_resource_acceptable": "利用可能ですが、軽量化すると読み込みが安定します。",
      "furniture_resource_heavy": "モデルが重いため、20 MB以下・25万三角形以下への軽量化を推奨します。",
      "furniture_select_preview": "プレビュー画像を選択またはドロップ",
      "furniture_select_top": "俯視図を選択またはドロップ",
      "furniture_image_hint": "jpg / png / webp / gif、最大50 MB",
      "furniture_asset_information": "素材情報",
      "furniture_dimensions_auto_hint": "長さ・幅・高さはGLBのバウンディングボックスから自動計算されます（単位：mm）。",
      "furniture_additional_info": "追加情報",
      "furniture_additional_info_hint": "備考があれば入力してください（任意）",
      "furniture_size_variants": "サイズ違い",
      "furniture_size_group_hint": "同じ商品の別サイズ（間口違いなど）は同じグループにすると、3D エディタの家具の一覧には 1 つだけ並び、置いた後に属性の「サイズ」で切り替えられます。",
      "furniture_size_group": "グループ",
      "furniture_size_group_placeholder": "選ぶか新しいキーを入力（例：graftekt-island）",
      "furniture_size_label": "サイズ名",
      "furniture_size_label_placeholder": "例：W2300（空欄なら幅から）",
      "furniture_size_group_name": "一覧に出す商品名",
      "furniture_size_group_name_placeholder": "例：アイランドキッチン（空欄なら素材名）",
      "furniture_size_default": "一覧に出すサイズ（代表）にする",
      "furniture_submit_upload": "3D モデルを登録",
      "furniture_required_field": "必須項目です",
      "furniture_glb_read_failed": "GLBモデルを読み取れませんでした。ファイルが正常か確認してください",
      "furniture_image_only": "jpg / jpeg / png / webp / gif 形式の画像を選択してください",
      "furniture_one_image_only": "画像は1項目につき1件のみ選択できます",
      "furniture_wait_for_model": "モデルの読み取りが完了するまでお待ちください",
      "furniture_three_files_required": "GLBモデル、プレビュー画像、俯視図をすべて選択してください",
      "furniture_dimensions_required": "GLBからモデルサイズを取得できませんでした",
      "furniture_upload_failed": "3D モデルの登録に失敗しました",
      "furniture_upload_success": "3D モデルを登録しました",
      "furniture_param_length": "長さ",
      "furniture_param_width": "幅",
      "furniture_param_height": "高さ",
      "furniture_param_elevation": "床からの高さ",
      "furniture_param_mount": "取付け",
      "furniture_mount_auto": "自動（名前から判定）",
      "furniture_mount_floor": "床・家具の上に置く",
      "furniture_mount_ceiling": "天井から吊る",
      "furniture_mount_hint": "天井から吊る照明は、上端を天井（既定 2400mm）に合わせて置きます。自動のときは、名前にペンダント・シャンデリア・シーリングなどを含むものを天井から吊る照明とみなします。",
      "furniture_extra_info": "追加情報",
      "furniture_search_placeholder": "素材名・商品コード・メーカーで検索",
      "furniture_kind_filter": "分類",
      "furniture_class_all": "すべて",
      "furniture_class_stair": "階段",
      "furniture_class_furniture": "家具",
      "furniture_class_builtin": "造作",
      "furniture_class_lighting": "照明",
      "furniture_class_equipment": "設備",
      "furniture_class_appliance": "家電",
      "furniture_class_accessory": "小物",
      "furniture_class_flooring": "床材",
      "furniture_class_wallpaper": "壁材",
      "furniture_class_window": "窓",
      "furniture_class_interiorDoor": "室内ドア",
      "furniture_class_entranceDoor": "玄関ドア",
      "furniture_upload_tab_interiorDoor": "室内ドア",
      "furniture_upload_tab_entranceDoor": "玄関ドア",
      "furniture_upload_interiorDoor": "室内ドアを登録",
      "furniture_upload_entranceDoor": "玄関ドアを登録",
      "furniture_style_filter": "スタイル",
      "furniture_clear_filters": "条件をクリア",
      "furniture_filter_empty": "条件に一致する素材がありません",
      "furniture_kind_all": "すべての種類",
      "furniture_kind_furniture": "家具",
      "furniture_kind_flooring": "床材",
      "furniture_kind_wallpaper": "壁材",
      "furniture_delete": "削除",
      "furniture_delete_confirm_title": "素材の削除",
      "furniture_delete_confirm": "「{name}」を削除しますか？削除するとエディタの素材一覧に表示されなくなります。すでにプランに配置されている場合、その部分は正しく表示されなくなります。",
      "furniture_delete_success": "素材を削除しました",
      "furniture_delete_failed": "素材の削除に失敗しました",
      "furniture_material_upload_title": "床材・壁材をアップロード",
      "furniture_material_detail_title": "床材・壁材詳細",
      "furniture_material_kind": "種類",
      "furniture_upload_tab_furniture": "3D モデル",
      "furniture_upload_tab_flooring": "床材",
      "furniture_upload_tab_wallpaper": "壁材",
      "furniture_upload_flooring": "床材を登録",
      "furniture_upload_flooring_desc": "寸法と色から柄を生成、または画像をアップロード",
      "furniture_upload_wallpaper": "壁材をアップロード",
      "furniture_upload_wallpaper_desc": "柄の画像と実寸を登録",
      "furniture_kind_door": "ドア",
      "furniture_kind_window": "窓",
      "furniture_upload_tab_door": "ドア",
      "furniture_upload_tab_window": "窓",
      "furniture_upload_door": "ドアを登録",
      "furniture_upload_door_desc": "形式・寸法・色から登録（3D の形は寸法から作ります）",
      "furniture_upload_window": "窓を登録",
      "furniture_upload_window_desc": "形式・寸法・色から登録（3D の形は寸法から作ります）",
      "opening_form": "形式",
      "opening_size": "寸法",
      "opening_nominal_width": "有効開口の幅",
      "opening_nominal_height": "有効開口の高さ",
      "opening_head": "有効開口の上端（床から）",
      "opening_hole_hint": "壁の開口 {w} × {h} mm、開口の下端は床から {e} mm",
      "opening_hinge": "吊元",
      "opening_hinge_left": "左",
      "opening_hinge_right": "右",
      "opening_swing": "開き勝手",
      "opening_swing_in": "内開き",
      "opening_swing_out": "外開き",
      "opening_colors": "色",
      "opening_color_frame": "枠・框",
      "opening_color_leaf": "扉",
      "opening_color_casing": "額縁",
      "opening_color_glass": "ガラス",
      "opening_color_handle": "金物",
      "opening_details_kept": "枠・框・額縁などの詳細（{source}）はそのまま保存します。",
      "opening_preview": "プレビュー（室内側から）",
      "opening_kind_code": "建具記号",
      "opening_nominal_code": "呼称",
      "opening_submit": "登録する",
      "opening_saved": "登録しました",
      "opening_updated": "保存しました",
      "opening_save_failed": "保存に失敗しました",
      "opening_name_required": "名称を入力してください",
      "opening_detail_title": "ドア・窓詳細",
      "opening_hole_size": "壁の開口",
      "opening_hole_bottom": "開口の下端（床から）",
      "opening_source": "出典",
      "opening_import_title": "BIM-AI から取り込む",
      "opening_import_desc": "BIM-AI のライブラリのドア・窓をまとめて登録",
      "opening_import_source": "取り込み元",
      "opening_import_bundled": "同梱の {name}（{date} 時点）",
      "opening_import_choose_file": "BIM-AI のライブラリ JSON を選ぶ",
      "opening_import_hint": "BIM-AI の型ごとに 1 件、登録寸法は常用の寸法として登録します。登録済みの商品コードは、内容が変わったものだけ更新します。",
      "opening_import_summary": "ドア {doors} 件・窓 {windows} 件・寸法 {sizes}（新規 {new}・更新 {update}・登録済み {same}）",
      "opening_import_col_kind": "種類",
      "opening_import_col_status": "状態",
      "opening_import_status_new": "新規",
      "opening_import_status_update": "更新",
      "opening_import_status_same": "登録済み",
      "opening_import_status_done": "取り込み済み",
      "opening_import_status_failed": "失敗",
      "opening_import_run": "新規と更新を取り込む（{count} 件）",
      "opening_import_nothing": "取り込むものはありません",
      "opening_import_done": "{count} 件取り込みました",
      "opening_import_failed_count": "{count} 件の取り込みに失敗しました",
      "opening_import_load_failed": "ライブラリのドア・窓を読み込めませんでした",
      "opening_import_empty": "このファイルにはドア・窓がありません",
      "opening_import_file_invalid": "BIM-AI のライブラリ JSON として読めませんでした",
      "opening_sizes": "常用の寸法",
      "opening_sizes_hint_window": "有効開口の幅・高さ・上端（床から）と呼称。先頭が既定で、エディタでは置いた窓の「登録寸法」から選べます。",
      "opening_sizes_hint_door": "有効開口の幅・高さ。先頭が既定で、エディタでは置いたドアの「登録寸法」から選べます。",
      "opening_size_default": "既定",
      "opening_size_make_default": "既定にする",
      "opening_size_add": "寸法を追加",
      "opening_sizes_required": "寸法を 1 つ以上入れてください",
      "opening_code_auto": "自動",
      "opening_preview_size": "プレビューの寸法：{size}（行をクリックで切り替え）",
      "opening_plan_preview": "平面",
      "opening_plan_outside": "外",
      "opening_plan_inside": "内",
      "opening_plan_wall": "壁厚 {t} で表示",
      "opening_plan_door_summary": "有効開口 {w}×{h}　壁穴 {hole}　枠見付 {fw}　扉厚 {lt}　額縁 {cw}×{ct}　／ 図は吊元 {hinge}・{swing}で表示（配置時に指定）",
      "opening_jamb_frame_d": "枠見込",
      "opening_jamb_frame_w": "枠見付",
      "opening_jamb_casing_d": "額縁見込",
      "opening_jamb_casing_w": "額縁見付",
      "opening_jamb_casing_step": "レベル差",
      "opening_jamb_frame_pos": "境界位置",
      "opening_jamb_sash_w": "框見付",
      "opening_jamb_sash_d": "框見込",
      "opening_jamb_casing_chiri": "ちり",
      "opening_jamb_auto": "（自動）",
      "opening_sizes_summary": "{first} ほか {count} 件",
      "floor_gen_source": "床材の作り方",
      "floor_gen_source_generate": "寸法と色から生成",
      "floor_gen_source_upload": "画像をアップロード",
      "floor_gen_source_generate_hint": "板や石の寸法と色から、並べても継ぎ目の出ない柄を作ります。「この柄を使う」で柄の画像と実寸が下に入ります。",
      "floor_gen_source_upload_hint": "写真などの柄の画像をアップロードし、画像 1 枚の実寸を入れます。",
      "floor_gen_kind_wood": "木（フローリング）",
      "floor_gen_kind_stone": "石・タイル",
      "floor_gen_kind_cf": "CF（継ぎ目なし）",
      "floor_gen_plank_width": "板の幅",
      "floor_gen_plank_length": "板の長さ",
      "floor_gen_bond": "張り方",
      "floor_gen_bond_random": "乱尺",
      "floor_gen_bond_half": "1/2 ずらし",
      "floor_gen_bond_third": "1/3 ずらし",
      "floor_gen_figure": "木目",
      "floor_gen_figure_straight": "まっすぐ（柾目調）",
      "floor_gen_figure_wavy": "うねり（板目調）",
      "floor_gen_color": "色",
      "floor_gen_vary": "色のばらつき",
      "floor_gen_grain": "木目の強さ",
      "floor_gen_joint": "目地の幅",
      "floor_gen_joint_color": "目地の色",
      "floor_gen_auto": "自動",
      "floor_gen_stone_width": "石の幅",
      "floor_gen_stone_depth": "石の奥行",
      "floor_gen_bond_grid": "芋目地",
      "floor_gen_bond_stagger": "馬目地（1/2 ずらし）",
      "floor_gen_look": "表情",
      "floor_gen_look_marble": "大理石調",
      "floor_gen_look_granite": "御影石調",
      "floor_gen_look_plain": "無地",
      "floor_gen_cf_look": "柄",
      "floor_gen_cf_stone": "石目調",
      "floor_gen_cf_terrazzo": "テラゾー調",
      "floor_gen_pattern": "模様の強さ",
      "floor_gen_repeat": "繰り返し",
      "floor_gen_resolution": "解像度",
      "floor_gen_overall": "全体：画像 1 枚（{w} × {h} mm）を 2 × 2 に並べた様子",
      "floor_gen_closeup": "実寸の拡大（600 × 400 mm）",
      "floor_gen_info": "画像 1 枚 = {w} × {h} mm（{pw} × {ph} px）",
      "floor_gen_reroll": "別のパターン",
      "floor_gen_use": "この柄を使う",
      "floor_gen_generating": "生成中… {percent}%",
      "floor_gen_too_large": "画像が大きすぎます。解像度を下げてください",
      "floor_gen_failed": "床材の生成に失敗しました",
      "floor_gen_used": "柄の画像と実寸を入れました。素材名と商品コードを確認して登録してください",
      "furniture_material_texture": "柄の画像",
      "furniture_material_texture_note": "床・壁に繰り返し貼る柄1枚分の画像です（ベースカラー）。",
      "furniture_select_image": "画像を選択またはドロップ",
      "furniture_edit": "編集",
      "furniture_edit_title": "素材を編集",
      "furniture_current_file": "登録済みのファイル",
      "furniture_replace_file": "差し替え",
      "furniture_cancel_replace": "差し替えを取り消す",
      "furniture_code_locked_hint": "商品コードはプランの中で素材を見分けるIDのため変更できません。",
      "furniture_dimensions_edit_hint": "長さ・幅・高さは直接修正できます。GLBを差し替えると新しいモデルから自動計算されます（単位：mm）。",
      "furniture_preview_follows_texture": "プレビュー画像も新しい柄の画像にする",
      "furniture_preview_same_as_texture": "新しい柄の画像を使用",
      "furniture_edit_success": "素材を更新しました",
      "furniture_edit_failed": "素材の更新に失敗しました",
      "furniture_edit_submit": "保存する",
      "furniture_material_preview_note": "一覧とエディタのサムネイルです。選択しない場合は柄の画像を使います。",
      "furniture_material_tile_size": "柄1枚の実寸",
      "furniture_material_tile_hint": "柄の画像1枚が、床・壁で何mm×何mmに当たるかを入力します。高さは画像の縦横比から自動で入ります（手で変更もできます）。",
      "furniture_material_tile_width": "幅",
      "furniture_material_tile_height": "高さ",
      "furniture_material_tiling": "敷き詰めイメージ",
      "furniture_material_tiling_caption": "3m×3mの範囲に貼ったイメージ",
      "furniture_material_not_set": "未登録",
      "furniture_code_hint": "エディタで素材を見分けるIDです。半角英数字と . _ - が使えます。",
      "furniture_code_invalid": "半角英数字と . _ - だけで入力してください",
      "furniture_material_submit": "床材・壁材を登録",
      "furniture_material_texture_required": "柄の画像を選択してください",
      "furniture_material_upload_success": "床材・壁材を登録しました",
      "settings_drive_label": "案件ファイルの保存先（Google Drive フォルダ）",
      "settings_drive_placeholder": "フォルダのURLまたはIDを入力（空欄で既定の保存先）",
      "settings_drive_hint": "Google Drive のフォルダURL（…/folders/～）を貼り付けるとIDを自動で取り出します。変更後に作成される案件から反映されます。",
      "settings_reply_label": "自動送信メールの返信先アドレス（Reply-To）",
      "settings_reply_placeholder": "例：info@makehouse.co.jp（空欄で既定の返信先）",
      "settings_reply_hint": "Aliyun DirectMail で検証済みのアドレスのみ有効です。",
      "settings_save": "保存",
      "settings_saved": "保存しました",
      "settings_load_failed": "設定を読み込めませんでした",
      "settings_save_failed": "保存できませんでした",
      "settings_slack_label": "Slack 通知（AI real CG フィードバック）",
      "settings_permission_label": "権限データの正規化",
      "settings_permission_export": "現在の権限を保存",
      "settings_permission_restore": "保存した権限に戻す",
      "settings_permission_exported": "{count} 件を書き出しました。実行の前の控えとして保管してください。",
      "settings_permission_restored": "{restored} 件を書き戻しました（変更なし {unchanged} 件）。",
      "settings_permission_restore_confirm": "{exportedAt} 時点の控えから {count} 件を書き戻します。いまの権限は上書きされます。よろしいですか。",
      "settings_permission_bad_file": "権限の控えとして読めないファイルです",
      "settings_permission_dry_run": "試算する",
      "settings_permission_apply": "実行する",
      "settings_permission_hint": "旧モデル（案件ロール1つ）で保存されたアカウントを、新モデル（ロール＋追加能力）へ書き直します。試算は1行も書き込みません。実行の前に必ず試算で差分を確認してください。",
      "settings_permission_summary": "全 {total} 件中 {changed} 件を書き換えます（JSON が壊れていて触れない行: {broken} 件）。",
      "settings_permission_needs_products": "案件依頼を持つのに商品が空のアカウントが {count} 件あります。商品を割り当てるか、依頼権を外してください:",
      "settings_permission_confirm": "{changed} 件のアカウントを書き換えます。よろしいですか。",
      "settings_permission_applied": "{changed} 件を書き換えました。",
      "settings_permission_failed": "権限データの正規化に失敗しました",
      "settings_slack_placeholder": "https://hooks.slack.com/services/…（空欄で通知なし）",
      "settings_slack_hint": "Slack の Incoming Webhook URL を貼り付けると、ユーザーが結果画像にフィードバックを送るたびにそのチャンネルへ通知します。",
      "settings_slack_case_label": "案件の Slack スレッド",
      "settings_slack_case_token": "bot トークン",
      "settings_slack_case_channel": "チャンネル ID",
      "settings_slack_case_group": "担当者がいないときに @ するグループ ID",
      "settings_slack_case_hint": "新しい案件でこのチャンネルに「工務店_案件名」のスレッドを立て、案件ページと案件フォルダのリンクを送って、いまの段階の担当者（いなければこのグループ。空なら生産設計）を @ します。依頼者が案件チャットに書いたメッセージもこのスレッドへ転送します。bot には chat:write と users:read.email の権限が要り、チャンネルに招待しておいてください。トークンかチャンネルが空なら何もしません。",
      "settings_slack_case_clear_token": "トークンを消す",
      "settings_office_label": "Make House Village（Office）連携",
      "settings_office_url": "Office の URL",
      "settings_office_token": "bot トークン",
      "settings_office_token_placeholder": "Office サーバーの bot_token.txt の値",
      "settings_office_tpl_online": "テンプレート名：基本設計（オンライン設計）",
      "settings_office_tpl_semi": "テンプレート名：基本設計（セミオーダー）",
      "settings_office_tpl_application": "テンプレート名：申請サポート",
      "settings_office_tpl_structure_calc": "構造計算のテンプレート",
      "settings_office_hint": "設定すると、案件依頼が入ったときに Office の設計・エンジニアリング事業部へ「加盟店名＋工事名称」のプロジェクトを自動作成します（申請サポートの段階に進むと別プロジェクト）。見積書発行時に予定売上を更新します。URL を空にすると連携しません。テンプレート名が空の場合は同じ種類の最初のテンプレートを使います。構造計算の依頼は D（構造計算）で作成し、テンプレートが空なら「構造計算」を使います。",
      "settings_ai_real_cg_title": "AI real CG 利用量（新規発行アカウントの既定値）",
      "settings_quota_image": "画像生成",
      "settings_quota_video": "動画生成",
      "settings_quota_upscale": "高解像度化ダウンロード",
      "settings_ai_real_cg_hint": "-1＝無制限、0＝利用不可、1 以上＝週次上限。ここで発行した新しいアカウントに適用されます。既存アカウントは個別に調整してください。",
      "settings_image3d_label": "画像→3D 生成 API",
      "settings_image3d_provider": "サービス",
      "settings_image3d_key": "API キー",
      "settings_image3d_key_placeholder": "空欄のままなら 3D 生成を呼び出しません",
      "settings_image3d_model": "モデル名（任意）",
      "settings_image3d_model_placeholder": "空欄なら各サービスの既定モデル",
      "settings_image3d_hint": "生成画像内のオブジェクトを選んで回転させる機能で使います。キーはサービスごとに保存されるので、切り替えても前のキーは消えません。",
      "settings_openrouter_label": "AI モデル（OpenRouter）",
      "settings_openrouter_key": "API キー（全機能共通）",
      "settings_openrouter_key_placeholder": "sk-or-v1-…",
      "settings_openrouter_key_set": "設定済み（末尾 {tail}）。変えるときだけ入力",
      "settings_openrouter_key_hint": "レンダリング・超解像・動画・AI アシスタント・図面読み取り・家具の 3D 化・S-AI の応答は、すべてこのキーで OpenRouter を呼びます。保存した瞬間から効きます（再起動は不要）。",
      "settings_openrouter_key_source_env": "現在はサーバーの環境変数のキーで動いています。ここに入れると、そちらより優先されます。",
      "settings_openrouter_key_source_legacy": "現在は以前の S-AI 用に入れたキーで動いています。",
      "settings_openrouter_clear_key": "保存するときにキーを消す",
      "settings_openrouter_models": "機能ごとのモデル",
      "settings_openrouter_refresh_models": "モデル一覧を取り直す",
      "settings_openrouter_models_hint": "空なら薄く表示されている既定のモデルを使います。候補は OpenRouter の一覧から機能に合う種類だけに絞っています。一覧に無いモデルは名前を打ち込んで Enter で指定できます（vendor/model の形）。",
      "settings_openrouter_models_load_failed": "OpenRouter のモデル一覧を取得できませんでした。モデル名は手入力できます。",
      "settings_openrouter_feature_exterior": "外観レンダリング",
      "settings_openrouter_feature_interior": "内観レンダリング",
      "settings_openrouter_feature_render3d": "3D レンダリング（俯瞰カメラ）",
      "settings_openrouter_feature_upscale": "超解像",
      "settings_openrouter_feature_video": "動画",
      "settings_openrouter_feature_assistant": "AI アシスタント（問答）",
      "settings_openrouter_feature_drawingVectorize": "図面の読み取り（3D・S-AI 概算積算）",
      "settings_openrouter_feature_objectSegment": "家具の 3D 化：切り出し（視覚モデル）",
      "settings_openrouter_feature_objectImage": "家具の 3D 化：描き直し・穴埋め（出図モデル）",
      "settings_openrouter_feature_sai": "S-AI の AI 応答",
      "settings_openrouter_feature_saiConsult": "S-AI ホームの AI（相談・成果物づくり、道具を使えるモデル）",
      "settings_openrouter_feature_saiConsultFile": "S-AI ホームの AI：添付の画像・スキャンの読み取り",
      "settings_openrouter_feature_bimaiAgent": "S-AI 概算積算：モデルの AI 修正",
      "settings_openrouter_feature_estimateSheet": "S-AI 概算積算：見積書の読み取り（プラン比較）",
      "account_management_sub": "アカウントを検索し、案件ロール / 商品権限を調整します。編集可否は権限により異なります。",
      "search_account_placeholder": "ユーザー名 / 氏名 / 会社 / 住所 / メールで検索",
      "user_type": "ユーザータイプ",
      "case_role": "案件ロール",
      "product_permission": "商品権限",
      "search": "検索",
      "reset": "リセット",
      "normal_user": "一般ユーザー",
      "platform_admin": "最高プラットフォーム管理者",
      "mh_member": "MH社員",
      "mh_partner": "MHパートナー",
      "no_case_role": "案件ロールなし",
      "capability_filter": "追加権限",
      "capability_render_on": "AI real CG 利用あり",
      "capability_render_off": "AI real CG 利用停止",
      "capability_manage_products": "商品管理あり",
      "capability_manage_render": "AI real CG 管理あり",
      "capability_request_structure_calc": "構造計算依頼あり",
      "submitter": "BS加盟店",
      "doer": "担当者",
      "case_admin": "Case管理者",
      "all_products": "すべての商品",
      "no_product_unset": "商品なし / 未設定",
      "no_product": "なし",
      "not_set": "未設定",
      "username": "ユーザー名",
      "name": "氏名",
      "company": "会社",
      "address": "住所",
      "email": "メール",
      "calendar_email": "Google address",
      "account_status": "アカウントステータス",
      "subscription_status": "サブスクリプション状態",
      "password": "パスワード",
      "subscription_start_date": "サブスクリプション開始日",
      "registered_at": "登録日時",
      "password_hidden_hint": "クリックで表示",
      "product_scope": "商品権限",
      "actions": "操作",
      "role": "ロール",
      "product": "商品",
      "notification_email": "通知メール",
      "edit_case_role": "案件ロールを編集",
      "edit_product_scope": "商品権限を編集",
      "preset_new_user": "新規ユーザー",
      "preset_hint_new_user": "Lv1 一般ユーザー。AI real CG も案件も無し。追加能力で案件依頼だけ付けることもできます。",
      "generate_password": "ランダム生成",
      "generated_password_hint": "生成されたパスワード（発行後に本人へ安全に共有してください）：",
      "platform_admin_only": "プラットフォーム管理はプラットフォーム管理者のみ発行できます",
      "csv_role_hint": "accountType 列にはロールキーを入力します：RENDER_USER / SUBMITTER / MH_MEMBER / MH_PARTNER / DOER / CASE_ADMIN / PLATFORM_ADMIN（旧形式の user / doer も可）。availableItem は SUBMITTER のときだけ有効です。",
      "permission": "権限",
      "permission_preset": "ロール",
      "edit_permission": "権限を編集",
      "addons": "追加能力",
      "addons_hint": "AI real CG利用 / AI real CG管理はAI real CG管理者、商品管理は案件管理者が変更できます。変更権限のない項目は保存時に無視されます。",
      "addon_render_access": "AI real CG利用",
      "addon_manage_products": "商品管理",
      "addon_manage_render": "AI real CG管理",
      "addon_case_request": "案件依頼",
      "addon_case_doer": "案件担当",
      "addon_case_manage": "案件管理",
      "addon_manage_users": "ユーザー管理",
      "addon_request_structure_calc": "構造計算依頼",
      "addon_render_off": "AI real CG停止中",
      "viewer": "閲覧者",
      "permission_updated": "権限を更新しました",
      "preset_render_user": "AI real CGユーザー",
      "preset_submitter": "BS加盟店",
      "preset_mh_member": "MH社員",
      "preset_mh_partner": "MHパートナー",
      "preset_doer": "案件担当者",
      "preset_case_admin": "案件管理",
      "preset_platform_admin": "プラットフォーム管理",
      "preset_hint_render_user": "Lv2 AI real CG のみ。",
      "preset_hint_submitter": "Lv3 BS加盟店。既定で案件依頼を持ち、表示できる商品を個別に指定します。",
      "preset_hint_mh_member": "Lv5 MH社員。全案件を閲覧＋チャット＋全商品。担当者に指名されると操作もできます。",
      "preset_hint_doer": "AI real CG＋案件 DOER（担当者）＋全商品。",
      "preset_hint_case_admin": "AI real CG＋案件 ADMIN＋全商品。アカウントの権限を管理できます。",
      "preset_hint_mh_partner": "Lv4 MHパートナー。担当に割り当てられた案件だけ（案件担当が既定で付く）＋指定した商品だけ。",
      "preset_hint_platform_admin": "Lv6 全権限。プラットフォーム管理者のみ設定できます。",
      "edit_calendar_email": "Google addressを編集",
      "account": "アカウント",
      "select_role": "ロールを選択",
      "specific_products": "指定商品",
      "select_visible_products": "表示可能商品を選択（未選択=商品なし）",
      "doer_admin_all_products_hint": "担当者 / Case管理者はデフォルトですべての商品が表示されます。選択は不要です。",
      "cancel": "キャンセル",
      "save": "保存",
      "revoke_role": "ロールを取消",
      "calendar_email_placeholder": "空欄の場合はカレンダーイベントを受信しません",
      "calendar_email_hint": "納期アラートなどのカレンダーイベントの実際の受信先 Google address です。空欄の場合、このアカウントはカレンダー受信対象外です。makehouse.co.jp ドメイン外のメールは招待を受信できますが、自動で赤表示されません。",
      "single_create": "単体発行",
      "single_create_desc": "加盟店ユーザーまたは担当者を手入力します",
      "csv_batch_issue": "CSV一括発行",
      "csv_batch_issue_desc": "最大100件のアカウントを一括アップロードして発行します",
      "create_collaboration_account": "アカウント発行",
      "create_collaboration_account_sub": "メールはアカウント識別とHubSpot同期に使用されます。作成時に認証コードは送信されないため、送信前に確認してください。",
      "account_type": "アカウントタイプ",
      "submitter_user": "BS加盟店ユーザー",
      "login_name": "ログイン名",
      "login_name_placeholder": "ログインに使用する一意の識別子。会社メール推奨",
      "company_placeholder": "必須、会社名を入力してください",
      "address_placeholder": "必須、住所を入力してください",
      "email_placeholder": "必須、一意で有効なメールを入力してください",
      "email_login_id_hint": "このメールアドレスがログイン ID になります（ログインはメールアドレスとパスワード）",
      "phone": "電話番号",
      "phone_placeholder": "必須。例：03-1234-5678 / 090-1234-5678 / +81…",
      "initial_password": "初期パスワード",
      "password_placeholder": "12〜20文字、空白文字不可",
      "display_name_placeholder": "任意。担当者アカウントは表示名、工務店アカウントは空欄可",
      "calendar_email_register_placeholder": "任意。担当者は入力推奨、工務店アカウントは空欄可",
      "create_account": "アカウント発行",
      "prepare_csv": "CSVファイルを準備",
      "csv_utf8_hint": "UTF-8エンコードを使用し、テンプレートのヘッダーを変更しないでください",
      "batch_step_1": "テンプレートをダウンロードし、アカウント情報を入力します。",
      "batch_step_2": "メールは必須で、ファイル内で重複しないことを確認してください。",
      "batch_step_3": "アップロード後に発行を確認すると、システムが行ごとに検証して作成します。",
      "download_csv_template": "CSVテンプレートをダウンロード",
      "upload_and_issue": "アップロードして発行",
      "csv_file_limit_hint": ".csvファイル対応、最大50 MB、最大100行",
      "csv_drop_text": "CSVファイルをここにドラッグ、または",
      "click_select": "クリックして選択",
      "keep_one_file": "発行待ちファイルは1つのみ保持します",
      "csv_preview": "CSV内容プレビュー",
      "account_records": "件のアカウントレコード",
      "reselect_file": "ファイルを再選択",
      "csv_preview_failed": "CSVをプレビューできません",
      "row_number": "番号",
      "type": "タイプ",
      "precheck": "事前チェック",
      "format_ok": "形式正常",
      "confirm_batch_issue": "一括発行を確認",
      "issue_result": "発行結果",
      "issue_result_sub": "成功したアカウントは初期化され、HubSpot同期が開始されました",
      "export_failed_rows": "失敗レコードを出力",
      "total": "合計",
      "success": "成功",
      "failed": "失敗",
      "csv_row": "CSV行",
      "result": "結果",
      "process_result": "処理結果",
      "contractor_sub": "外注登録時は、ここで管理する有効な外注先リストから選択します",
      "batch_add": "一括追加",
      "add_contractor": "外注先追加",
      "contractor_search_placeholder": "外注先名で検索",
      "no_contractors": "外注先はありません",
      "contractor_name": "外注先名",
      "delete": "削除",
      "add": "追加",
      "contractor_name_placeholder": "外注先名を入力してください",
      "contractor_csv_batch_add": "CSVで外注先を一括追加",
      "csv_selected": "CSV選択済み",
      "contractor_csv_hint": "ヘッダーは contractorName のみ、1行に1つの外注先名",
      "download_template": "テンプレートをダウンロード",
      "select_csv": "CSVを選択",
      "contractor_records": "件の外注先レコード",
      "select_csv_to_preview": "CSV選択後に事前チェック結果を表示します",
      "select_csv_first": "先にCSVファイルを選択してください",
      "close": "閉じる",
      "empty_name": "空の名称",
      "create_failed": "作成に失敗しました",
      "success_failed_count": "成功 {success} 件、失敗 {failure} 件",
      "row_failure": "第 {row} 行：{name}、{message}",
      "existing_tags": "既存タグ",
      "tags_sub": "タグテキスト変更後は自動保存されます。タイプは変更できません。",
      "add_tag": "タグを追加",
      "tag_count": "{count} 件のタグ",
      "adjust_order": "並び順を調整",
      "no_tags": "タグはありません",
      "deleted_tags": "削除済みタグ",
      "no_deleted_tags": "削除済みのタグはありません",
      "cover": "カバー",
      "uploading": "アップロード中",
      "click_upload": "クリックしてアップロード",
      "tag_text": "タグテキスト",
      "view_count": "閲覧数",
      "status": "ステータス",
      "deleted": "削除済み",
      "normal": "正常",
      "restore": "復元",
      "tag_type": "タグタイプ",
      "product_tag": "商品タグ",
      "material_tag": "資料タグ",
      "custom_tag": "カスタムタグ",
      "product_tag_hint": "商品タグは商品権限、左側商品一覧、資料アップロードの商品帰属に表示されます。",
      "tag_text_placeholder": "例：申請資料 / 構造図 / 画像",
      "product_cover": "商品カバー",
      "product_cover_preview_alt": "商品カバープレビュー",
      "upload_product_cover": "商品カバーをアップロード",
      "cover_upload_hint": "この領域をクリックして JPG / PNG / WEBP / GIF を選択",
      "no_sortable_tags": "並び替え可能なタグはありません",
      "save_order": "並び順を保存",
      "adjust_product_order": "商品タグの並び順を調整",
      "adjust_material_order": "資料タグの並び順を調整",
      "adjust_tag_order": "タグの並び順を調整",
      "start_date": "開始日",
      "end_date": "終了日",
      "event_type": "イベントタイプ",
      "result_all": "結果（すべて）",
      "actor_fuzzy": "操作者（あいまい）",
      "case_account_keyword": "案件/アカウントキーワード",
      "query": "検索",
      "audit_sub": "案件フローとアカウント発行関連の監査レコードをデフォルト表示します",
      "no_logs": "ログはありません。条件を調整してください",
      "time": "時間",
      "operation_type": "操作タイプ",
      "actor": "操作者",
      "target_info": "対象情報",
      "stage_subtask": "段階/サブタスク",
      "failure_reason": "失敗理由",
      "detail": "詳細",
      "view": "表示",
      "log_detail": "ログ詳細",
      "no_extra_info": "拡張情報なし",
      "event_category": "イベント分類",
      "audit_category_login": "ログインイベント",
      "audit_category_render": "レンダリングイベント",
      "audit_category_admin_product": "管理システム商品リストイベント",
      "audit_category_admin_management": "管理システム管理イベント",
      "audit_category_admin_case": "管理システム案件イベント",
      "audit_category_unknown": "未分類イベント",
      "audit_event_login": "ログイン",
      "audit_event_create_render_project": "AIrealCGプロジェクト作成",
      "audit_event_generate_interior_render_image": "内観画像生成",
      "audit_event_generate_floorplan_render_image": "平面図生成",
      "audit_event_generate_facade_render_image": "外観画像生成",
      "audit_event_upscale_render_image": "アップスケール",
      "audit_event_generate_render_video": "動画生成",
      "audit_event_create_case_account": "アカウント発行",
      "audit_event_batch_create_case_accounts": "アカウント一括発行",
      "audit_event_create_case": "新規案件依頼",
      "audit_event_assign_case_subtask": "サブタスク割り当て",
      "audit_event_set_case_stage_assignees": "段階の担当者変更",
      "audit_event_complete_subtask": "サブタスク完了",
      "audit_event_record_subtask_outsource": "外注登録",
      "audit_event_update_subtask_outsource": "外注更新",
      "audit_event_approve_subtask_outsource": "外注承認",
      "audit_event_reject_subtask_outsource": "外注却下",
      "audit_event_generate_case_quotation": "見積書作成",
      "audit_event_update_case_quotation": "見積書修正",
      "audit_event_close_case": "案件クローズ",
      "audit_event_delete_case": "案件削除",
      "audit_event_update_case_contact_email": "依頼者のメールアドレス変更",
      "audit_event_update_case_request_info": "依頼情報の変更",
      "audit_event_update_case_stage_schedule": "段階日程の変更",
      "audit_event_confirm_case_current_stage_completed": "検収完了",
      "audit_event_submit_case_product_request_feedback": "チェックバック送信",
      "audit_event_save_case_stage_transition_draft": "次フェーズ依頼下書き保存",
      "audit_event_submit_case_stage_transition": "次フェーズ依頼送信",
      "audit_event_confirm_case_started": "着手",
      "audit_event_confirm_product_requesting": "案件納品",
      "audit_event_confirm_case_complete": "案件完成",
      "audit_event_update_case_cover": "案件カバー更新",
      "audit_event_download_case_quotation_pdf": "見積書PDFダウンロード",
      "audit_event_download_case_delivery_note_pdf": "納品書PDFダウンロード",
      "audit_event_download_case_request_form_pdf": "請求書PDFダウンロード",
      "audit_event_upload_case_attachment": "案件添付ファイルアップロード",
      "audit_event_delete_case_attachment": "案件添付ファイル削除",
      "audit_event_create_case_attachment_folder": "依頼資料フォルダ作成",
      "audit_event_delete_case_attachment_folder": "依頼資料フォルダ削除",
      "audit_event_upload_case_deliverable": "成果物アップロード",
      "audit_event_delete_case_deliverable": "成果物削除",
      "audit_event_create_case_deliverable_folder": "成果物フォルダ作成",
      "audit_event_delete_case_deliverable_folder": "成果物フォルダ削除",
      "audit_event_download_case_file": "案件ファイルダウンロード",
      "audit_event_upload_product_catalog_file": "商品追加",
      "audit_event_update_product_catalog_file": "商品編集",
      "audit_event_replace_product_catalog_file": "商品ファイル差替",
      "audit_event_delete_product_catalog_file": "商品削除",
      "audit_event_open_product_catalog_file_detail": "商品詳細表示",
      "audit_event_create_product_catalog_tag": "タグ追加",
      "audit_event_update_product_catalog_tag": "タグ編集",
      "audit_event_update_product_catalog_tag_order": "タグ並び順変更",
      "audit_event_update_product_catalog_tag_cover": "タグカバー更新",
      "audit_event_delete_product_catalog_tag": "タグ削除",
      "audit_event_restore_product_catalog_tag": "タグ復元",
      "audit_event_grant_case_role": "案件ロール付与",
      "audit_event_revoke_case_role": "案件ロール取消",
      "audit_event_update_case_products": "商品権限更新",
      "audit_event_update_calendar_notify_email": "Google address更新",
      "audit_event_update_case_account_profile": "アカウント情報更新",
      "audit_event_create_outsource_contractor": "外注先追加",
      "audit_event_batch_create_outsource_contractors": "外注先一括追加",
      "audit_event_update_outsource_contractor": "外注先編集",
      "audit_event_delete_outsource_contractor": "外注先削除",
      "audit_event_grant_render_access": "レンダリング権限付与",
      "audit_event_revoke_render_access": "レンダリング権限取消",
      "audit_event_grant_manage_products": "商品管理権限付与",
      "audit_event_revoke_manage_products": "商品管理権限取消",
      "audit_stage_basic_design": "基本設計",
      "audit_stage_application": "申請",
      "audit_stage_detail_design": "実施設計",
      "target_account": "アカウント",
      "target_case_id": "案件ID",
      "target_key": "キー",
      "target_assignee": "担当者",
      "target_file": "ファイル",
      "required_account_type": "アカウント種別を選択してください",
      "required_username": "ログイン名を入力してください",
      "required_company": "会社名を入力してください",
      "required_address": "住所を入力してください",
      "required_email": "メールアドレスを入力してください",
      "required_phone": "電話番号を入力してください",
      "phone_invalid": "電話番号の形式が正しくありません（数字 8〜20 桁）",
      "phone_empty": "電話番号が空です",
      "required_password": "初期パスワードを入力してください",
      "email_invalid": "メールアドレスの形式が正しくありません",
      "email_too_long": "メールアドレスは 64 文字までにしてください（ログイン ID になります）",
      "invalid_calendar_email": "Google addressの形式が正しくありません",
      "password_rule": "パスワードは12〜20文字で、空白文字を含めることはできません",
      "account_list_load_failed": "アカウント一覧の読み込みに失敗しました",
      "account_list_load_failed_network": "アカウント一覧の読み込みに失敗しました",
      "account_profile_saved": "アカウント情報を自動保存しました",
      "account_profile_save_failed": "アカウント情報の保存に失敗しました",
      "account_profile_save_failed_network": "アカウント情報の保存に失敗しました",
      "role_updated": "案件ロールを更新しました",
      "update_failed": "更新に失敗しました",
      "update_failed_network": "更新に失敗しました",
      "role_revoked": "案件ロールを解除しました",
      "revoke_failed": "解除に失敗しました",
      "revoke_failed_network": "解除に失敗しました",
      "product_scope_updated": "商品権限を更新しました",
      "calendar_email_updated": "Google addressを更新しました",
      "invalid_product_uuid": "商品UUIDが無効です：{items}",
      "contractor_list_load_failed": "外注先一覧の読み込みに失敗しました",
      "csv_only": ".csv ファイルのみ対応しています",
      "one_csv_only": "CSVファイルは一度に1件のみアップロードできます。先に現在のファイルをクリアしてください",
      "csv_header_must_be": "CSVヘッダーは次の通りにしてください：{headers}",
      "contractor_csv_empty": "CSVに外注先レコードがありません",
      "contractor_csv_max": "CSVは外注先レコード500件までです",
      "invalid_column_count": "列数が正しくありません",
      "contractor_name_empty": "外注先名を入力してください",
      "contractor_name_too_long": "外注先名は128文字以内で入力してください",
      "csv_name_duplicate": "CSV内で名称が重複しています",
      "csv_parse_failed": "CSVファイルの解析に失敗しました",
      "csv_precheck_failed_fix": "CSVファイルを確認してください",
      "contractor_csv_max_warning": "一度に追加できる外注先は500件までです",
      "batch_add_done": "一括追加が完了しました：成功 {success} 件、失敗 {failed} 件",
      "batch_add_success": "一括追加に成功しました。外注先を {success} 件作成しました",
      "batch_add_failed": "一括追加に失敗しました",
      "batch_add_failed_network": "一括追加に失敗しました",
      "contractor_name_required": "外注先名を入力してください",
      "create_success": "作成しました",
      "save_success": "保存しました",
      "save_failed": "保存に失敗しました",
      "delete_success": "削除しました",
      "delete_failed": "削除に失敗しました",
      "confirm_delete_contractor": "外注先「{name}」を削除しますか？過去の外注記録は保持されます。",
      "confirm_delete": "削除確認",
      "tag_list_load_failed": "タグ一覧の読み込みに失敗しました",
      "tag_view_count_load_failed": "タグ閲覧数の読み込みに失敗しました",
      "tag_view_count_loaded": "タグ閲覧数を検索しました",
      "query_view_count": "閲覧数検索",
      "tag_text_required": "タグテキストを入力してください",
      "cover_required": "商品カバーをアップロードしてください",
      "tag_added": "タグを追加しました",
      "tag_add_failed": "タグの追加に失敗しました",
      "tag_add_failed_network": "タグの追加に失敗しました",
      "confirm_delete_tag": "タグ「{name}」を削除しますか？削除したタグは一覧に表示されなくなり、「削除済みタグ」にチェックを入れるといつでも復元できます。",
      "confirm_restore_tag": "タグ「{name}」を復元しますか？復元後、このタグは再び利用可能として表示されます。",
      "tag_delete_success": "削除しました",
      "tag_restore_success": "復元しました",
      "tag_restore_failed": "復元に失敗しました",
      "tag_order_saved": "タグの並び順を保存しました",
      "tag_order_save_failed": "タグの並び順の保存に失敗しました",
      "tag_order_save_failed_network": "タグの並び順の保存に失敗しました",
      "cover_type_warning": "カバー画像は JPG、PNG、WEBP、GIF のみ対応しています",
      "cover_updated": "カバーを更新しました",
      "cover_update_failed": "カバーの更新に失敗しました",
      "cover_update_failed_network": "カバーの更新に失敗しました",
      "tag_text_empty": "タグテキストを空にできません",
      "tag_saved": "タグを自動保存しました",
      "tag_save_failed": "タグの保存に失敗しました",
      "tag_save_failed_network": "タグの保存に失敗しました",
      "audit_query_failed": "操作ログの検索に失敗しました",
      "audit_request_failed": "操作ログの取得に失敗しました。時間をおいて再度お試しいただくか、管理者にお問い合わせください",
      "export_csv": "CSVエクスポート",
      "exporting_csv": "エクスポート中...",
      "export_csv_failed": "CSVエクスポートに失敗しました",
      "file_read_failed": "ファイルの読み込みに失敗しました",
      "csv_unclosed_quote": "CSVに閉じられていないダブルクォートがあります",
      "account_csv_empty": "CSVにアカウントレコードがありません",
      "account_csv_max": "CSVはアカウントレコード100件までです",
      "invalid_account_type": "アカウント種別が無効です",
      "invalid_product_code": "商品コードが無効です",
      "username_empty": "ログイン名が空です",
      "username_duplicate": "ログイン名が重複しています",
      "company_empty": "会社名が空です",
      "address_empty": "住所が空です",
      "email_empty": "メールアドレスが空です",
      "email_duplicate": "メールアドレスが重複しています",
      "password_invalid": "パスワード形式が正しくありません",
      "confirm_batch_issue_message": "プレビュー内の {count} 件のアカウントを行ごとに作成します。一部の行が失敗しても、他の有効なアカウントは発行を続行します。CSV内のメールアドレスを確認してください。",
      "confirm_issue": "発行する",
      "batch_issue_done": "一括発行が完了しました：成功 {success} 件、失敗 {failed} 件",
      "batch_issue_success": "一括発行に成功しました。アカウントを {success} 件作成しました",
      "batch_issue_failed": "一括発行に失敗しました",
      "batch_issue_request_failed": "一括発行リクエストに失敗しました。ファイル内容またはバックエンドサービスを確認してください",
      "account_create_success": "アカウントを作成しました",
      "register_failed": "登録に失敗しました",
      "account_create_request_failed": "アカウント作成リクエストに失敗しました。バックエンドサービスを確認してください"
    },
    "catalog": {
      "upload_material": "商品追加",
      "search_placeholder": "商品名を検索",
      "image_size": "画像サイズ",
      "size_small": "小",
      "size_medium": "中",
      "size_large": "大",
      "custom_tags": "カスタムタグ",
      "clear": "クリア",
      "no_custom_tags": "カスタムタグはありません",
      "preview": "プレビュー",
      "edit": "編集",
      "delete": "削除",
      "no_materials": "資料はありません",
      "edit_material": "商品編集",
      "material_title": "商品タイトル",
      "title_placeholder": "画面に表示するタイトルを入力してください",
      "material_file": "商品ファイル",
      "drop_title": "クリックまたはドラッグしてファイルを追加",
      "drop_sub": "一度にアップロードできるファイルは1件です",
      "remove": "削除",
      "product_tags": "商品タグ",
      "no_product_tags": "商品タグはありません",
      "material_tags": "資料タグ",
      "no_material_tags": "資料タグはありません",
      "cancel": "キャンセル",
      "save_material": "商品を保存",
      "material_tag": "資料タグ",
      "product_library": "商品資料ライブラリ",
      "breadcrumb_root": "Makehouseデータベース",
      "breadcrumb_product": "Makehouseデータベース > 商品：{product}",
      "breadcrumb_material_tag": "Makehouseデータベース > 資料タグ：{tag}",
      "tag_load_failed": "タグ一覧の読み込みに失敗しました",
      "material_load_failed": "資料の読み込みに失敗しました",
      "type_image": "画像",
      "type_html": "ウェブページ",
      "type_material": "資料",
      "no_manage_permission": "現在のアカウントには資料管理権限がありません",
      "one_file_warning": "選択できるファイルは1件のみです。現在のファイルを先に削除してください",
      "title_required": "資料タイトルを入力してください",
      "product_tag_required": "商品タグを1件以上選択してください",
      "tag_required": "タグを1件以上選択してください",
      "file_required": "ファイルを選択してください",
      "save_success": "保存しました",
      "save_failed": "保存に失敗しました",
      "confirm_delete_message": "商品「{title}」を削除しますか？",
      "delete_material": "商品削除",
      "delete_success": "削除しました",
      "delete_failed": "削除に失敗しました",
      "download_failed": "ダウンロードに失敗しました",
      "file_download_failed": "ファイルのダウンロードに失敗しました",
      "pdf_preview": "PDFプレビュー",
      "unsupported_preview": "このファイルタイプはオンラインプレビューに対応していません",
      "file_size": "ファイルサイズ",
      "registered_at": "登録日",
      "belonging_product": "所属商品",
      "related_tags": "関連タグ",
      "download_file": "ファイルをダウンロード",
      "replace_file": "ファイルを差替",
      "replace_file_confirm_message": "差し替えてよろしいでしょうか",
      "replace_success": "ファイルを差し替えました",
      "replace_failed": "ファイルの差替に失敗しました",
      "type_image_material": "画像資料",
      "type_pdf_material": "PDF資料",
      "type_html_material": "HTML資料",
      "type_file_material": "資料ファイル",
      "type_word_material": "Word資料",
      "type_zip_material": "ZIP資料",
      "type_video_material": "動画資料",
      "zip_entry_count": "{count} 件",
      "zip_filter_placeholder": "ファイル名で絞り込み",
      "zip_truncated": "件数が多いため、先頭 {count} 件のみ表示しています",
      "zip_empty": "この ZIP は空です",
      "zip_no_match": "該当するファイルがありません",
      "select_files": "選択してダウンロード",
      "exit_select": "選択を終了",
      "selected_count": "{count} 件選択中",
      "select_hint": "カードをクリックして選択（最大 {max} 件）",
      "select_all_page": "このページを全選択",
      "clear_selection": "選択解除",
      "download_selected": "まとめてダウンロード",
      "batch_download_limit": "一度にダウンロードできるのは {max} 件までです",
      "batch_download_failed": "まとめてダウンロードに失敗しました",
      "batch_download_success": "{count} 件を ZIP でダウンロードしました",
      "word_converting": "Word を PDF に変換しています（初回は少し時間がかかります）",
      "html_preview_loading": "HTMLプレビューを読み込み中…",
      "preview_load_failed": "プレビューの読み込みに失敗しました",
      "preview_too_large": "ファイルサイズが大きいためオンラインプレビューできません。ダウンロードしてご確認ください",
      "excel_preview_truncated": "先頭 {rows} 行のみ表示しています。全体はファイルをダウンロードしてご確認ください",
      "invalid_file_info": "ファイル情報が無効です"
    },
    "gantt": {
      "title": "段階ガントチャート",
      "empty": "段階スケジュールはありません",
      "basic_design": "基本設計",
      "application": "確認申請",
      "detail_design": "実施設計",
      "structure_calc": "構造計算",
      "unscheduled": "未スケジュール",
      "edit": "日程を編集",
      "edit_title": "段階の日程を編集",
      "edit_hint": "クリックして日程を編集",
      "start_date": "開始日",
      "end_date": "終了日",
      "save": "保存",
      "saved": "日程を保存しました",
      "date_required": "開始日と終了日を入力してください",
      "date_order": "開始日は終了日以前の日付にしてください",
      "start_fill_hint": "見積書を作っても日程は変わりません。日程が空の段階は、開始したときに開始日から 10 日間（構造計算は 14 日間）が入ります。",
      "add_row": "行を追加",
      "row_name_placeholder": "名前（例：現地調査）",
      "move_up": "上へ移動",
      "move_down": "下へ移動",
      "delete_row": "行を削除",
      "name_required": "追加した行の名前を入力してください",
      "name_too_long": "名前は 40 文字以内で入力してください",
      "too_many_rows": "追加できる行は 20 行までです",
      "custom_hint": "追加した行は日程の表示だけで、段階の進行・見積・カレンダーには反映されません。矢印で段階の上や下へ移動できます。"
    },
    "messages": {
      "cover_type_warning": "カバー画像は JPG、PNG、WEBP、GIF のみ対応しています",
      "cover_updated": "カバーを更新しました",
      "cover_update_failed": "カバーの更新に失敗しました",
      "cover_update_failed_network": "カバーの更新に失敗しました",
      "confirm_delete_file": "ファイル「{name}」を削除しますか？",
      "confirm_delete_deliverable": "成果物「{name}」を削除しますか？",
      "confirm_delete_deliverable_folder": "フォルダ{name}を削除しますか？フォルダ内のファイルもごみ箱に移動します。",
      "file_name_wrap": "「{name}」",
      "file_fallback": "ファイル",
      "upload_failed_with_name": "{name}：アップロードに失敗しました",
      "upload_success_count": "{count}件のファイルをアップロードしました",
      "upload_failed_summary": "{count}件のファイルのアップロードに失敗しました：{items}",
      "upload_cancelled": "アップロードをキャンセルしました",
      "quotation_issued": "見積書を発行しました",
      "quotation_updated": "見積書を修正しました",
      "missing_case_id": "案件IDが指定されていません",
      "case_closed": "案件をクローズしました",
      "case_deleted": "案件を削除しました",
      "contact_email_saved": "依頼者のメールアドレスを変更しました",
      "stage_started": "現在のフェーズを開始しました",
      "stage_completed": "現在のフェーズの確認が完了しました",
      "product_feedback_submitted": "フィードバックと修正内容を送信しました",
      "draft_saved": "下書きを保存しました",
      "draft_save_failed": "下書きの保存に失敗しました",
      "transition_submitted": "送信しました。次のフェーズ（資料確認中）へ進みます",
      "product_requesting": "納品・請求フェーズに進みました",
      "project_marked_complete": "案件を完了しました",
      "assignee_assigned": "担当者を割り当てました",
      "stage_assignees_saved": "担当者を保存しました",
      "subtask_completed": "サブタスクを完了しました",
      "outsource_recorded": "外注情報を記録しました",
      "invalid_outsource_review": "外注審査操作が無効です",
      "outsource_approved": "外注情報を承認しました",
      "outsource_rejected": "外注情報を差し戻しました",
      "feedback_title_basic_design": "基本設計段階のフィードバック情報",
      "feedback_title_application": "確認申請段階のフィードバック情報",
      "feedback_title_detail_design": "実施設計段階のフィードバック情報"
    }
  },
  "drawingVectorize": {
    "preview": {
      "replay": "再生し直す",
      "enterEditing": "編集を開始",
      "preparing": "3Dプレビューを準備しています",
      "playing": "建物を生成しています",
      "paused": "プレビューを一時停止しました",
      "completed": "プレビューが完了しました",
      "unavailable": "3Dプレビューを表示できません。2D編集は続行できます"
    }
  }
}
